function numeralFemaleEnding(condition) {
    return condition + "-ші";
}
function numeralMaleEnding(condition) {
    return condition + "-ші";
}
function numeralNeuterEnding(condition) {
    return condition + "-ші";
}
function plural(count, parameters) {
    if (count === 1) {
        return parameters[0];
    }
    return parameters[1];
}
function signed(condition) {
    if (condition === 0) {
        return '0';
    }
    var num = Number.parseFloat(condition.toFixed(2));
    if (condition > 0) {
        return '+' + num.toString();
    }
    return num.toString();
}
function europeanHandicapCondition(condition) {
    if (condition < 0) {
        return "0:" + Math.abs(condition);
    }
    else {
        return Math.abs(condition) + ":0";
    }
}
var bo_b1 = function (match, outcome) { return 'Фора'; };
var bo_c1 = function (match, outcome) { return 'Матч тоталы'; };
var bo_d1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam); };
var bo_e1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam); };
var bo_f1 = function (match, outcome) { return 'Матч тоталының жұп/тақ болуы'; };
var bo_g1 = function (match, outcome) { return "".concat(match.homeTeam, " - ").concat(match.awayTeam); };
var bo_h1 = function (match, outcome) { return "".concat(outcome.teamOne, " - ").concat(outcome.teamTwo); };
var bo_i1 = function (match, outcome) { return "".concat(outcome.teamOne); };
var bo_j1 = function (match, outcome) { return 'Бірінші сеттегі фора'; };
var bo_k1 = function (match, outcome) { return 'Екінші сеттегі фора'; };
var bo_l1 = function (match, outcome) { return 'Үшінші сеттегі фора'; };
var bo_m1 = function (match, outcome) { return 'Бірінші сеттің тоталы'; };
var bo_n1 = function (match, outcome) { return 'Екінші сеттің тоталы'; };
var bo_o1 = function (match, outcome) { return 'Үшінші сеттің тоталы'; };
var bo_p1 = function (match, outcome) { return 'Матчтағы сеттер тоталы'; };
var bo_q1 = function (match, outcome) { return 'Матч есебі'; };
var bo_r1 = function (match, outcome) { return 'Бірінші сет нәтижесі'; };
var bo_s1 = function (match, outcome) { return 'Екінші сет нәтижесі'; };
var bo_t1 = function (match, outcome) { return 'Үшінші сет нәтижесі'; };
var bo_u1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_v1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_w1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_x1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_y1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_z1 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_a2 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_b2 = function (match, outcome) { return "".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_c2 = function (match, outcome) { return "".concat(match.homeTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_d2 = function (match, outcome) { return "".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_e2 = function (match, outcome) { return "".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_f2 = function (match, outcome) { return "".concat(match.awayTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_g2 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?"); };
var bo_h2 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?"); };
var bo_i2 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?"); };
var bo_j2 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_k2 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_l2 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_m2 = function (match, outcome) { return 'Бірінші сеттің 10 ұпайына дейін шағын сеттегі жеңіс'; };
var bo_n2 = function (match, outcome) { return 'Екінші сеттің 10 ұпайына дейін шағын сеттегі жеңіс'; };
var bo_o2 = function (match, outcome) { return 'Үшінші сеттің 10 ұпайына дейін шағын сеттегі жеңіс'; };
var bo_p2 = function (match, outcome) { return 'Бірінші сеттің 10 ұпайына дейін шағын сеттегі фора'; };
var bo_q2 = function (match, outcome) { return 'Екінші сеттің 10 ұпайына дейін шағын сеттегі фора'; };
var bo_r2 = function (match, outcome) { return 'Үшінші сеттің 10 ұпайына дейін шағын сеттегі фора'; };
var bo_s2 = function (match, outcome) { return 'Бірінші сеттің 10 ұпайына дейін шағын сеттегі тотал'; };
var bo_t2 = function (match, outcome) { return 'Екінші сеттің 10 ұпайына дейін шағын сеттегі тотал'; };
var bo_u2 = function (match, outcome) { return 'Үшінші сеттің 10 ұпайына дейін шағын сеттегі тотал'; };
var bo_v2 = function (match, outcome) { return 'Бірінші сеттің 15 ұпайына дейін шағын сеттегі жеңіс'; };
var bo_w2 = function (match, outcome) { return 'Екінші сеттің 15 ұпайына дейін шағын сеттегі жеңіс'; };
var bo_x2 = function (match, outcome) { return 'Үшінші сеттің 15 ұпайына дейін шағын сеттегі жеңіс'; };
var bo_y2 = function (match, outcome) { return 'Бірінші сеттің 15 ұпайына дейін шағын сеттегі фора'; };
var bo_z2 = function (match, outcome) { return 'Екінші сеттің 15 ұпайына дейін шағын сеттегі фора'; };
var bo_a3 = function (match, outcome) { return 'Үшінші сеттің 15 ұпайына дейін шағын сеттегі фора'; };
var bo_b3 = function (match, outcome) { return 'Бірінші сеттің 15 ұпайына дейін шағын сеттегі тотал'; };
var bo_c3 = function (match, outcome) { return 'Екінші сеттің 15 ұпайына дейін шағын сеттегі тотал'; };
var bo_d3 = function (match, outcome) { return 'Үшінші сеттің 15 ұпайына дейін шағын сеттегі тотал'; };
var bo_e3 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430"); };
var bo_f3 = function (match, outcome) { return 'Бірінші таймдағы фора'; };
var bo_g3 = function (match, outcome) { return 'Бірінші тайм нәтижесі'; };
var bo_h3 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430"); };
var bo_i3 = function (match, outcome) { return "\u041A\u0456\u043C ".concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B \u0441\u043E\u0493\u0430\u0434\u044B?"); };
var bo_j3 = function (match, outcome) { return 'Қосарлы нәтиже'; };
var bo_k3 = function (match, outcome) { return 'Бірінші таймның тоталы'; };
var bo_l3 = function (match, outcome) { return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447 \u0442\u043E\u0442\u0430\u043B\u044B ".concat(outcome.condition); };
var bo_m3 = function (match, outcome) { return "".concat(match.homeTeam, " \u0442\u0443\u0440\u0430 ").concat(outcome.condition, " \u0433\u043E\u043B\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_n3 = function (match, outcome) { return "".concat(match.awayTeam, " \u0442\u0443\u0440\u0430 ").concat(outcome.condition, " \u0433\u043E\u043B\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_o3 = function (match, outcome) { return 'Матчтың дәл тоталы'; };
var bo_p3 = function (match, outcome) { return 'Қанша команда соғады'; };
var bo_q3 = function (match, outcome) { return 'Дәл есеп'; };
var bo_r3 = function (match, outcome) { return 'Азиялық фора'; };
var bo_s3 = function (match, outcome) { return 'Бірінші ширектегі фора'; };
var bo_t3 = function (match, outcome) { return 'Екінші ширектегі фора'; };
var bo_u3 = function (match, outcome) { return 'Үшінші ширектегі фора'; };
var bo_v3 = function (match, outcome) { return 'Төртінші ширектегі фора'; };
var bo_w3 = function (match, outcome) { return 'Бірінші ширектiң тоталы'; };
var bo_x3 = function (match, outcome) { return 'Екінші ширектің тоталы'; };
var bo_y3 = function (match, outcome) { return 'Үшінші ширектің тоталы'; };
var bo_z3 = function (match, outcome) { return 'Төртінші ширектің тоталы'; };
var bo_a4 = function (match, outcome) { return 'Бірінші ширек нәтижесі'; };
var bo_b4 = function (match, outcome) { return 'Екінші ширек нәтижесі'; };
var bo_c4 = function (match, outcome) { return 'Үшінші ширек нәтижесі'; };
var bo_d4 = function (match, outcome) { return 'Төртінші ширек нәтижесі'; };
var bo_e4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435"); };
var bo_f4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435"); };
var bo_g4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435"); };
var bo_h4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435"); };
var bo_i4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435"); };
var bo_j4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435"); };
var bo_k4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435"); };
var bo_l4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435"); };
var bo_m4 = function (match, outcome) { return 'Бірінші жартының тоталы'; };
var bo_n4 = function (match, outcome) { return 'Екінші жартыдағы нәтиже'; };
var bo_o4 = function (match, outcome) { return 'Екінші жартының тоталы'; };
var bo_p4 = function (match, outcome) { return 'Бірінші жартыдағы фора'; };
var bo_q4 = function (match, outcome) { return 'Екінші жартыдағы фора'; };
var bo_r4 = function (match, outcome) { return 'Бірінші жартыдағы нәтиже'; };
var bo_s4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u0434\u0430"); };
var bo_t4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0435\u043Ai\u043D\u0448i \u0436\u0430\u0440\u0442\u044B\u0434\u0430"); };
var bo_u4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u0434\u0430"); };
var bo_v4 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0435\u043Ai\u043D\u0448i \u0436\u0430\u0440\u0442\u044B\u0434\u0430"); };
var bo_w4 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B"); };
var bo_x4 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B"); };
var bo_y4 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B"); };
var bo_z4 = function (match, outcome) { return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B"); };
var bo_a5 = function (match, outcome) { return 'Бірінші ширектің дәл тоталы'; };
var bo_b5 = function (match, outcome) { return 'Екінші ширектің дәл тоталы'; };
var bo_c5 = function (match, outcome) { return 'Үшінші ширектің дәл тоталы'; };
var bo_d5 = function (match, outcome) { return 'Төртінші ширектің дәл тоталы'; };
var bo_e5 = function (match, outcome) { return "".concat(match.homeTeam, " \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_f5 = function (match, outcome) { return "".concat(match.awayTeam, " \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_g5 = function (match, outcome) { return 'Өту'; };
var bo_h5 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0430\u0440\u043B\u044B\u049B \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_i5 = function (match, outcome) { return "".concat(match.awayTeam, " \u0431\u0430\u0440\u043B\u044B\u049B \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_j5 = function (match, outcome) { return "".concat(match.homeTeam, " \u0435\u043A\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_k5 = function (match, outcome) { return "".concat(match.awayTeam, " \u0435\u043A\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_l5 = function (match, outcome) { return 'Ең нәтижелі жартылық'; };
var bo_m5 = function (match, outcome) { return 'Ең нәтижелі ширек'; };
var bo_n5 = function (match, outcome) { return 'Ең нәтижелі ширектің тоталы'; };
var bo_o5 = function (match, outcome) { return 'Ең нәтижесіз ширектің тоталы'; };
var bo_p5 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_q5 = function (match, outcome) { return "".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_r5 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_s5 = function (match, outcome) { return "".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u0430 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_t5 = function (match, outcome) { return 'Овертайм бола ма'; };
var bo_u5 = function (match, outcome) { return 'Айырмашылықпен жеңіс'; };
var bo_v5 = function (match, outcome) { return 'Бірінші ширекте айырмашылықпен жеңіс'; };
var bo_w5 = function (match, outcome) { return 'Екінші ширекте айырмашылықпен жеңіс'; };
var bo_x5 = function (match, outcome) { return 'Үшінші ширекте айырмашылықпен жеңіс'; };
var bo_y5 = function (match, outcome) { return 'Төртінші ширекте айырмашылықпен жеңіс'; };
var bo_z5 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(outcome.playerName, " (").concat(match.homeTeam, ")"); };
var bo_a6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(outcome.playerName, " (").concat(match.awayTeam, ")"); };
var bo_b6 = function (match, outcome) { return 'Тотал: 3-ұпайлық лақтырулар'; };
var bo_c6 = function (match, outcome) { return 'Тотал: 2-ұпайлық лақтырулар'; };
var bo_d6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " 3-\u04B1\u043F\u0430\u0439\u043B\u044B\u049B \u043B\u0430\u049B\u0442\u044B\u0440\u0443\u043B\u0430\u0440"); };
var bo_e6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " 3-\u04B1\u043F\u0430\u0439\u043B\u044B\u049B \u043B\u0430\u049B\u0442\u044B\u0440\u0443\u043B\u0430\u0440"); };
var bo_f6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " 2-\u04B1\u043F\u0430\u0439\u043B\u044B\u049B \u043B\u0430\u049B\u0442\u044B\u0440\u0443\u043B\u0430\u0440"); };
var bo_g6 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " 2-\u04B1\u043F\u0430\u0439\u043B\u044B\u049B \u043B\u0430\u049B\u0442\u044B\u0440\u0443\u043B\u0430\u0440"); };
var bo_h6 = function (match, outcome) { return 'Фора 3-ұпайлық лақтырулар'; };
var bo_i6 = function (match, outcome) { return 'Фора 2-ұпайлық лақтырулар'; };
var bo_j6 = function (match, outcome) { return 'Нәтиже по 3-ұпайлық лақтырулар'; };
var bo_k6 = function (match, outcome) { return '2-ұпайлық лақтырулар бойынша нәтиже'; };
var bo_l6 = function (match, outcome) { return 'Ең нәтижесіз ширек'; };
var bo_m6 = function (match, outcome) { return 'Матчта доп беру тоталы'; };
var bo_n6 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u0430 ".concat(match.homeTeam, " \u0434\u043E\u043F \u0431\u0435\u0440\u0443 \u0442\u043E\u0442\u0430\u043B\u044B"); };
var bo_o6 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u0430 ".concat(match.awayTeam, " \u0434\u043E\u043F \u0431\u0435\u0440\u0443 \u0442\u043E\u0442\u0430\u043B\u044B"); };
var bo_p6 = function (match, outcome) { return 'Матчта доп берулерден фора'; };
var bo_q6 = function (match, outcome) { return 'Матчта доп берулерден жеңіс'; };
var bo_r6 = function (match, outcome) { return 'Матчтағы бірінші 2-ұпайлық лақтыру'; };
var bo_s6 = function (match, outcome) { return 'Матчтағы бірінші 3-ұпайлық лақтыру'; };
var bo_t6 = function (match, outcome) { return 'Матчтағы бірінші айыппұл доп'; };
var bo_u6 = function (match, outcome) { return 'Қайсысы ертерек болады'; };
var bo_v6 = function (match, outcome) { return 'Ширектегі ең көп ұпай саны'; };
var bo_w6 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u0430 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']), " \u04B1\u043F\u0430\u0439 \u0430\u043B\u0430\u0434\u044B"); };
var bo_x6 = function (match, outcome) { return 'Матчта трипл-дабл тоталы'; };
var bo_y6 = function (match, outcome) { return 'Матчта дабл-дабл тоталы'; };
var bo_z6 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']), " \u04B1\u043F\u0430\u0439 \u0430\u043B\u0430\u0434\u044B"); };
var bo_a7 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']), " \u04B1\u043F\u0430\u0439 \u0430\u043B\u0430\u0434\u044B"); };
var bo_b7 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456\u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']), " \u04B1\u043F\u0430\u0439 \u0430\u043B\u0430\u0434\u044B"); };
var bo_c7 = function (match, outcome) { return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0448\u0438\u0440\u0435\u043A\u0442\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']), " \u04B1\u043F\u0430\u0439 \u0430\u043B\u0430\u0434\u044B"); };
var bo_d7 = function (match, outcome) { return 'Матчтағы ұпай айырмашылығы'; };
var bo_e7 = function (match, outcome) { return 'Бірінші ширектегі ұпай айырмашылығы'; };
var bo_f7 = function (match, outcome) { return 'Екінші ширектегі ұпай айырмашылығы'; };
var bo_g7 = function (match, outcome) { return 'Үшінші ширектегі ұпай айырмашылығы'; };
var bo_h7 = function (match, outcome) { return 'Төртінші ширектегі ұпай айырмашылығы'; };
var bo_i7 = function (match, outcome) { return 'Бірінші жартылықта фора'; };
var bo_j7 = function (match, outcome) { return 'Екінші жартылықта фора'; };
var bo_k7 = function (match, outcome) { return 'Бірінші жартылық нәтижесі'; };
var bo_l7 = function (match, outcome) { return 'Екінші жартылық нәтижесі'; };
var bo_m7 = function (match, outcome) { return 'Бірінші жартылықтың тоталы'; };
var bo_n7 = function (match, outcome) { return 'Екінші жартылықтың тоталы'; };
var bo_o7 = function (match, outcome) { return 'Бірінші жартылықтың нақты тоталы'; };
var bo_p7 = function (match, outcome) { return 'Овертайм болады ма'; };
var bo_q7 = function (match, outcome) { return 'Бірінші жартылықта айырмашылықпен жеңіс'; };
var bo_r7 = function (match, outcome) { return 'Екінші жартылықта айырмашылықпен жеңіс'; };
var bo_s7 = function (match, outcome) { return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']), " \u0430\u043B\u0430\u0434\u044B"); };
var bo_t7 = function (match, outcome) { return "\u041A\u0456\u043C \u0435\u043A\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']), " \u0430\u043B\u0430\u0434\u044B"); };
var bo_u7 = function (match, outcome) { return 'Матчтың нақты тоталы'; };
var bo_v7 = function (match, outcome) { return "\u041A\u0456\u043C \u043C\u0430\u0442\u0447\u0442\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']), " \u0430\u043B\u0430\u0434\u044B"); };
var bo_w7 = function (match, outcome) { return 'Ең нәтижелі жартылықтың тоталы'; };
var bo_x7 = function (match, outcome) { return 'Ең нәтижесіз жартылықтың тоталы'; };
var bo_y7 = function (match, outcome) { return "".concat(match.homeTeam, " \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u044B\u04A3 \u0435\u043A\u0435\u0443\u0456\u043D \u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_z7 = function (match, outcome) { return "".concat(match.awayTeam, " \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u044B\u04A3 \u0435\u043A\u0435\u0443\u0456\u043D \u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_a8 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u044B \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u044B \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_b8 = function (match, outcome) { return "".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u044B \u0436\u04D9\u043D\u0435 \u043C\u0430\u0442\u0447\u0442\u044B \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_c8 = function (match, outcome) { return 'Тотал: 3-ұпайлық лақтыру'; };
var bo_d8 = function (match, outcome) { return 'Тотал: 2-ұпайлық лақтыру'; };
var bo_e8 = function (match, outcome) { return 'Фора 3-ұпайлық лақтыру'; };
var bo_f8 = function (match, outcome) { return 'Фора 2-ұпайлық лақтыру'; };
var bo_g8 = function (match, outcome) { return '3-ұпайлық лақтыру бойынша нәтиже'; };
var bo_h8 = function (match, outcome) { return '2-ұпайлық лақтыру бойынша нәтиже'; };
var bo_i8 = function (match, outcome) { return 'Матч тоталының жұп/тағы'; };
var bo_j8 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430"); };
var bo_k8 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430"); };
var bo_l8 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430"); };
var bo_m8 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0436\u0430\u0440\u0442\u044B\u043B\u044B\u049B\u0442\u0430"); };
var bo_n8 = function (match, outcome) { return 'Бірінші кезеңнiң тоталы'; };
var bo_o8 = function (match, outcome) { return 'Екінші кезеңнiң тоталы'; };
var bo_p8 = function (match, outcome) { return 'Үшінші кезеңнiң тоталы'; };
var bo_q8 = function (match, outcome) { return 'Бірінші кезең нәтижесі'; };
var bo_r8 = function (match, outcome) { return 'Екінші кезең нәтижесі'; };
var bo_s8 = function (match, outcome) { return 'Үшінші кезең нәтижесі'; };
var bo_t8 = function (match, outcome) { return 'Пенальтиді ескерумен жеңіс'; };
var bo_u8 = function (match, outcome) { return '1айырмашылықпен жеңіс'; };
var bo_v8 = function (match, outcome) { return '2 1айырмашылықпен жеңіс'; };
var bo_w8 = function (match, outcome) { return 'Бірінші кезеңде неше команда соғады?'; };
var bo_x8 = function (match, outcome) { return 'Екінші кезеңде неше команда соғады?'; };
var bo_y8 = function (match, outcome) { return 'Үшінші кезеңде неше команда соғады?'; };
var bo_z8 = function (match, outcome) { return 'Кезең-Матч'; };
var bo_a9 = function (match, outcome) { return 'Овертайм тоталы'; };
var bo_b9 = function (match, outcome) { return 'Оветайм нәтижесі'; };
var bo_c9 = function (match, outcome) { return 'Овертаймдағы фора'; };
var bo_d9 = function (match, outcome) { return 'Бірінші кезеңдегі фора'; };
var bo_e9 = function (match, outcome) { return 'Екінші кезеңдегі фора'; };
var bo_f9 = function (match, outcome) { return 'Үшінші кезеңдегі фора'; };
var bo_g9 = function (match, outcome) { return 'Бірінші кезеңнің нақты есебі'; };
var bo_h9 = function (match, outcome) { return 'Екінші кезеңнің нақты есебі'; };
var bo_i9 = function (match, outcome) { return 'Үшінші кезеңнің нақты есебі'; };
var bo_j9 = function (match, outcome) { return "\u041A\u0456\u043C ".concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B\u0434\u044B \u0441\u0430\u043B\u0430\u0434\u044B?"); };
var bo_k9 = function (match, outcome) { return 'Матчта партиялар бойынша фора'; };
var bo_l9 = function (match, outcome) { return 'Бірінші сеттің дәл тоталы'; };
var bo_m9 = function (match, outcome) { return 'Екінші сеттің дәл тоталы'; };
var bo_n9 = function (match, outcome) { return 'Үшінші сеттің дәл тоталы'; };
var bo_o9 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_p9 = function (match, outcome) { return "".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_q9 = function (match, outcome) { return "".concat(match.homeTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_r9 = function (match, outcome) { return "".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_s9 = function (match, outcome) { return "".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_t9 = function (match, outcome) { return "".concat(match.awayTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_u9 = function (match, outcome) { return 'Бірінші сеттің жұп/тақ болуы'; };
var bo_v9 = function (match, outcome) { return 'Екінші сеттің жұп/тақ болуы'; };
var bo_w9 = function (match, outcome) { return 'Үшінші сеттің жұп/тақ болуы'; };
var bo_x9 = function (match, outcome) { return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B ".concat(outcome.condition); };
var bo_y9 = function (match, outcome) { return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B ".concat(outcome.condition); };
var bo_z9 = function (match, outcome) { return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B ".concat(outcome.condition); };
var bo_a10 = function (match, outcome) { return 'Шағын сетте бірінші сеттің 10 ұпайына дейін жеңіс'; };
var bo_b10 = function (match, outcome) { return 'Шағын сетте екінші сеттің 10 ұпайына дейін жеңіс'; };
var bo_c10 = function (match, outcome) { return 'Шағын сетте бірінші сеттің 10 ұпайына дейін фора'; };
var bo_d10 = function (match, outcome) { return 'Шағын сетте екінші сеттің 10 ұпайына дейін фора'; };
var bo_e10 = function (match, outcome) { return 'Шағын сетте бірінші сеттің 10 ұпайына дейін тотал'; };
var bo_f10 = function (match, outcome) { return 'Шағын сетте екінші сеттің 10 ұпайына дейін тотал'; };
var bo_g10 = function (match, outcome) { return 'Шағын сетте екінші сеттің 15 ұпайына дейін жеңіс'; };
var bo_h10 = function (match, outcome) { return 'Шағын сетте бірінші сеттің 15 ұпайына дейін фора'; };
var bo_i10 = function (match, outcome) { return 'Шағын сетте екінші сеттің 15 ұпайына дейін фора'; };
var bo_j10 = function (match, outcome) { return 'Шағын сетте бірінші сеттің 15 ұпайына дейін тотал'; };
var bo_k10 = function (match, outcome) { return 'Шағын сетте екінші сеттің 15 ұпайына дейін тотал'; };
var bo_l10 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_m10 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_n10 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_o10 = function (match, outcome) { return 'Бірінші сетте айырмашылықпен жеңіс'; };
var bo_p10 = function (match, outcome) { return 'Екінші сетте айырмашылықпен жеңіс'; };
var bo_q10 = function (match, outcome) { return 'Үшінші сетте айырмашылықпен жеңіс'; };
var bo_r10 = function (match, outcome) { return 'Тотал: Бірінші атыс шебіде'; };
var bo_s10 = function (match, outcome) { return 'Тотал: Екінші атыс шебіде'; };
var bo_t10 = function (match, outcome) { return 'Тотал: Үшінші атыс шебіде'; };
var bo_u10 = function (match, outcome) { return 'Тотал: Төртінші атыс шебіде'; };
var bo_v10 = function (match, outcome) { return 'Тотал: Бесінші атыс шебіде'; };
var bo_w10 = function (match, outcome) { return 'Тотал: Алтыншы атыс шебіде'; };
var bo_x10 = function (match, outcome) { return 'Тотал: Жетінші атыс шебіде'; };
var bo_y10 = function (match, outcome) { return 'Тотал: Сегізінші атыс шебіде'; };
var bo_z10 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_a11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_b11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_c11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_d11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_e11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_f11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_g11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0441\u0435\u0433\u0456\u0437\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_h11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_i11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_j11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_k11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_l11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_m11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_n11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_o11 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0441\u0435\u0433\u0456\u0437\u0456\u043D\u0448\u0456 \u0430\u0442\u044B\u0441 \u0448\u0435\u0431\u0456\u0434\u0435"); };
var bo_p11 = function (match, outcome) { return 'Фора: Бірінші атыс шебіде'; };
var bo_q11 = function (match, outcome) { return 'Фора: Екінші атыс шебіде'; };
var bo_r11 = function (match, outcome) { return 'Фора: Үшінші атыс шебіде'; };
var bo_s11 = function (match, outcome) { return 'Фора: Төртінші атыс шебіде'; };
var bo_t11 = function (match, outcome) { return 'Фора: Бесінші атыс шебіде'; };
var bo_u11 = function (match, outcome) { return 'Фора: Алтыншы атыс шебіде'; };
var bo_v11 = function (match, outcome) { return 'Фора: Жетінші атыс шебіде'; };
var bo_w11 = function (match, outcome) { return 'Фора: Сегізінші атыс шебіде'; };
var bo_x11 = function (match, outcome) { return 'Нәтиже: Бірінші атыс шебіде'; };
var bo_y11 = function (match, outcome) { return 'Нәтиже: Екінші атыс шебіде'; };
var bo_z11 = function (match, outcome) { return 'Нәтиже: Үшінші атыс шебіде'; };
var bo_a12 = function (match, outcome) { return 'Нәтиже: Төртінші атыс шебіде'; };
var bo_b12 = function (match, outcome) { return 'Нәтиже: Бесінші атыс шебіде'; };
var bo_c12 = function (match, outcome) { return 'Нәтиже: Алтыншы атыс шебіде'; };
var bo_d12 = function (match, outcome) { return 'Нәтиже: Жетінші атыс шебіде'; };
var bo_e12 = function (match, outcome) { return 'Нәтиже: Сегізінші атыс шебіде'; };
var bo_f12 = function (match, outcome) { return 'Дәл тоталы: Бірінші атыс шебіде'; };
var bo_g12 = function (match, outcome) { return 'Дәл тоталы: Екінші атыс шебіде'; };
var bo_h12 = function (match, outcome) { return 'Дәл тоталы: Үшінші атыс шебіде'; };
var bo_i12 = function (match, outcome) { return 'Дәл тоталы: Төртінші атыс шебіде'; };
var bo_j12 = function (match, outcome) { return 'Дәл тоталы: Бесінші атыс шебіде'; };
var bo_k12 = function (match, outcome) { return 'Дәл тоталы: Алтыншы атыс шебіде'; };
var bo_l12 = function (match, outcome) { return 'Дәл тоталы: Жетінші атыс шебіде'; };
var bo_m12 = function (match, outcome) { return 'Дәл тоталы: Сегізінші атыс шебіде'; };
var bo_n12 = function (match, outcome) { return 'Мерзімнен бұрын женіс болады ма?'; };
var bo_o12 = function (match, outcome) { return 'Жекпе-жекте жеңу тәсілі'; };
var bo_p12 = function (match, outcome) { return 'Жекпе-жекте жеңу'; };
var bo_q12 = function (match, outcome) { return 'Тотал'; };
var bo_r12 = function (match, outcome) { return "\u041A\u0456\u043C ".concat(outcome.condition, " \u0440\u0430\u0443\u043D\u0434\u0442\u044B \u0436\u0435\u04A3\u0435\u0434\u0456?"); };
var bo_s12 = function (match, outcome) { return 'FirstBlood'; };
var bo_t12 = function (match, outcome) { return "FirstBlood ".concat(outcome.condition, " \u0440\u0430\u0443\u043D\u0434\u0442\u0430"); };
var bo_u12 = function (match, outcome) { return "".concat(outcome.condition, " \u043A\u0430\u0440\u0442\u0430\u043D\u044B \u043A\u0456\u043C \u0436\u0435\u04A3\u0435\u0434\u0456?"); };
var bo_v12 = function (match, outcome) { return "FirstBlood ".concat(outcome.condition, " \u043A\u0430\u0440\u0442\u0430\u0434\u0430"); };
var bo_w12 = function (match, outcome) { return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F 1-\u0456\u043D\u0448\u0456 \u043A\u0430\u0440\u0442\u0430\u0434\u0430 ".concat(outcome.condition, " \u04E9\u043B\u0442\u0456\u0440\u0443 \u0436\u0438\u043D\u0430\u0439\u0434\u044B"); };
var bo_x12 = function (match, outcome) { return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F 2-\u043D\u0448\u0456 \u043A\u0430\u0440\u0442\u0430\u0434\u0430 ".concat(outcome.condition, " \u04E9\u043B\u0442\u0456\u0440\u0443 \u0436\u0438\u043D\u0430\u0439\u0434\u044B"); };
var bo_y12 = function (match, outcome) { return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F 3-\u0456\u043D\u0448\u0456 \u043A\u0430\u0440\u0442\u0430\u0434\u0430 ".concat(outcome.condition, " \u04E9\u043B\u0442\u0456\u0440\u0443 \u0436\u0438\u043D\u0430\u0439\u0434\u044B"); };
var bo_z12 = function (match, outcome) { return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F 4-\u0456\u043D\u0448\u0456 \u043A\u0430\u0440\u0442\u0430\u0434\u0430 ".concat(outcome.condition, " \u04E9\u043B\u0442\u0456\u0440\u0443 \u0436\u0438\u043D\u0430\u0439\u0434\u044B"); };
var bo_a13 = function (match, outcome) { return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F 5-\u0456\u043D\u0448\u0456 \u043A\u0430\u0440\u0442\u0430\u0434\u0430 ".concat(outcome.condition, " \u04E9\u043B\u0442\u0456\u0440\u0443 \u0436\u0438\u043D\u0430\u0439\u0434\u044B"); };
var bo_b13 = function (match, outcome) { return 'Матчта нәтиже'; };
var bo_c13 = function (match, outcome) { return '1-інші картада жеңіс'; };
var bo_d13 = function (match, outcome) { return '2-нші картада жеңіс'; };
var bo_e13 = function (match, outcome) { return '3-інші картада жеңіс'; };
var bo_f13 = function (match, outcome) { return '4-інші картада жеңіс'; };
var bo_g13 = function (match, outcome) { return '5-інші картада жеңіс'; };
var bo_h13 = function (match, outcome) { return 'First blood бірінші картада'; };
var bo_i13 = function (match, outcome) { return 'First blood екінші картада'; };
var bo_j13 = function (match, outcome) { return 'First blood үшінші картада'; };
var bo_k13 = function (match, outcome) { return 'First blood төртінші картада'; };
var bo_l13 = function (match, outcome) { return 'First blood бесінші картада'; };
var bo_m13 = function (match, outcome) { return 'Буллиттерді ескерумен жеңіс'; };
var bo_n13 = function (match, outcome) { return "".concat(match.homeTeam, " \u0435\u043A\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0434\u0430 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_o13 = function (match, outcome) { return "".concat(match.awayTeam, " \u0435\u043A\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0434\u0430 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_p13 = function (match, outcome) { return "".concat(outcome.conditionTwo, " \u0436\u04D9\u043D\u0435 \u043E\u0434\u0430\u043D \u043A\u04E9\u043F \u0433\u043E\u043B \u0441\u043E\u0493\u0430\u0442\u044B\u043D \u043A\u043E\u043C\u0430\u043D\u0434\u0430\u043B\u0430\u0440 (\u043E\u043B\u0430\u0440\u0434\u044B\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B)"); };
var bo_q13 = function (match, outcome) { return 'Еі нәтижелі команда (оның тоталы)'; };
var bo_r13 = function (match, outcome) { return 'Ең нәтижелі тайм (тотал)'; };
var bo_s13 = function (match, outcome) { return "\u0415\u043A\u0456 \u0442\u0430\u0439\u043C \u0434\u0430 \u0441\u0430\u043B\u044B\u0441\u0442\u044B\u0440\u0493\u0430\u043D\u0434\u0430 ".concat(outcome.condition, " \u0430\u0437"); };
var bo_t13 = function (match, outcome) { return "\u0415\u043A\u0456 \u0442\u0430\u0439\u043C \u0434\u0430 \u0441\u0430\u043B\u044B\u0441\u0442\u044B\u0440\u0493\u0430\u043D\u0434\u0430 ".concat(outcome.condition, " \u043A\u04E9\u043F"); };
var bo_u13 = function (match, outcome) { return 'Бірінші таймның жұп/тақ болуы'; };
var bo_v13 = function (match, outcome) { return 'Екінші таймның жұп/тақ болуы'; };
var bo_w13 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 ".concat(match.homeTeam, " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?"); };
var bo_x13 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 ".concat(match.homeTeam, " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?"); };
var bo_y13 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 ".concat(match.awayTeam, " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?"); };
var bo_z13 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 ".concat(match.awayTeam, " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?"); };
var bo_a14 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u0430 ".concat(match.homeTeam, " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?"); };
var bo_b14 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u0430 ".concat(match.awayTeam, " \u043D\u0435\u0448\u0435 \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?"); };
var bo_c14 = function (match, outcome) { return 'Ең нәтижесіз  команда (оның тоталы)'; };
var bo_d14 = function (match, outcome) { return "".concat(match.homeTeam, " \u0442\u0435\u043A \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?"); };
var bo_e14 = function (match, outcome) { return "".concat(match.awayTeam, " \u0442\u0435\u043A \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?"); };
var bo_f14 = function (match, outcome) { return "".concat(match.homeTeam, " \u0442\u0435\u043A \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?"); };
var bo_g14 = function (match, outcome) { return "".concat(match.awayTeam, " \u0442\u0435\u043A \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?"); };
var bo_h14 = function (match, outcome) { return 'Қанша команда бірінші таймда соғады'; };
var bo_i14 = function (match, outcome) { return 'Қанша команда екінші таймда соғады'; };
var bo_j14 = function (match, outcome) { return "\u049A\u0430\u043D\u0448\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 ".concat(outcome.condition, " \u0430\u0441\u0430 \u0441\u043E\u0493\u0430\u0434\u044B"); };
var bo_k14 = function (match, outcome) { return 'Бірінші гол қалай салынады?'; };
var bo_l14 = function (match, outcome) { return 'Келесі айналымға шығу'; };
var bo_m14 = function (match, outcome) { return 'Кім алаң ортасынан бастайды?'; };
var bo_n14 = function (match, outcome) { return 'Екі гол қатарынан бір командамен салынады'; };
var bo_o14 = function (match, outcome) { return "".concat(match.homeTeam, " \u0435\u0440\u0456\u043A\u0442\u0456 \u0436\u0435\u04A3\u0456\u0441\u043A\u0435 \u0436\u0435\u0442\u0435\u0434\u0456"); };
var bo_p14 = function (match, outcome) { return "\u041A\u0456\u043C ".concat(numeralFemaleEnding(outcome.condition), " \u0421\u041A \u0430\u043B\u0430\u0434\u044B"); };
var bo_q14 = function (match, outcome) { return "".concat(match.awayTeam, " \u0435\u0440\u0456\u043A\u0442\u0456 \u0436\u0435\u04A3\u0456\u0441\u043A\u0435 \u0436\u0435\u0442\u0435\u0434\u0456"); };
var bo_r14 = function (match, outcome) { return 'Матчта бірінші болып не орын алады?'; };
var bo_s14 = function (match, outcome) { return 'Дубль'; };
var bo_t14 = function (match, outcome) { return 'Хет-трик'; };
var bo_u14 = function (match, outcome) { return "\u041A\u0456\u043C ".concat(numeralMaleEnding(outcome.condition), " \u0431\u04B1\u0440\u044B\u0448\u0442\u0430\u043C\u0430\u043D\u044B \u0431\u0435\u0440\u0435\u0434\u0456?"); };
var bo_v14 = function (match, outcome) { return "\u0422\u0443\u0440\u0430 ".concat(outcome.conditionTwo, " \u0441\u043E\u049B\u049B\u0430\u043D \u043A\u043E\u043C\u0430\u043D\u0434\u0430\u043B\u0430\u0440 (\u043E\u043B\u0430\u0440\u0434\u044B\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B)"); };
var bo_w14 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u0430 \u0442\u0443\u0440\u0430 ".concat(outcome.condition, " \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B \u043C\u0430"); };
var bo_x14 = function (match, outcome) { return 'Соңғы голды кім салады?'; };
var bo_y14 = function (match, outcome) { return 'Автогол'; };
var bo_z14 = function (match, outcome) { return 'Ауыстыруға шыққан ойыншы салады ма?'; };
var bo_a15 = function (match, outcome) { return 'Соңғы гол уақыты'; };
var bo_b15 = function (match, outcome) { return 'Кубок иегері'; };
var bo_c15 = function (match, outcome) { return 'Суперкубок иегері'; };
var bo_d15 = function (match, outcome) { return "\u049A\u0430\u0439 \u0442\u0430\u0439\u043C\u0434\u0430 ".concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B \u0433\u043E\u043B \u0441\u0430\u043B\u044B\u043D\u0430\u0434\u044B?"); };
var bo_e15 = function (match, outcome) { return '1-ден 15 минут аралығында қосарлы нәтиже'; };
var bo_f15 = function (match, outcome) { return '16-дан 30 минут аралығында қосарлы нәтиже'; };
var bo_g15 = function (match, outcome) { return '31 минуттан үзіліске дейін қосарлы нәтиже'; };
var bo_h15 = function (match, outcome) { return '46-дан 60 минут аралығында қосарлы нәтиже'; };
var bo_i15 = function (match, outcome) { return '61-ден 75 минут аралығында қосарлы нәтиже'; };
var bo_j15 = function (match, outcome) { return '76 минуттан НУ соңына дейін қосарлы нәтиже'; };
var bo_k15 = function (match, outcome) { return "".concat(match.homeTeam, " ").concat(numeralMaleEnding(outcome.condition), " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438\u0434\u0456 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?"); };
var bo_l15 = function (match, outcome) { return "".concat(match.awayTeam, " ").concat(numeralMaleEnding(outcome.condition), " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438\u0434\u0456 \u0441\u043E\u0493\u0430\u0434\u044B \u043C\u0430?"); };
var bo_m15 = function (match, outcome) { return "".concat(match.homeTeam, " \u04E9\u0437\u0456\u043D\u0456\u04A3 ").concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B\u044B\u043D \u0441\u043E\u0493\u0430\u0434\u044B"); };
var bo_n15 = function (match, outcome) { return "".concat(match.awayTeam, " \u04E9\u0437\u0456\u043D\u0456\u04A3 ").concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B\u044B\u043D \u0441\u043E\u0493\u0430\u0434\u044B"); };
var bo_o15 = function (match, outcome) { return 'Бірінші таймдағы бұрыштамалар тоталы'; };
var bo_p15 = function (match, outcome) { return 'Бірінші таймдағы СК тоталы'; };
var bo_q15 = function (match, outcome) { return 'Матчтағы бұрыштамалар бойынша фора'; };
var bo_r15 = function (match, outcome) { return 'Бірінші таймдағы бұрыштамалар бойынша фора'; };
var bo_s15 = function (match, outcome) { return 'СК бойынша фора'; };
var bo_t15 = function (match, outcome) { return 'Бірінші таймда СК бойынша фора'; };
var bo_u15 = function (match, outcome) { return 'Бұрыштамалар бойынша матч нәтижесі'; };
var bo_v15 = function (match, outcome) { return 'Бұрыштамалар бойынша бірінші тайм нәтижесі'; };
var bo_w15 = function (match, outcome) { return 'СК бойынша матч нәтижесі'; };
var bo_x15 = function (match, outcome) { return 'СК бойынша бірінші тайм нәтижесі'; };
var bo_y15 = function (match, outcome) { return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['гол']), " \u0441\u0430\u043B\u0430\u0434\u044B"); };
var bo_z15 = function (match, outcome) { return " ".concat(numeralMaleEnding(outcome.condition), " \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438 \u0441\u0430\u043B\u044B\u043D\u0430\u0434\u044B \u043C\u0430"); };
var bo_a16 = function (match, outcome) { return 'Ауттар'; };
var bo_b16 = function (match, outcome) { return 'Тайм-Матч'; };
var bo_c16 = function (match, outcome) { return 'Матч тоталы (Азия)'; };
var bo_d16 = function (match, outcome) { return 'Бұрыштамалар тоталы'; };
var bo_e16 = function (match, outcome) { return 'Матч қалай аяқталады?'; };
var bo_f16 = function (match, outcome) { return 'Пенальти (тотал)'; };
var bo_g16 = function (match, outcome) { return 'Қызыл карточкалар тоталы'; };
var bo_h16 = function (match, outcome) { return 'Бірінші гол уақыты'; };
var bo_i16 = function (match, outcome) { return 'Минут голдар жиынтығы'; };
var bo_j16 = function (match, outcome) { return 'Екінші таймның тоталы'; };
var bo_k16 = function (match, outcome) { return 'Екінші таймдағы фора'; };
var bo_l16 = function (match, outcome) { return 'Қақпаның жақтауына соғу'; };
var bo_m16 = function (match, outcome) { return 'Сары карточкалар тоталы'; };
var bo_n16 = function (match, outcome) { return 'Екінші тайм нәтижесі'; };
var bo_o16 = function (match, outcome) { return '1-ден 15 минут аралығында матчтағы фора'; };
var bo_p16 = function (match, outcome) { return '16-дан 30 минут аралығында матчтағы фора'; };
var bo_q16 = function (match, outcome) { return '31 минуттан үзіліске дейін матчтағы фора'; };
var bo_r16 = function (match, outcome) { return '46-дан 60 минут аралығында матчтағы фора'; };
var bo_s16 = function (match, outcome) { return '61-ден 75 минут аралығында матчтағы фора'; };
var bo_t16 = function (match, outcome) { return '76 минуттан НУ соңына дейін матчтағы фора'; };
var bo_u16 = function (match, outcome) { return "".concat(match.homeTeam, " \u0433\u043E\u043B\u0434\u0430\u0440"); };
var bo_v16 = function (match, outcome) { return "".concat(match.awayTeam, " \u0433\u043E\u043B\u0434\u0430\u0440"); };
var bo_w16 = function (match, outcome) { return 'Ауыстырулар тоталы'; };
var bo_x16 = function (match, outcome) { return '1-ден 15 минут аралығындағы матч тоталы'; };
var bo_y16 = function (match, outcome) { return '16-дан 30 минут аралығындағы матч тоталы'; };
var bo_z16 = function (match, outcome) { return '31-ден минут үзіліске дейін аралығындағы матч тоталы'; };
var bo_a17 = function (match, outcome) { return '46-дан 60 минут аралығындағы матч тоталы'; };
var bo_b17 = function (match, outcome) { return '61-ден 75 минут аралығындағы матч тоталы'; };
var bo_c17 = function (match, outcome) { return '76 минуттан НУ соңына дейін матч тоталы'; };
var bo_d17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 1-\u0434\u0435\u043D 15 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430"); };
var bo_e17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 16-\u0434\u0430\u043D 30 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430"); };
var bo_f17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 31 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u04AF\u0437\u0456\u043B\u0456\u0441\u043A\u0435 \u0434\u0435\u0439\u0456\u043D"); };
var bo_g17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 46-\u0434\u0430\u043D 60 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430"); };
var bo_h17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 61-\u0434\u0435\u043D 75 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430"); };
var bo_i17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 76 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u041D\u0423 \u0441\u043E\u04A3\u044B\u043D\u0430 \u0434\u0435\u0439\u0456\u043D"); };
var bo_j17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 1-\u0434\u0435\u043D 15 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430"); };
var bo_k17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 16-\u0434\u0430\u043D 30 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430"); };
var bo_l17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 31 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u04AF\u0437\u0456\u043B\u0456\u0441\u043A\u0435 \u0434\u0435\u0439\u0456\u043D"); };
var bo_m17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 46-\u0434\u0430\u043D 60 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430"); };
var bo_n17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 61-\u0434\u0435\u043D 75 \u043C\u0438\u043D\u0443\u0442 \u0430\u0440\u0430\u043B\u044B\u0493\u044B\u043D\u0434\u0430"); };
var bo_o17 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u043C\u0430\u0442\u0447\u0442\u0430\u0493\u044B 76 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u041D\u0423 \u0441\u043E\u04A3\u044B\u043D\u0430 \u0434\u0435\u0439\u0456\u043D"); };
var bo_p17 = function (match, outcome) { return 'Бірінші таймның дәл тоталы'; };
var bo_q17 = function (match, outcome) { return 'Екінші таймның дәл тоталы'; };
var bo_r17 = function (match, outcome) { return "".concat(match.homeTeam, " \u04B1\u0442\u0430\u0434\u044B \u0436\u04D9\u043D\u0435 \u04E9\u0442\u043A\u0456\u0437\u0431\u0435\u0439\u0434\u0456"); };
var bo_s17 = function (match, outcome) { return "".concat(match.awayTeam, " \u04B1\u0442\u0430\u0434\u044B \u0436\u04D9\u043D\u0435 \u04E9\u0442\u043A\u0456\u0437\u0431\u0435\u0439\u0434\u0456"); };
var bo_t17 = function (match, outcome) { return "".concat(match.homeTeam, " \u0442\u0443\u0440\u0430 ").concat(outcome.condition, " \u0433\u043E\u043B \u0441\u043E\u0493\u0430\u0434\u044B"); };
var bo_u17 = function (match, outcome) { return "".concat(match.awayTeam, " \u0442\u0443\u0440\u0430 ").concat(outcome.condition, " \u0433\u043E\u043B \u0441\u043E\u0493\u0430\u0434\u044B"); };
var bo_v17 = function (match, outcome) { return 'Бірінші таймның дәл есебі'; };
var bo_w17 = function (match, outcome) { return 'Екінші таймның дәл есебі'; };
var bo_x17 = function (match, outcome) { return 'Салынбаған пенальти'; };
var bo_y17 = function (match, outcome) { return "\u0415\u043A\u0456 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 ".concat(outcome.condition, " \u0441\u0430\u043B\u044B\u0441\u0442\u044B\u0440\u0493\u0430\u043D\u0434\u0430 \u0430\u0437 \u0441\u0430\u043B\u0430\u0434\u044B"); };
var bo_z17 = function (match, outcome) { return "\u0415\u043A\u0456 \u043A\u043E\u043C\u0430\u043D\u0434\u0430 ".concat(outcome.condition, " \u0441\u0430\u043B\u044B\u0441\u0442\u044B\u0440\u0493\u0430\u043D\u0434\u0430 \u043A\u04E9\u043F \u0441\u0430\u043B\u0430\u0434\u044B"); };
var bo_a18 = function (match, outcome) { return 'Таймдарды (голдарды) салыстыру'; };
var bo_b18 = function (match, outcome) { return '1-ден 15 минут аралығында матчтағы жеңіс'; };
var bo_c18 = function (match, outcome) { return '16-дан 30 минут аралығында матчтағы жеңіс'; };
var bo_d18 = function (match, outcome) { return '31 минуттан үзіліске дейін матчтағы жеңіс'; };
var bo_e18 = function (match, outcome) { return '46-дан 60 минут аралығында матчтағы жеңіс'; };
var bo_f18 = function (match, outcome) { return '61-ден 75 минут аралығында матчтағы жеңіс'; };
var bo_g18 = function (match, outcome) { return '76 минуттан НУ соңына дейін матчтағы жеңіс'; };
var bo_h18 = function (match, outcome) { return "".concat(match.homeTeam, " \u0442\u0430\u0439\u043C\u0434\u0430\u0440\u0434\u044B\u04A3 \u0431\u0456\u0440\u0456\u043D\u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_i18 = function (match, outcome) { return "".concat(match.awayTeam, " \u0442\u0430\u0439\u043C\u0434\u0430\u0440\u0434\u044B\u04A3 \u0431\u0456\u0440\u0456\u043D\u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_j18 = function (match, outcome) { return "".concat(outcome.conditionTwo, " - ").concat(outcome.conditionThree, " \u0433\u043E\u043B\u0493\u0430 \u0434\u0435\u0439\u0456\u043D \u0441\u043E\u049B\u049B\u0430\u043D \u043A\u043E\u043C\u0430\u043D\u0434\u0430\u043B\u0430\u0440 (\u043E\u043B\u0430\u0440\u0434\u044B\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B)"); };
var bo_k18 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430"); };
var bo_l18 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430"); };
var bo_m18 = function (match, outcome) { return " ".concat(outcome.playerName, " (").concat(match.homeTeam, ") \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B \u043C\u0430?"); };
var bo_n18 = function (match, outcome) { return "".concat(outcome.playerName, " (").concat(match.awayTeam, ") \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B \u043C\u0430?"); };
var bo_o18 = function (match, outcome) { return 'Матч нәтижесі'; };
var bo_p18 = function (match, outcome) { return 'Матч форасы'; };
var bo_q18 = function (match, outcome) { return 'Қожайындар тоталы'; };
var bo_r18 = function (match, outcome) { return 'Қонақтар тоталы'; };
var bo_s18 = function (match, outcome) { return 'Ең нәтижелі матч тоталы'; };
var bo_t18 = function (match, outcome) { return 'Ең нәтижесіз матч тоталы'; };
var bo_u18 = function (match, outcome) { return 'Голсыз матч тоталы'; };
var bo_v18 = function (match, outcome) { return 'Қожайындар жеңістерінің тоталы'; };
var bo_w18 = function (match, outcome) { return 'Қонақтар жеңістерінің тоталы'; };
var bo_x18 = function (match, outcome) { return 'Тең ойын тоталы'; };
var bo_y18 = function (match, outcome) { return 'Қос нәтиже'; };
var bo_z18 = function (match, outcome) { return 'Команданың екеуі де салады: 1 тайм/2 тайм'; };
var bo_a19 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B ".concat(outcome.condition, " \u0436\u04D9\u043D\u0435 \u0435\u043A\u0443\u0456 \u0434\u0435 \u0441\u0430\u043B\u0430\u0434\u044B"); };
var bo_b19 = function (match, outcome) { return "".concat(match.homeTeam, " \u0441\u0430\u043B\u0430\u0434\u044B \u0436\u04D9\u043D\u0435 \u0436\u0435\u04A3\u0431\u0435\u0439\u0434\u0456"); };
var bo_c19 = function (match, outcome) { return "".concat(match.awayTeam, " \u0437\u0441\u0430\u043B\u0430\u0434\u044B \u0436\u04D9\u043D\u0435 \u0436\u0435\u04A3\u0431\u0435\u0439\u0434\u0456"); };
var bo_d19 = function (match, outcome) { return 'Матчта жеңу тәсілі'; };
var bo_e19 = function (match, outcome) { return '1-інші таймда өтелген уақыт'; };
var bo_f19 = function (match, outcome) { return '2-інші таймда өтелген уақыт'; };
var bo_g19 = function (match, outcome) { return 'Матчта штанга/жолақ боалды ма'; };
var bo_h19 = function (match, outcome) { return 'Бірінші ауысу уақыты'; };
var bo_i19 = function (match, outcome) { return "\u049A\u044B\u0437\u044B\u043B \u043A\u0430\u0440\u0442\u0430\u043D\u044B ".concat(match.homeTeam, " \u043E\u0439\u044B\u043D\u0448\u044B\u0441\u044B \u0430\u043B\u0430\u0434\u044B"); };
var bo_j19 = function (match, outcome) { return "\u049A\u044B\u0437\u044B\u043B \u043A\u0430\u0440\u0442\u0430\u043D\u044B".concat(match.awayTeam, " \u043E\u0439\u044B\u043D\u0448\u044B\u0441\u044B \u0430\u043B\u0430\u0434\u044B"); };
var bo_k19 = function (match, outcome) { return 'Пенальти мен жою болады ма'; };
var bo_l19 = function (match, outcome) { return 'Гол өтелген уақытта'; };
var bo_m19 = function (match, outcome) { return 'Алдау үшін Сары Карта'; };
var bo_n19 = function (match, outcome) { return 'Шешілген жейде үшін Сары Карта'; };
var bo_o19 = function (match, outcome) { return 'Әр жалаушадан бұрыштамалар'; };
var bo_p19 = function (match, outcome) { return '3-ші орын кім алады?'; };
var bo_q19 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, "  (\u049A\u043E\u0441\u044B\u043C\u0448\u0430 \u0443\u0430\u049B\u044B\u0442)"); };
var bo_r19 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, "  (\u049A\u043E\u0441\u044B\u043C\u0448\u0430 \u0443\u0430\u049B\u044B\u0442)"); };
var bo_s19 = function (match, outcome) { return 'Қос нәтиже (Қосымша уақыт)'; };
var bo_t19 = function (match, outcome) { return 'Дәл есеп (Қосымша уақыт)'; };
var bo_u19 = function (match, outcome) { return 'Фора (Қосымша уақыт)'; };
var bo_v19 = function (match, outcome) { return 'Тотал  (Қосымша уақыт)'; };
var bo_w19 = function (match, outcome) { return "".concat(match.homeTeam, " - ").concat(match.awayTeam, " (\u049A\u043E\u0441\u044B\u043C\u0448\u0430 \u0443\u0430\u049B\u044B\u0442)"); };
var bo_x19 = function (match, outcome) { return "\u041A\u0456\u043C ".concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?"); };
var bo_y19 = function (match, outcome) { return 'Бірінші қосымша уақытта фора'; };
var bo_z19 = function (match, outcome) { return 'Бірінші қосымша уақыттың тоталы'; };
var bo_a20 = function (match, outcome) { return 'Бірінші қосымша уақытта нәтиже'; };
var bo_b20 = function (match, outcome) { return 'Екінші қосымша уақытта фора'; };
var bo_c20 = function (match, outcome) { return 'Екінші қосымша уақыттың тоталы'; };
var bo_d20 = function (match, outcome) { return 'Екінші қосымша уақытта нәтиже'; };
var bo_e20 = function (match, outcome) { return 'Пенальти сериясында дәл есеп'; };
var bo_f20 = function (match, outcome) { return "\u0441\u0430\u043B\u044B\u043D\u0493\u0430\u043D \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.awayTeam, " (\u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438 \u0441\u0435\u0440\u0438\u044F\u0441\u044B)"); };
var bo_g20 = function (match, outcome) { return "\u0421\u0430\u043B\u044B\u043D\u0493\u0430\u043D \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.homeTeam, " (\u0441\u0435\u0440\u0438\u044F \u043F\u0435\u043D\u0430\u043B\u044C\u0442\u0438)"); };
var bo_h20 = function (match, outcome) { return 'салынған пенальти тоталы:  (пенальти сериясы)'; };
var bo_i20 = function (match, outcome) { return 'Салынбаған пенальти тоталы:  (пенальти сериясы)'; };
var bo_j20 = function (match, outcome) { return "\u0415\u0443\u0440\u043E\u043F\u0430\u043B\u044B\u043B\u044B\u049B \u0444\u043E\u0440\u0430 ".concat(europeanHandicapCondition(outcome.condition)); };
var bo_k20 = function (match, outcome) { return "\u0415\u0443\u0440\u043E\u043F\u0430\u043B\u044B\u049B \u0444\u043E\u0440\u0430 ".concat(europeanHandicapCondition(outcome.condition), " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430"); };
var bo_l20 = function (match, outcome) { return "\u0415\u0443\u0440\u043E\u043F\u0430\u043B\u044B\u049B \u0444\u043E\u0440\u0430 ".concat(europeanHandicapCondition(outcome.condition), " 2-\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430"); };
var bo_m20 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u043A\u0456\u043C ".concat(numeralMaleEnding(outcome.condition), " \u0433\u043E\u043B \u0441\u0430\u043B\u0430\u0434\u044B?"); };
var bo_n20 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u044B\u04A3 \u049B\u0430\u043B\u0493\u0430\u043D \u0443\u0430\u049B\u044B\u0442\u044B (\u0430\u0493\u044B\u043C\u0434\u0430\u0493\u044B \u0435\u0441\u0435\u043F ".concat(outcome.condition, ":").concat(outcome.conditionTwo, ")"); };
var bo_o20 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u043D\u044B\u04A3 \u049B\u0430\u043B\u0493\u0430\u043D \u0443\u0430\u049B\u044B\u0442\u044B (\u0430\u0493\u044B\u043C\u0434\u0430\u0493\u044B \u0435\u0441\u0435\u043F ".concat(outcome.condition, ":").concat(outcome.conditionTwo, ")"); };
var bo_p20 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u043D\u044B\u04A3 \u0431\u04B1\u0440\u044B\u0448\u0442\u0430\u043C\u0430\u043B\u0430\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.homeTeam); };
var bo_q20 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u043D\u044B\u04A3 \u0431\u04B1\u0440\u044B\u0448\u0442\u0430\u043C\u0430\u043B\u0430\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.awayTeam); };
var bo_r20 = function (match, outcome) { return "\u0411\u04B1\u0440\u044B\u0448\u0442\u0430\u043C\u0430\u043B\u0430\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.homeTeam); };
var bo_s20 = function (match, outcome) { return "\u0411\u04B1\u0440\u044B\u0448\u0442\u0430\u043C\u0430\u043B\u0430\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.awayTeam); };
var bo_t20 = function (match, outcome) { return 'Бірінші гол уақыты (мин)'; };
var bo_u20 = function (match, outcome) { return 'Бірінші таймның қос нәтижесі'; };
var bo_v20 = function (match, outcome) { return 'Екінші таймның қос нәтижесі'; };
var bo_w20 = function (match, outcome) { return 'Екеуі де алады ма?'; };
var bo_x20 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_y20 = function (match, outcome) { return "".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_z20 = function (match, outcome) { return "".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_a21 = function (match, outcome) { return "".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0442\u0430\u0439\u043C\u0434\u0430 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_b21 = function (match, outcome) { return 'Хет-триктер (олардың тоталы)'; };
var bo_c21 = function (match, outcome) { return 'Бірінші кезеңнің тоталы'; };
var bo_d21 = function (match, outcome) { return 'Екінші кезеңнің тоталы'; };
var bo_e21 = function (match, outcome) { return 'Үшінші кезеңнің тоталы'; };
var bo_f21 = function (match, outcome) { return 'Бірінші кезеңнің дәл есебі'; };
var bo_g21 = function (match, outcome) { return 'Екінші кезеңнің дәл есебі'; };
var bo_h21 = function (match, outcome) { return 'Үшінші кезеңнің дәл есебі'; };
var bo_i21 = function (match, outcome) { return 'Бірінші кезеңнің жұп/тақ болуы'; };
var bo_j21 = function (match, outcome) { return 'Екінші кезеңнің жұп/тақ болуы'; };
var bo_k21 = function (match, outcome) { return 'Үшінші кезеңнің жұп/тақ болуы'; };
var bo_l21 = function (match, outcome) { return 'Ең нәтижелі кезең (тотал)'; };
var bo_m21 = function (match, outcome) { return 'Ең нәтижесіз кезең (тотал)'; };
var bo_n21 = function (match, outcome) { return 'Бірінші кезеңнің дәл тоталы'; };
var bo_o21 = function (match, outcome) { return 'Екінші кезеңнің дәл тоталы'; };
var bo_p21 = function (match, outcome) { return 'Үшінші кезеңнің дәл тоталы'; };
var bo_q21 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435"); };
var bo_r21 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435"); };
var bo_s21 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435"); };
var bo_t21 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435"); };
var bo_u21 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435"); };
var bo_v21 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435"); };
var bo_w21 = function (match, outcome) { return 'Екі команда да салады'; };
var bo_x21 = function (match, outcome) { return 'ОТ ескерумен жеңіс'; };
var bo_y21 = function (match, outcome) { return 'Период-Матч'; };
var bo_z21 = function (match, outcome) { return "".concat(match.homeTeam, " \u04D9\u0440 \u043A\u0435\u0437\u0435\u04A3\u0434\u0456 \u0441\u0430\u043B\u0430\u0434\u044B"); };
var bo_a22 = function (match, outcome) { return "".concat(match.awayTeam, " \u04D9\u0440 \u043A\u0435\u0437\u0435\u04A3\u0434\u0435 \u0441\u0430\u043B\u0430\u0434\u044B"); };
var bo_b22 = function (match, outcome) { return 'Барлық кезеңдерде салады'; };
var bo_c22 = function (match, outcome) { return 'бірінші және екінші кезеңді салыстыру'; };
var bo_d22 = function (match, outcome) { return 'Бірінші және үшінші кезеңді салыстыру'; };
var bo_e22 = function (match, outcome) { return 'Екінші және үшінші кезеңді салыстыру'; };
var bo_f22 = function (match, outcome) { return "".concat(match.homeTeam, " \u043A\u0435\u0437\u0435\u04A3\u0434\u0435\u0440\u0434\u0456\u04A3 \u0431\u0456\u0440\u0435\u0443\u0456\u043D\u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_g22 = function (match, outcome) { return "".concat(match.awayTeam, " \u043A\u0435\u0437\u0435\u04A3\u0434\u0435\u0440\u0434\u0456\u04A3 \u0431\u0456\u0440\u0435\u0443\u0456\u043D\u0434\u0435 \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_h22 = function (match, outcome) { return 'Кемінде бір кезеңде тең ойын'; };
var bo_i22 = function (match, outcome) { return 'Матчта 1-10 минутқа дейін жеңу'; };
var bo_j22 = function (match, outcome) { return 'Матчта 11-20 минутқа дейін жеңу'; };
var bo_k22 = function (match, outcome) { return 'Матчта 21-30 минутқа дейін жеңу'; };
var bo_l22 = function (match, outcome) { return 'Матчта 31-40 минутқа дейін жеңу'; };
var bo_m22 = function (match, outcome) { return 'Матчта 41-50 минутқа дейін жеңу'; };
var bo_n22 = function (match, outcome) { return 'Матчта 51-60 минутқа дейін жеңу'; };
var bo_o22 = function (match, outcome) { return 'Матчта 1-10 минутқа дейін фора'; };
var bo_p22 = function (match, outcome) { return 'Матчта 11-20 минутқа дейін фора'; };
var bo_q22 = function (match, outcome) { return 'Матчта 21-30 минутқа дейін фора'; };
var bo_r22 = function (match, outcome) { return 'Матчта 31-40 минутқа дейін фора'; };
var bo_s22 = function (match, outcome) { return 'Матчта 41-50 минутқа дейін фора'; };
var bo_t22 = function (match, outcome) { return 'Матчта 51-60 минутқа дейін фора'; };
var bo_u22 = function (match, outcome) { return 'Матчта 1-10 минутқа дейін тотал'; };
var bo_v22 = function (match, outcome) { return 'Матчта 11-20 минутқа дейін тотал'; };
var bo_w22 = function (match, outcome) { return 'Матчта 21-30 минутқа дейін тотал'; };
var bo_x22 = function (match, outcome) { return 'Матчта 31-40 минутқа дейін тотал'; };
var bo_y22 = function (match, outcome) { return 'Матчта 41-50 минутқа дейін тотал'; };
var bo_z22 = function (match, outcome) { return 'Матчта 51-60 минутқа дейін тотал'; };
var bo_a23 = function (match, outcome) { return 'Бірінші кезеңді неше команда салады?'; };
var bo_b23 = function (match, outcome) { return 'Екінші кезеңді неше команда салады?'; };
var bo_c23 = function (match, outcome) { return 'Үшінші кезеңді неше команда салады?'; };
var bo_d23 = function (match, outcome) { return "".concat(match.homeTeam, " \u0435\u0440\u0456\u043A\u0442\u0456\u043A \u0436\u0435\u04A3\u0456\u0441\u043A\u0435 \u0436\u0435\u0442\u0435\u0434\u0456"); };
var bo_e23 = function (match, outcome) { return "".concat(match.awayTeam, " \u0435\u0440\u0456\u043A\u0442\u0456\u043A \u0436\u0435\u04A3\u0456\u0441\u043A\u0435 \u0436\u0435\u0442\u0435\u0434\u0456"); };
var bo_f23 = function (match, outcome) { return 'Чет/Нечет наибольшего выпавшего шара'; };
var bo_g23 = function (match, outcome) { return 'Чет/Нечет наименьшего выпавшего шара'; };
var bo_h23 = function (match, outcome) { return 'Чет/Нечет первого выпавшего шара'; };
var bo_i23 = function (match, outcome) { return 'Чет/Нечет последнего выпавшего шара'; };
var bo_j23 = function (match, outcome) { return 'Первый меньше/больше последнего'; };
var bo_k23 = function (match, outcome) { return 'Все шары четные'; };
var bo_l23 = function (match, outcome) { return 'Все шары нечетные'; };
var bo_m23 = function (match, outcome) { return 'Хотя бы два шара с соседними номерами'; };
var bo_n23 = function (match, outcome) { return 'Наименьший выпавший шар'; };
var bo_o23 = function (match, outcome) { return 'Наибольший выпавший шар'; };
var bo_p23 = function (match, outcome) { return 'Сумма выпавших шаров'; };
var bo_q23 = function (match, outcome) { return "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0438\u0437 \u0432\u044B\u043F\u0430\u0432\u0448\u0438\u0445 \u0448\u0430\u0440\u043E\u0432 \u043A\u0440\u0430\u0442\u0435\u043D ".concat(outcome.condition); };
var bo_r23 = function (match, outcome) { return 'Разница между наименьшим и наибольшим шарами'; };
var bo_s23 = function (match, outcome) { return 'Сумма нечетных шаров'; };
var bo_t23 = function (match, outcome) { return 'Сумма четных шаров'; };
var bo_u23 = function (match, outcome) { return 'Первый выпавший шар'; };
var bo_v23 = function (match, outcome) { return 'Второй выпавший шар'; };
var bo_w23 = function (match, outcome) { return 'Третий выпавший шар'; };
var bo_x23 = function (match, outcome) { return 'Четвертый выпавший шар'; };
var bo_y23 = function (match, outcome) { return 'Пятый выпавший шар'; };
var bo_z23 = function (match, outcome) { return 'Шестой выпавший шар'; };
var bo_a24 = function (match, outcome) { return 'Седьмой выпавший шар'; };
var bo_b24 = function (match, outcome) { return "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0448\u0430\u0440 \u043F\u043E\u043F\u0430\u0434\u0435\u0442 \u0432 \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B \u043E\u0442 ".concat(outcome.condition, " \u0434\u043E ").concat(outcome.conditionTwo); };
var bo_c24 = function (match, outcome) { return 'Сумма наименьшего и наибольшего шаров'; };
var bo_d24 = function (match, outcome) { return 'Ұрыста жеңіске жету'; };
var bo_e24 = function (match, outcome) { return 'Мерзімнен ерте жеңіс болады ма?'; };
var bo_f24 = function (match, outcome) { return "".concat(match.homeTeam, " \u0430\u0443\u044B\u0440\u0442\u0443/\u0442\u04B1\u043D\u0448\u044B\u049B\u0442\u044B\u0440\u0443/\u0435\u0440\u0456\u043A\u0442\u0456 \u0431\u0435\u0440\u0456\u043B\u0443 \u0430\u0440\u049B\u044B\u043B\u044B \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_g24 = function (match, outcome) { return "".concat(match.awayTeam, " \u0430\u0443\u044B\u0440\u0442\u0443/\u0442\u04B1\u043D\u0448\u044B\u049B\u0442\u044B\u0440\u0443/\u0435\u0440\u0456\u043A\u0442\u0456 \u0431\u0435\u0440\u0456\u043B\u0443 \u0430\u0440\u049B\u044B\u043B\u044B \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_h24 = function (match, outcome) { return "".concat(match.homeTeam, "  \u043D\u043E\u043A\u0430\u0443\u0442\u043F\u0435\u043D/\u0442\u0435\u0445\u043D\u0438\u043A\u0430\u043B\u044B\u049B \u043D\u043E\u043A\u0430\u0443\u0442\u043F\u0435\u043D/\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_i24 = function (match, outcome) { return "".concat(match.awayTeam, "  \u043D\u043E\u043A\u0430\u0443\u0442\u043F\u0435\u043D/\u0442\u0435\u0445\u043D\u0438\u043A\u0430\u043B\u044B\u049B \u043D\u043E\u043A\u0430\u0443\u0442\u043F\u0435\u043D/\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_j24 = function (match, outcome) { return 'Медальдар тоталы'; };
var bo_k24 = function (match, outcome) { return 'Жиырма тоғызыншы партияның нәтижесі'; };
var bo_l24 = function (match, outcome) { return 'Отызыншы партияның нәтижесі'; };
var bo_m24 = function (match, outcome) { return 'Отыз бірінші партияның нәтижесі'; };
var bo_n24 = function (match, outcome) { return 'Отыз екінші партияның нәтижесі'; };
var bo_o24 = function (match, outcome) { return 'Отыз үшінші партияның нәтижесі'; };
var bo_p24 = function (match, outcome) { return 'Отыз төртінші партияның нәтижесі'; };
var bo_q24 = function (match, outcome) { return 'Отыз бесінші партияның нәтижесі'; };
var bo_r24 = function (match, outcome) { return 'Отыз алтыншы партияның нәтижесі'; };
var bo_s24 = function (match, outcome) { return 'Отыз жетінші партияның нәтижесі'; };
var bo_t24 = function (match, outcome) { return 'Он сегізінші партияның жұп/тақ болуы'; };
var bo_u24 = function (match, outcome) { return 'Он тоғызыншы партияның жұп/тақ болуы'; };
var bo_v24 = function (match, outcome) { return 'Жиырмасыншы партияның жұп/тақ болуы'; };
var bo_w24 = function (match, outcome) { return 'Жиырма бірінші партияның жұп/тақ болуы'; };
var bo_x24 = function (match, outcome) { return 'Жиырма екінші партияның жұп/тақ болуы'; };
var bo_y24 = function (match, outcome) { return 'Жиырма үшінші партияның жұп/тақ болуы'; };
var bo_z24 = function (match, outcome) { return 'Жиырма төртінші партияның жұп/тақ болуы'; };
var bo_a25 = function (match, outcome) { return 'Жиырма бесінші партияның жұп/тақ болуы'; };
var bo_b25 = function (match, outcome) { return 'Жиырма алтыншы партияның жұп/тақ болуы'; };
var bo_c25 = function (match, outcome) { return 'Жиырма жетінші партияның жұп/тақ болуы'; };
var bo_d25 = function (match, outcome) { return 'Жиырма сегізінші партияның жұп/тақ болуы'; };
var bo_e25 = function (match, outcome) { return 'Жиырма тоғызыншы партияның жұп/тақ болуы'; };
var bo_f25 = function (match, outcome) { return 'Отызыншы партияның жұп/тақ болуы'; };
var bo_g25 = function (match, outcome) { return 'Отыз бірінші партияның жұп/тақ болуы'; };
var bo_h25 = function (match, outcome) { return 'Отыз екінші партияның жұп/тақ болуы'; };
var bo_i25 = function (match, outcome) { return 'Отыз үшінші партияның жұп/тақ болуы'; };
var bo_j25 = function (match, outcome) { return 'Отыз төртінші партияның жұп/тақ болуы'; };
var bo_k25 = function (match, outcome) { return 'Отыз бесінші партияның жұп/тақ болуы'; };
var bo_l25 = function (match, outcome) { return 'Отыз алтыншы партияның жұп/тақ болуы'; };
var bo_m25 = function (match, outcome) { return 'Отыз жетінші партияның жұп/тақ болуы'; };
var bo_n25 = function (match, outcome) { return 'Бірінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_o25 = function (match, outcome) { return 'Екінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_p25 = function (match, outcome) { return 'Үшінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_q25 = function (match, outcome) { return 'Төртінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_r25 = function (match, outcome) { return 'Бесінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_s25 = function (match, outcome) { return 'Алтыншы партияда қандай түсті шар бірінші болып салынады?'; };
var bo_t25 = function (match, outcome) { return 'Жетінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_u25 = function (match, outcome) { return 'Сегізінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_v25 = function (match, outcome) { return 'Тоғызыншы партияда қандай түсті шар бірінші болып салынады?'; };
var bo_w25 = function (match, outcome) { return 'Оныншы партияда қандай түсті шар бірінші болып салынады?'; };
var bo_x25 = function (match, outcome) { return 'Он бірінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_y25 = function (match, outcome) { return 'Он екінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_z25 = function (match, outcome) { return 'Он үшінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_a26 = function (match, outcome) { return 'Он төртінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_b26 = function (match, outcome) { return 'Он бесінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_c26 = function (match, outcome) { return 'Он алтыншы партияда қандай түсті шар бірінші болып салынады?'; };
var bo_d26 = function (match, outcome) { return 'Он жетінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_e26 = function (match, outcome) { return 'Он сегізінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_f26 = function (match, outcome) { return 'Он тоғызыншы партияда қандай түсті шар бірінші болып салынады?'; };
var bo_g26 = function (match, outcome) { return 'Жиырмасыншы партияда қандай түсті шар бірінші болып салынады?'; };
var bo_h26 = function (match, outcome) { return 'Жиырма бірінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_i26 = function (match, outcome) { return 'Жиырма екінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_j26 = function (match, outcome) { return 'Жиырма үшінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_k26 = function (match, outcome) { return 'Жиырма төртінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_l26 = function (match, outcome) { return 'Жиырма бесінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_m26 = function (match, outcome) { return 'Жиырма алтыншы партияда қандай түсті шар бірінші болып салынады?'; };
var bo_n26 = function (match, outcome) { return 'Жиырма жетінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_o26 = function (match, outcome) { return 'Жиырма сегізінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_p26 = function (match, outcome) { return 'Жиырма тоғызыншы партияда қандай түсті шар бірінші болып салынады?'; };
var bo_q26 = function (match, outcome) { return 'Отызыншы партияда қандай түсті шар бірінші болып салынады?'; };
var bo_r26 = function (match, outcome) { return 'Отыз бірінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_s26 = function (match, outcome) { return 'Отыз екінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_t26 = function (match, outcome) { return 'Отыз үшінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_u26 = function (match, outcome) { return 'Отыз төртінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_v26 = function (match, outcome) { return 'Отыз бесінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_w26 = function (match, outcome) { return 'Отыз алтыншы партияда қандай түсті шар бірінші болып салынады?'; };
var bo_x26 = function (match, outcome) { return 'Отыз жетінші партияда қандай түсті шар бірінші болып салынады?'; };
var bo_y26 = function (match, outcome) { return 'Бірінші партияның нәтижесі'; };
var bo_z26 = function (match, outcome) { return 'Екінші партияның нәтижесі'; };
var bo_a27 = function (match, outcome) { return 'Үшінші партияның нәтижесі'; };
var bo_b27 = function (match, outcome) { return 'Төртінші партияның нәтижесі'; };
var bo_c27 = function (match, outcome) { return 'Бесінші партияның нәтижесі'; };
var bo_d27 = function (match, outcome) { return 'Алтыншы партияның нәтижесі'; };
var bo_e27 = function (match, outcome) { return 'Жетінші партияның нәтижесі'; };
var bo_f27 = function (match, outcome) { return 'Сегізінші партияның нәтижесі'; };
var bo_g27 = function (match, outcome) { return 'Тоғызыншы партияның нәтижесі'; };
var bo_h27 = function (match, outcome) { return 'Оныншы партияның нәтижесі'; };
var bo_i27 = function (match, outcome) { return 'Он бірінші партияның нәтижесі'; };
var bo_j27 = function (match, outcome) { return 'Он екінші партияның нәтижесі'; };
var bo_k27 = function (match, outcome) { return 'Он үшінші партияның нәтижесі'; };
var bo_l27 = function (match, outcome) { return 'Он төртінші партияның нәтижесі'; };
var bo_m27 = function (match, outcome) { return 'Он бесінші партияның нәтижесі'; };
var bo_n27 = function (match, outcome) { return 'Он алтыншы партияның нәтижесі'; };
var bo_o27 = function (match, outcome) { return 'Он жетінші партияның нәтижесі'; };
var bo_p27 = function (match, outcome) { return 'Он сегізінші партияның нәтижесі'; };
var bo_q27 = function (match, outcome) { return 'Он тоғызыншы партияның нәтижесі'; };
var bo_r27 = function (match, outcome) { return 'Жиырмасыншы партияның нәтижесі'; };
var bo_s27 = function (match, outcome) { return 'Жиырма бірінші партияның нәтижесі'; };
var bo_t27 = function (match, outcome) { return 'Жиырма екінші партияның нәтижесі'; };
var bo_u27 = function (match, outcome) { return 'Жиырма үшінші партияның нәтижесі'; };
var bo_v27 = function (match, outcome) { return 'Жиырма төртінші партияның нәтижесі'; };
var bo_w27 = function (match, outcome) { return 'Жиырма бесінші партияның нәтижесі'; };
var bo_x27 = function (match, outcome) { return 'Жиырма алтыншы партияның нәтижесі'; };
var bo_y27 = function (match, outcome) { return 'Жиырма жетінші партияның нәтижесі'; };
var bo_z27 = function (match, outcome) { return 'Жиырма сегізінші партияның нәтижесі'; };
var bo_a28 = function (match, outcome) { return 'Жетінші партияда кім бірінші болып шар соғады?'; };
var bo_b28 = function (match, outcome) { return 'Сегізінші партияда кім бірінші болып шар соғады?'; };
var bo_c28 = function (match, outcome) { return 'Тоғызыншы партияда кім бірінші болып шар соғады?'; };
var bo_d28 = function (match, outcome) { return 'Оныншы партияда кім бірінші болып шар соғады?'; };
var bo_e28 = function (match, outcome) { return 'Он бірінші партияда кім бірінші болып шар соғады?'; };
var bo_f28 = function (match, outcome) { return 'Он екінші партияда кім бірінші болып шар соғады?'; };
var bo_g28 = function (match, outcome) { return 'Он үшінші партияда кім бірінші болып шар соғады?'; };
var bo_h28 = function (match, outcome) { return 'Он төртінші партияда кім бірінші болып шар соғады?'; };
var bo_i28 = function (match, outcome) { return 'Он бесінші партияда кім бірінші болып шар соғады?'; };
var bo_j28 = function (match, outcome) { return 'Он алтыншы партияда кім бірінші болып шар соғады?'; };
var bo_k28 = function (match, outcome) { return 'Он жетінші партияда кім бірінші болып шар соғады?'; };
var bo_l28 = function (match, outcome) { return 'Он сегізінші партияда кім бірінші болып шар соғады?'; };
var bo_m28 = function (match, outcome) { return 'Он тоғызыншы партияда кім бірінші болып шар соғады?'; };
var bo_n28 = function (match, outcome) { return 'Жиырмасыншы партияда кім бірінші болып шар соғады?'; };
var bo_o28 = function (match, outcome) { return 'Жиырма бірінші партияда кім бірінші болып шар соғады?'; };
var bo_p28 = function (match, outcome) { return 'Жиырма екінші партияда кім бірінші болып шар соғады?'; };
var bo_q28 = function (match, outcome) { return 'Жиырма үшінші партияда кім бірінші болып шар соғады?'; };
var bo_r28 = function (match, outcome) { return 'Жиырма төртінші партияда кім бірінші болып шар соғады?'; };
var bo_s28 = function (match, outcome) { return 'Жиырма бесінші партияда кім бірінші болып шар соғады?'; };
var bo_t28 = function (match, outcome) { return 'Жиырма алтыншы партияда кім бірінші болып шар соғады?'; };
var bo_u28 = function (match, outcome) { return 'Жиырма жетінші партияда кім бірінші болып шар соғады?'; };
var bo_v28 = function (match, outcome) { return 'Жиырма сегізінші партияда кім бірінші болып шар соғады?'; };
var bo_w28 = function (match, outcome) { return 'Жиырма тоғызыншы партияда кім бірінші болып шар соғады?'; };
var bo_x28 = function (match, outcome) { return 'Отызыншы партияда кім бірінші болып шар соғады?'; };
var bo_y28 = function (match, outcome) { return 'Отыз бірінші партияда кім бірінші болып шар соғады?'; };
var bo_z28 = function (match, outcome) { return 'Отыз екінші партияда кім бірінші болып шар соғады?'; };
var bo_a29 = function (match, outcome) { return 'Отыз үшінші партияда кім бірінші болып шар соғады?'; };
var bo_b29 = function (match, outcome) { return 'Отыз төртінші партияда кім бірінші болып шар соғады?'; };
var bo_c29 = function (match, outcome) { return 'Отыз бесінші партияда кім бірінші болып шар соғады?'; };
var bo_d29 = function (match, outcome) { return 'Отыз алтыншы партияда кім бірінші болып шар соғады?'; };
var bo_e29 = function (match, outcome) { return 'Отыз жетінші партияда кім бірінші болып шар соғады?'; };
var bo_f29 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_g29 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_h29 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_i29 = function (match, outcome) { return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_j29 = function (match, outcome) { return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_k29 = function (match, outcome) { return "\u0410\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_l29 = function (match, outcome) { return "\u0416\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_m29 = function (match, outcome) { return "\u0421\u0435\u0433\u0456\u0437\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_n29 = function (match, outcome) { return "\u0422\u043E\u0493\u044B\u0437\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_o29 = function (match, outcome) { return "\u041E\u043D\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_p29 = function (match, outcome) { return "\u041E\u043D \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_q29 = function (match, outcome) { return "\u041E\u043D \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_r29 = function (match, outcome) { return "\u041E\u043D \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_s29 = function (match, outcome) { return "\u041E\u043D \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_t29 = function (match, outcome) { return "\u041E\u043D \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_u29 = function (match, outcome) { return "\u041E\u043D \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_v29 = function (match, outcome) { return "\u041E\u043D \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_w29 = function (match, outcome) { return "\u041E\u043D \u0441\u0435\u0433\u0456\u0437\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_x29 = function (match, outcome) { return "\u041E\u043D \u0442\u043E\u0493\u044B\u0437\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_y29 = function (match, outcome) { return "\u0416\u0438\u044B\u0440\u043C\u0430\u0441\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_z29 = function (match, outcome) { return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_a30 = function (match, outcome) { return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_b30 = function (match, outcome) { return "\u0416\u0438\u044B\u0440\u043C\u0430 \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_c30 = function (match, outcome) { return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_d30 = function (match, outcome) { return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_e30 = function (match, outcome) { return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_f30 = function (match, outcome) { return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_g30 = function (match, outcome) { return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0441\u0435\u0433\u0456\u0437\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_h30 = function (match, outcome) { return "\u0416\u0438\u044B\u0440\u043C\u0430 \u0442\u043E\u0493\u044B\u0437\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_i30 = function (match, outcome) { return "\u041E\u0442\u044B\u0437\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_j30 = function (match, outcome) { return "\u041E\u0442\u044B\u0437 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_k30 = function (match, outcome) { return "\u041E\u0442\u044B\u0437 \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_l30 = function (match, outcome) { return "\u041E\u0442\u044B\u0437 \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_m30 = function (match, outcome) { return "\u041E\u0442\u044B\u0437 \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_n30 = function (match, outcome) { return "\u041E\u0442\u044B\u0437 \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_o30 = function (match, outcome) { return "\u041E\u0442\u044B\u0437 \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_p30 = function (match, outcome) { return "\u041E\u0442\u044B\u0437 \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439 \u0436\u0438\u043D\u0430\u0439\u0434\u044B?"); };
var bo_q30 = function (match, outcome) { return 'Бірінші партияның жұп/тақ болуы'; };
var bo_r30 = function (match, outcome) { return 'Екінші партияның жұп/тақ болуы'; };
var bo_s30 = function (match, outcome) { return 'Үшінші партияның жұп/тақ болуы'; };
var bo_t30 = function (match, outcome) { return 'Төртінші партияның жұп/тақ болуы'; };
var bo_u30 = function (match, outcome) { return 'Бесінші партияның жұп/тақ болуы'; };
var bo_v30 = function (match, outcome) { return 'Алтыншы партияның жұп/тақ болуы'; };
var bo_w30 = function (match, outcome) { return 'Жетінші партияның жұп/тақ болуы'; };
var bo_x30 = function (match, outcome) { return 'Сегізінші партияның жұп/тақ болуы'; };
var bo_y30 = function (match, outcome) { return 'Тоғызыншы партияның жұп/тақ болуы'; };
var bo_z30 = function (match, outcome) { return 'Оныншы партияның жұп/тақ болуы'; };
var bo_a31 = function (match, outcome) { return 'Он бірінші партияның жұп/тақ болуы'; };
var bo_b31 = function (match, outcome) { return 'Он екінші партияның жұп/тақ болуы'; };
var bo_c31 = function (match, outcome) { return 'Он үшінші партияның жұп/тақ болуы'; };
var bo_d31 = function (match, outcome) { return 'Он төртінші партияның жұп/тақ болуы'; };
var bo_e31 = function (match, outcome) { return 'Он бесінші партияның жұп/тақ болуы'; };
var bo_f31 = function (match, outcome) { return 'Он алтыншы партияның жұп/тақ болуы'; };
var bo_g31 = function (match, outcome) { return 'Он жетінші партияның жұп/тақ болуы'; };
var bo_h31 = function (match, outcome) { return 'Матчтағы сенчури брейктер тоталы'; };
var bo_i31 = function (match, outcome) { return 'Бірінші партиядағы фора'; };
var bo_j31 = function (match, outcome) { return 'Екінші партиядағы фора'; };
var bo_k31 = function (match, outcome) { return 'Үшінші партиядағы фора'; };
var bo_l31 = function (match, outcome) { return 'Төртінші партиядағы фора'; };
var bo_m31 = function (match, outcome) { return 'Бесінші партиядағы фора'; };
var bo_n31 = function (match, outcome) { return 'Алтыншы партиядағы фора'; };
var bo_o31 = function (match, outcome) { return 'Жетінші партиядағы фора'; };
var bo_p31 = function (match, outcome) { return 'Сегізінші партиядағы фора'; };
var bo_q31 = function (match, outcome) { return 'Тоғызыншы партиядағы фора'; };
var bo_r31 = function (match, outcome) { return 'Оныншы партиядағы фора'; };
var bo_s31 = function (match, outcome) { return 'Он бірінші партиядағы фора'; };
var bo_t31 = function (match, outcome) { return 'Он екінші партиядағы фора'; };
var bo_u31 = function (match, outcome) { return 'Он үшінші партиядағы фора'; };
var bo_v31 = function (match, outcome) { return 'Он төртінші партиядағы фора'; };
var bo_w31 = function (match, outcome) { return 'Он бесінші партиядағы фора'; };
var bo_x31 = function (match, outcome) { return 'Он алтыншы партиядағы фора'; };
var bo_y31 = function (match, outcome) { return 'Он жетінші партиядағы фора'; };
var bo_z31 = function (match, outcome) { return 'Он сегізінші партиядағы фора'; };
var bo_a32 = function (match, outcome) { return 'Он тоғызыншы партиядағы фора'; };
var bo_b32 = function (match, outcome) { return 'Жиырмасыншы партиядағы фора'; };
var bo_c32 = function (match, outcome) { return 'Жиырма бірінші партиядағы фора'; };
var bo_d32 = function (match, outcome) { return 'Жиырма екінші партиядағы фора'; };
var bo_e32 = function (match, outcome) { return 'Жиырма үшінші партиядағы фора'; };
var bo_f32 = function (match, outcome) { return 'Жиырма төртінші партиядағы фора'; };
var bo_g32 = function (match, outcome) { return 'Жиырма бесінші партиядағы фора'; };
var bo_h32 = function (match, outcome) { return 'Жиырма алтыншы партиядағы фора'; };
var bo_i32 = function (match, outcome) { return 'Жиырма жетінші партиядағы фора'; };
var bo_j32 = function (match, outcome) { return 'Жиырма сегізінші партиядағы фора'; };
var bo_k32 = function (match, outcome) { return 'Жиырма тоғызыншы партиядағы фора'; };
var bo_l32 = function (match, outcome) { return 'Отызыншы партиядағы фора'; };
var bo_m32 = function (match, outcome) { return 'Отыз бірінші партиядағы фора'; };
var bo_n32 = function (match, outcome) { return 'Отыз екінші партиядағы фора'; };
var bo_o32 = function (match, outcome) { return 'Отыз үшінші партиядағы фора'; };
var bo_p32 = function (match, outcome) { return 'Отыз төртінші партиядағы фора'; };
var bo_q32 = function (match, outcome) { return 'Отыз бесінші партиядағы фора'; };
var bo_r32 = function (match, outcome) { return 'Отыз алтыншы партиядағы фора'; };
var bo_s32 = function (match, outcome) { return 'Отыз жетінші партиядағы фора'; };
var bo_t32 = function (match, outcome) { return 'Бірінші партияның тоталы'; };
var bo_u32 = function (match, outcome) { return 'Екінші партияның тоталы'; };
var bo_v32 = function (match, outcome) { return 'Үшінші партияның тоталы'; };
var bo_w32 = function (match, outcome) { return 'Төртінші партияның тоталы'; };
var bo_x32 = function (match, outcome) { return 'Бесінші партияның тоталы'; };
var bo_y32 = function (match, outcome) { return 'Алтыншы партияның тоталы'; };
var bo_z32 = function (match, outcome) { return 'Жетінші партияның тоталы'; };
var bo_a33 = function (match, outcome) { return 'Сегізінші партияның тоталы'; };
var bo_b33 = function (match, outcome) { return 'Тоғызыншы партияның тоталы'; };
var bo_c33 = function (match, outcome) { return 'Оныншы партияның тоталы'; };
var bo_d33 = function (match, outcome) { return 'Он бірінші партияның тоталы'; };
var bo_e33 = function (match, outcome) { return 'Он екінші партияның тоталы'; };
var bo_f33 = function (match, outcome) { return 'Он үшінші партияның тоталы'; };
var bo_g33 = function (match, outcome) { return 'Он төртінші партияның тоталы'; };
var bo_h33 = function (match, outcome) { return 'Он бесінші партияның тоталы'; };
var bo_i33 = function (match, outcome) { return 'Он алтыншы партияның тоталы'; };
var bo_j33 = function (match, outcome) { return 'Он жетінші партияның тоталы'; };
var bo_k33 = function (match, outcome) { return 'Он сегізінші партияның тоталы'; };
var bo_l33 = function (match, outcome) { return 'Он тоғызыншы партияның тоталы'; };
var bo_m33 = function (match, outcome) { return 'Жиырмасыншы партияның тоталы'; };
var bo_n33 = function (match, outcome) { return 'Жиырма бірінші партияның тоталы'; };
var bo_o33 = function (match, outcome) { return 'Жиырма екінші партияның тоталы'; };
var bo_p33 = function (match, outcome) { return 'Жиырма үшінші партияның тоталы'; };
var bo_q33 = function (match, outcome) { return 'Жиырма төртінші партияның тоталы'; };
var bo_r33 = function (match, outcome) { return 'Жиырма бесінші партияның тоталы'; };
var bo_s33 = function (match, outcome) { return 'Жиырма алтыншы партияның тоталы'; };
var bo_t33 = function (match, outcome) { return 'Жиырма жетінші партияның тоталы'; };
var bo_u33 = function (match, outcome) { return 'Жиырма сегізінші партияның тоталы'; };
var bo_v33 = function (match, outcome) { return 'Жиырма тоғызыншы партияның тоталы'; };
var bo_w33 = function (match, outcome) { return 'Отызыншы партияның тоталы'; };
var bo_x33 = function (match, outcome) { return 'Отыз бірінші партияның тоталы'; };
var bo_y33 = function (match, outcome) { return 'Отыз екінші партияның тоталы'; };
var bo_z33 = function (match, outcome) { return 'Отыз үшінші партияның тоталы'; };
var bo_a34 = function (match, outcome) { return 'Отыз төртінші партияның тоталы'; };
var bo_b34 = function (match, outcome) { return 'Отыз бесінші партияның тоталы'; };
var bo_c34 = function (match, outcome) { return 'Отыз алтыншы партияның тоталы'; };
var bo_d34 = function (match, outcome) { return 'Отыз жетінші партияның тоталы'; };
var bo_e34 = function (match, outcome) { return 'Бірінші партияда кім бірінші болып шар соғады?'; };
var bo_f34 = function (match, outcome) { return 'Екінші партияда кім бірінші болып шар соғады?'; };
var bo_g34 = function (match, outcome) { return 'Үшінші партияда кім бірінші болып шар соғады?'; };
var bo_h34 = function (match, outcome) { return 'Төртінші партияда кім бірінші болып шар соғады?'; };
var bo_i34 = function (match, outcome) { return 'Бесінші партияда кім бірінші болып шар соғады?'; };
var bo_j34 = function (match, outcome) { return 'Алтыншы партияда кім бірінші болып шар соғады?'; };
var bo_k34 = function (match, outcome) { return 'Матчтағы партиялар тоталы'; };
var bo_l34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_m34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_n34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_o34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_p34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_q34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_r34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_s34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_t34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_u34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_v34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_w34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_x34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_y34 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430"); };
var bo_z34 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_a35 = function (match, outcome) { return "".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_b35 = function (match, outcome) { return "".concat(match.homeTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_c35 = function (match, outcome) { return "".concat(match.homeTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_d35 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_e35 = function (match, outcome) { return "".concat(match.homeTeam, " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_f35 = function (match, outcome) { return "".concat(match.homeTeam, " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_g35 = function (match, outcome) { return "".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_h35 = function (match, outcome) { return "".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_i35 = function (match, outcome) { return "".concat(match.awayTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_j35 = function (match, outcome) { return "".concat(match.awayTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_k35 = function (match, outcome) { return "".concat(match.awayTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_l35 = function (match, outcome) { return "".concat(match.awayTeam, " \u0430\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_m35 = function (match, outcome) { return "".concat(match.awayTeam, " \u0436\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u0442\u0443\u0443\u0440\u0430 ").concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_n35 = function (match, outcome) { return 'Бірінші партияның дәл тоталы'; };
var bo_o35 = function (match, outcome) { return 'Екінші партияның дәл тоталы'; };
var bo_p35 = function (match, outcome) { return 'Үшінші партияның дәл тоталы'; };
var bo_q35 = function (match, outcome) { return 'Төртінші партияның дәл тоталы'; };
var bo_r35 = function (match, outcome) { return 'Бесінші партияның дәл тоталы'; };
var bo_s35 = function (match, outcome) { return 'Алтыншы партияның дәл тоталы'; };
var bo_t35 = function (match, outcome) { return 'Жетінші партияның дәл тоталы'; };
var bo_u35 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_v35 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_w35 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_x35 = function (match, outcome) { return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_y35 = function (match, outcome) { return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_z35 = function (match, outcome) { return "\u0410\u043B\u0442\u044B\u043D\u0448\u044B \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_a36 = function (match, outcome) { return "\u0416\u0435\u0442\u0456\u043D\u0448\u0456 \u043F\u0430\u0440\u0442\u0438\u044F\u0434\u0430 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_b36 = function (match, outcome) { return 'Жұп/бірінші кезеңнің тотал тағы'; };
var bo_c36 = function (match, outcome) { return 'Жұп/екінші кезеңнің тотал тағы'; };
var bo_d36 = function (match, outcome) { return 'Жұп/үшінші кезеңнің тотал тағы'; };
var bo_e36 = function (match, outcome) { return 'Жұп/төртінші кезеңнің тотал тағы'; };
var bo_f36 = function (match, outcome) { return 'Жұп/бесінші кезеңнің тотал тағы'; };
var bo_g36 = function (match, outcome) { return 'Жұп/алтыншы кезеңнің тотал тағы'; };
var bo_h36 = function (match, outcome) { return 'Жұп/жетінші кезеңнің тотал тағы'; };
var bo_i36 = function (match, outcome) { return 'Матчтың дәл есебі'; };
var bo_j36 = function (match, outcome) { return "".concat(match.awayTeam, " 1-\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u0431\u0440\u0435\u0439\u043A \u0436\u0430\u0441\u0430\u0439\u0434\u044B"); };
var bo_k36 = function (match, outcome) { return 'Теннисшімен қатарынан алынған геймдердің ең жоғарғы саны'; };
var bo_l36 = function (match, outcome) { return 'Брейктермен алмасу болады ма (екі қатар)?'; };
var bo_m36 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_n36 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_o36 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_p36 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_q36 = function (match, outcome) { return 'Төртінші сеттің жұп/тақ болуы'; };
var bo_r36 = function (match, outcome) { return 'Бесінші сеттің жұп/тақ болуы'; };
var bo_s36 = function (match, outcome) { return 'Бірінші сет/матч'; };
var bo_t36 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 \u0431\u0440\u0435\u0439\u043A \u043F\u043E\u0439\u043D\u0442 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?"); };
var bo_u36 = function (match, outcome) { return 'Екінші сеттің брейктердің тоталы'; };
var bo_v36 = function (match, outcome) { return 'Үшінші сеттің брейктердің тоталы'; };
var bo_w36 = function (match, outcome) { return 'Төртінші сеттің брейктердің тоталы'; };
var bo_x36 = function (match, outcome) { return 'Бесінші сеттің брейктердің тоталы'; };
var bo_y36 = function (match, outcome) { return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B ".concat(outcome.condition); };
var bo_z36 = function (match, outcome) { return "\u0416\u0435\u04A3\u0456\u0441 \u0436\u04D9\u043D\u0435 \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B ".concat(outcome.condition); };
var bo_a37 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_b37 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.homeTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_c37 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.homeTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_d37 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.homeTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_e37 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.homeTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_f37 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.awayTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_g37 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.awayTeam, " \u0435\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_h37 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.awayTeam, " \u04AF\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_i37 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.awayTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_j37 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.awayTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435"); };
var bo_k37 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ".concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_l37 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ".concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_m37 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ".concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_n37 = function (match, outcome) { return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ".concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_o37 = function (match, outcome) { return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u04D9\u043B\u0434\u0435\u043A\u0456\u043C \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ".concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_p37 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 ".concat(match.homeTeam, " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ").concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_q37 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 ".concat(match.homeTeam, " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ").concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_r37 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 ".concat(match.homeTeam, " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ").concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_s37 = function (match, outcome) { return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 ".concat(match.homeTeam, " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ").concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_t37 = function (match, outcome) { return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 ".concat(match.homeTeam, " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ").concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_u37 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 ".concat(match.awayTeam, " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ").concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_v37 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 ".concat(match.awayTeam, " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ").concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_w37 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 ".concat(match.awayTeam, " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ").concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_x37 = function (match, outcome) { return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 ".concat(match.awayTeam, " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ").concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_y37 = function (match, outcome) { return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 ".concat(match.awayTeam, " \u049B\u0430\u0442\u0430\u0440\u044B\u043D\u0430\u043D ").concat(outcome.condition, " \u0433\u0435\u0439\u043C \u04B1\u0442\u0430\u0434\u044B \u043C\u0430?"); };
var bo_z37 = function (match, outcome) { return 'Төртінші сеттегі фора'; };
var bo_a38 = function (match, outcome) { return 'Бесінші сеттегі фора'; };
var bo_b38 = function (match, outcome) { return 'Төртінші сеттің тоталы'; };
var bo_c38 = function (match, outcome) { return 'Бесінші сеттің тоталы'; };
var bo_d38 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u043D\u0456\u04A3 \u0434\u04D9\u043B \u0435\u0441\u0435\u0431\u0456"); };
var bo_e38 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0456 \u043A\u0456\u043C \u0430\u043B\u0430\u0434\u044B?"); };
var bo_f38 = function (match, outcome) { return 'Бірінші сеттің дәл есебі'; };
var bo_g38 = function (match, outcome) { return 'Екінші сеттің дәл есебі'; };
var bo_h38 = function (match, outcome) { return 'Үшінші сеттің дәл есебі'; };
var bo_i38 = function (match, outcome) { return 'Төртінші сеттің дәл есебі'; };
var bo_j38 = function (match, outcome) { return 'Бесінші сеттің дәл есебі'; };
var bo_k38 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 15x15 \u0431\u043E\u043B\u0430 \u043C\u0430?"); };
var bo_l38 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 30x30 \u0431\u043E\u043B\u0430 \u043C\u0430?"); };
var bo_m38 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 40x40 \u0431\u043E\u043B\u0430 \u043C\u0430?"); };
var bo_n38 = function (match, outcome) { return "\u0411\u0456\u0440\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B"); };
var bo_o38 = function (match, outcome) { return "\u0415\u043A\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B"); };
var bo_p38 = function (match, outcome) { return "\u04AE\u0448\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B"); };
var bo_q38 = function (match, outcome) { return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B"); };
var bo_r38 = function (match, outcome) { return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u043A\u0456\u043C ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0456 \u0430\u043B\u0430\u0434\u044B"); };
var bo_s38 = function (match, outcome) { return 'Төртінші сет нәтижесі'; };
var bo_t38 = function (match, outcome) { return 'Бесінші сет нәтижесі'; };
var bo_u38 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 \u043A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u04B1\u0442\u044B\u0441\u0442\u044B \u0430\u043B\u0430\u0434\u044B?"); };
var bo_v38 = function (match, outcome) { return 'Бірінші сетте тай-брейк бола ма?'; };
var bo_w38 = function (match, outcome) { return 'Екінші сетте тай-брейк бола ма?'; };
var bo_x38 = function (match, outcome) { return 'Үшінші сетте тай-брейк бола ма?'; };
var bo_y38 = function (match, outcome) { return 'Төртінші сетте тай-брейк бола ма?'; };
var bo_z38 = function (match, outcome) { return 'Бесінші сетте тай-брейк бола ма?'; };
var bo_a39 = function (match, outcome) { return 'Матчта тай-брейк болады ма?'; };
var bo_b39 = function (match, outcome) { return 'Бірінші сеттегі тай-брейктің тоталы'; };
var bo_c39 = function (match, outcome) { return 'Екінші сеттегі тай-брейктің тоталы'; };
var bo_d39 = function (match, outcome) { return 'Үшінші сеттегі тай-брейктің тоталы'; };
var bo_e39 = function (match, outcome) { return 'Төртінші сеттегі тай-брейктің тоталы'; };
var bo_f39 = function (match, outcome) { return 'Бесінші сеттегі тай-брейктің тоталы'; };
var bo_g39 = function (match, outcome) { return 'Бірінші сеттегі тай-брейктің дәл есебі'; };
var bo_h39 = function (match, outcome) { return 'Екінші сеттегі тай-брейктің дәл есебі'; };
var bo_i39 = function (match, outcome) { return 'Үшінші сеттегі тай-брейктің дәл есебі'; };
var bo_j39 = function (match, outcome) { return 'Төртінші сеттегі тай-брейктің дәл есебі'; };
var bo_k39 = function (match, outcome) { return 'Бесінші сеттегі тай-брейктің дәл есебі'; };
var bo_l39 = function (match, outcome) { return 'Бірінші сеттегі тай-брейктің дәл тоталы'; };
var bo_m39 = function (match, outcome) { return 'Екінші сеттегі тай-брейктің дәл тоталы'; };
var bo_n39 = function (match, outcome) { return 'Үшінші сеттегі тай-брейктің дәл тоталы'; };
var bo_o39 = function (match, outcome) { return 'Төртінші сеттегі тай-брейктің дәл тоталы'; };
var bo_p39 = function (match, outcome) { return 'Бесінші сеттегі тай-брейктің дәл тоталы'; };
var bo_q39 = function (match, outcome) { return 'Бірінші сетте тай-брейкте кім жеңеді?'; };
var bo_r39 = function (match, outcome) { return 'Екінші сетте тай-брейкте кім жеңеді?'; };
var bo_s39 = function (match, outcome) { return 'Үшінші сетте тай-брейкте кім жеңеді?'; };
var bo_t39 = function (match, outcome) { return 'Төртінші сетте тай-брейкте кім жеңеді?'; };
var bo_u39 = function (match, outcome) { return 'Бесінші сетте тай-брейкте кім жеңеді?'; };
var bo_v39 = function (match, outcome) { return 'Бірінші сеттің брейктердің тоталы'; };
var bo_w39 = function (match, outcome) { return 'Матчтағы брейктердің тоталы'; };
var bo_x39 = function (match, outcome) { return "".concat(match.homeTeam, " \u043C\u0430\u0442\u0447\u0442\u0430 \u0441\u0435\u0442\u0442\u0456 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_y39 = function (match, outcome) { return "".concat(match.awayTeam, " \u043C\u0430\u0442\u0447\u0442\u0430 \u0441\u0435\u0442\u0442\u0456 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_z39 = function (match, outcome) { return 'Ең нәтижесіз сеттің тоталы'; };
var bo_a40 = function (match, outcome) { return 'Матчта кім бірінші эйсті береді'; };
var bo_b40 = function (match, outcome) { return 'Матчта кім бірінші қосарлы қателікті жасайды'; };
var bo_c40 = function (match, outcome) { return "".concat(match.homeTeam, ": \u0431\u0435\u0440\u0443\u0434\u0456\u04A3 \u0435\u04A3 \u0436\u043E\u0493\u0430\u0440\u0493\u044B \u0436\u044B\u043B\u0434\u0430\u043C\u0434\u044B\u0493\u044B (\u043A\u043C/\u0441)"); };
var bo_d40 = function (match, outcome) { return "".concat(match.awayTeam, ": \u0431\u0435\u0440\u0443\u0434\u0456\u04A3 \u0435\u04A3 \u0436\u043E\u0493\u0430\u0440\u0493\u044B \u0436\u044B\u043B\u0434\u0430\u043C\u0434\u044B\u0493\u044B (\u043A\u043C/\u0441)"); };
var bo_e40 = function (match, outcome) { return 'Бірінші сеттің ұтылысынан кейін матчтағы жеңіс'; };
var bo_f40 = function (match, outcome) { return "".concat(match.homeTeam, ": \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u0435\u0440\u0443 %;"); };
var bo_g40 = function (match, outcome) { return "".concat(match.awayTeam, ": \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u0435\u0440\u0443 %;"); };
var bo_h40 = function (match, outcome) { return 'Матчта кім көп брейк жасайды'; };
var bo_i40 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.homeTeam); };
var bo_j40 = function (match, outcome) { return "\u0411\u0440\u0435\u0439\u043A\u0442\u0435\u0440\u0434\u0456\u04A3 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.awayTeam); };
var bo_k40 = function (match, outcome) { return 'Матчта кім бірінші брейкті жасайды'; };
var bo_l40 = function (match, outcome) { return "".concat(match.homeTeam, " 1-\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u0431\u0440\u0435\u0439\u043A \u0436\u0430\u0441\u0430\u0439\u0434\u044B"); };
var bo_m40 = function (match, outcome) { return 'Матчта 6:0 немесе 0:6 есеппен сет болады ма?'; };
var bo_n40 = function (match, outcome) { return "\u041A\u0456\u043C ".concat(outcome.condition, " \u0433\u0435\u0439\u043C \u0430\u043B\u0430\u0434\u044B?"); };
var bo_o40 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 15x15 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?"); };
var bo_p40 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 30x30 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?"); };
var bo_q40 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 40x40 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?"); };
var bo_r40 = function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u04B1\u043F\u0430\u0439"); };
var bo_s40 = function (match, outcome) { return " ".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u04B1\u043F\u0430\u0439"); };
var bo_t40 = function (match, outcome) { return 'Матчтағы эйстер тоталы'; };
var bo_u40 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u0430\u0493\u044B \u044D\u0439\u0441\u0442\u0435\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.homeTeam); };
var bo_v40 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u0430\u0493\u044B \u044D\u0439\u0441\u0442\u0435\u0440 \u0442\u043E\u0442\u0430\u043B\u044B: ".concat(match.awayTeam); };
var bo_w40 = function (match, outcome) { return 'Матчтағы қос қателер тоталы'; };
var bo_x40 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u0430\u0493\u044B \u049B\u043E\u0441 \u049B\u0430\u0442\u0435\u043B\u0435\u0440 \u0442\u043E\u0442\u0430\u043B\u044B : ".concat(match.homeTeam); };
var bo_y40 = function (match, outcome) { return "\u041C\u0430\u0442\u0447\u0442\u0430\u0493\u044B \u049B\u043E\u0441 \u049B\u0430\u0442\u0435\u043B\u0435\u0440 \u0442\u043E\u0442\u0430\u043B\u044B : ".concat(match.awayTeam); };
var bo_z40 = function (match, outcome) { return 'Сеттер (Тотал) нәтижелілігі'; };
var bo_a41 = function (match, outcome) { return 'Матчта өтіп шығу беріспен жеңеді'; };
var bo_b41 = function (match, outcome) { return "1-\u0456\u043D\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u043D\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u044D\u0439\u0441: ".concat(match.homeTeam); };
var bo_c41 = function (match, outcome) { return "1-\u0456\u043D\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u043D\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u044D\u0439\u0441: ".concat(match.awayTeam); };
var bo_d41 = function (match, outcome) { return "1-\u0456\u043D\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u043D\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u049B\u043E\u0441 \u049B\u0430\u0442\u0435: ".concat(match.homeTeam); };
var bo_e41 = function (match, outcome) { return "1-\u0456\u043D\u0448\u0456 \u043D\u0435\u043C\u0435\u0441\u0435 2-\u043D\u0448\u0456 \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u049B\u043E\u0441 \u049B\u0430\u0442\u0435: ".concat(match.awayTeam); };
var bo_f41 = function (match, outcome) { return 'Бірінші сетте эйс тоталы'; };
var bo_g41 = function (match, outcome) { return 'Матч барысында споршы шығады (дискв.)'; };
var bo_h41 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u0435\u0440\u0456\u0441\u0442\u0456\u04A3 \u0442\u0438\u0433\u0456\u0437\u0443 %"); };
var bo_i41 = function (match, outcome) { return "".concat(match.awayTeam, "  \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u0435\u0440\u0456\u0441\u0442\u0456\u04A3 \u0442\u0438\u0433\u0456\u0437\u0443 %"); };
var bo_j41 = function (match, outcome) { return 'Бірінші сетте брейктерден нәтиже'; };
var bo_k41 = function (match, outcome) { return 'Екінші сетте брейктерден нәтиже'; };
var bo_l41 = function (match, outcome) { return 'Үшінші сетте брейктерден нәтиже'; };
var bo_m41 = function (match, outcome) { return 'Төртінші сетте брейктерден нәтиже'; };
var bo_n41 = function (match, outcome) { return 'Бесінші сетте брейктерден нәтиже'; };
var bo_o41 = function (match, outcome) { return 'Матчтағы брейктерден фора'; };
var bo_p41 = function (match, outcome) { return 'Бірінші сетте брейктерден фора'; };
var bo_q41 = function (match, outcome) { return 'Екінші сетте брейктерден фора'; };
var bo_r41 = function (match, outcome) { return 'Үшінші сетте брейктерден фора'; };
var bo_s41 = function (match, outcome) { return 'Төртінші сетте брейктерден фора'; };
var bo_t41 = function (match, outcome) { return 'Бесінші сетте брейктерден фора'; };
var bo_u41 = function (match, outcome) { return "\u041A\u0456\u043C ".concat(outcome.conditionTwo, " \u04B1\u043F\u0430\u0439\u0434\u044B ").concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 \u0430\u043B\u0430\u0434\u044B"); };
var bo_v41 = function (match, outcome) { return "".concat(outcome.condition, " \u0436\u04D9\u043D\u0435 ").concat(outcome.conditionTwo, " \u0433\u0435\u0439\u043C\u0434\u0435\u0440\u0434\u0435 \u043D\u04D9\u0442\u0438\u0436\u0435"); };
var bo_w41 = function (match, outcome) { return "".concat(outcome.conditionTwo, " \u0433\u0435\u0439\u043C\u0434\u0435 \u0444\u043E\u0440\u0430"); };
var bo_x41 = function (match, outcome) { return "".concat(outcome.conditionTwo, " \u0433\u0435\u0439\u043C\u0434\u0435 \u0442\u043E\u0442\u0430\u043B"); };
var bo_y41 = function (match, outcome) { return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?"); };
var bo_z41 = function (match, outcome) { return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(outcome.condition, " \u04B1\u043F\u0430\u0439\u0434\u044B \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0430\u043B\u0430\u0434\u044B?"); };
var bo_a42 = function (match, outcome) { return 'Төртінші сеттің дәл тоталы'; };
var bo_b42 = function (match, outcome) { return 'Бесінші сеттің дәл тоталы'; };
var bo_c42 = function (match, outcome) { return "".concat(match.homeTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_d42 = function (match, outcome) { return "".concat(match.homeTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_e42 = function (match, outcome) { return "".concat(match.awayTeam, " \u0442\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_f42 = function (match, outcome) { return "".concat(match.awayTeam, " \u0431\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B\u043F\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); };
var bo_g42 = function (match, outcome) { return 'Ең нәтижелі сеттің тоталы'; };
var bo_h42 = function (match, outcome) { return 'Төртінші сетте айырмашылықпен жеңіс'; };
var bo_i42 = function (match, outcome) { return 'Бесінші сетте айырмашылықпен жеңіс'; };
var bo_j42 = function (match, outcome) { return 'Бірінші сеттің 10 ұпайға дейін шағын сетте жеңіс'; };
var bo_k42 = function (match, outcome) { return 'Екінші сеттің 10 ұпайға дейін шағын сетте жеңіс'; };
var bo_l42 = function (match, outcome) { return 'Үшінші сеттің 10 ұпайға дейін шағын сетте жеңіс'; };
var bo_m42 = function (match, outcome) { return 'Төртінші сеттің 10 ұпайға дейін шағын сетте жеңіс'; };
var bo_n42 = function (match, outcome) { return 'Бірінші сеттің 10 ұпайына дейін шағын сетте фора'; };
var bo_o42 = function (match, outcome) { return 'Екінші сеттің 10 ұпайына дейін шағын сетте фора'; };
var bo_p42 = function (match, outcome) { return 'Үшінші сеттің 10 ұпайына дейін шағын сетте фора'; };
var bo_q42 = function (match, outcome) { return 'Төртінші сеттің 10 ұпайына дейін шағын сетте фора'; };
var bo_r42 = function (match, outcome) { return 'Бірінші сеттің 10 ұпайына дейін шағын сетте тотал'; };
var bo_s42 = function (match, outcome) { return 'Екінші сеттің 10 ұпайына дейін шағын сетте тотал'; };
var bo_t42 = function (match, outcome) { return 'Үшінші сеттің 10 ұпайына дейін шағын сетте тотал'; };
var bo_u42 = function (match, outcome) { return 'Төртінші сеттің 10 ұпайына дейін шағын сетте тотал'; };
var bo_v42 = function (match, outcome) { return 'Бірінші сеттің 15 ұпайына дейін шағын сетте жеңіс'; };
var bo_w42 = function (match, outcome) { return 'Екінші сеттің 15 ұпайына дейін шағын сетте жеңіс'; };
var bo_x42 = function (match, outcome) { return 'Үшінші сеттің 15 ұпайына дейін шағын сетте жеңіс'; };
var bo_y42 = function (match, outcome) { return 'Төртінші сеттің 15 ұпайына дейін шағын сетте жеңіс'; };
var bo_z42 = function (match, outcome) { return 'Бірінші сеттің 15 ұпайына дейін шағын сетте фора'; };
var bo_a43 = function (match, outcome) { return 'Екінші сеттің 15 ұпайына дейін шағын сетте фора'; };
var bo_b43 = function (match, outcome) { return 'Үшінші сеттің 15 ұпайына дейін шағын сетте фора'; };
var bo_c43 = function (match, outcome) { return 'Төртінші сеттің 15 ұпайына дейін шағын сетте фора'; };
var bo_d43 = function (match, outcome) { return 'Бірінші сеттің 15 ұпайына дейін шағын сетте тотал'; };
var bo_e43 = function (match, outcome) { return 'Екінші сеттің 15 ұпайына дейін шағын сетте тотал'; };
var bo_f43 = function (match, outcome) { return 'Үшінші сеттің 15 ұпайына дейін шағын сетте тотал'; };
var bo_g43 = function (match, outcome) { return 'Төртінші сеттің 15 ұпайына дейін шағын сетте тотал'; };
var bo_h43 = function (match, outcome) { return "\u0422\u04E9\u0440\u0442\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_i43 = function (match, outcome) { return "\u0411\u0435\u0441\u0456\u043D\u0448\u0456 \u0441\u0435\u0442\u0442\u0435 \u043A\u0456\u043C ".concat(numeralNeuterEnding(outcome.condition), " \u04B1\u043F\u0430\u0439 \u04B1\u0442\u0430\u0434\u044B"); };
var bo_j43 = function (match, outcome) { return 'Алтын сетте фора'; };
var bo_k43 = function (match, outcome) { return 'Алтын сет тоталы'; };
var bo_l43 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.homeTeam, "\u0410\u043B\u0442\u044B\u043D \u0441\u0435\u0442\u0442\u0435"); };
var bo_m43 = function (match, outcome) { return "\u0422\u043E\u0442\u0430\u043B: ".concat(match.awayTeam, " \u0410\u043B\u0442\u044B\u043D \u0441\u0435\u0442\u0442\u0435"); };
var bo_n43 = function (match, outcome) { return 'Алтын сет нәтижесі'; };
var bo_o43 = function (match, outcome) { return "\u041A\u0456\u043C \u0431\u0456\u0440\u0456\u043D\u0448\u0456 \u0431\u043E\u043B\u044B\u043F \u0410\u043B\u0442\u044B\u043D \u0441\u0435\u0442\u0442\u0435 ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ұпай', 'ұпайлар', 'ұпайлар']), " \u0430\u043B\u0430\u0434\u044B"); };
var bo_p43 = function (match, outcome) { return 'Алтын сеттің дәл тоталы'; };
var bo_q43 = function (match, outcome) { return 'Алтын сеттің жұп/тақ'; };
var bo_r43 = function (match, outcome) { return "\u0410\u043B\u0442\u044B\u043D \u0441\u0435\u0442\u0442\u0456\u04A3 \u0436\u0435\u04A3\u0456\u0441\u0456 \u0436\u04D9\u043D\u0435 \u0442\u043E\u0442\u0430\u043B\u044B ".concat(outcome.condition); };
var bo_s43 = function (match, outcome) { return 'Алтын сетте айырмашылықпен жеңіс'; };
var bo_t43 = function (match, outcome) { return 'Неше сетте шағын тай-брейк болады?'; };
var bo_u43 = function (match, outcome) { return "".concat(outcome.condition, " \u0440\u0430\u0443\u043D\u0434\u0442\u044B \u043A\u0456\u043C \u0436\u0435\u04A3\u0435\u0434\u0456?"); };
var bo_v43 = function (match, outcome) { return 'Выпадет ли 13 сектор?'; };
var bo_w43 = function (match, outcome) { return "\u0412\u044B\u043F\u0430\u0434\u0435\u0442 \u043B\u0438 13 \u0441\u0435\u043A\u0442\u043E\u0440 \u0432 ".concat(outcome.condition, "-\u043C \u0440\u0430\u0443\u043D\u0434\u0435?"); };
var fa_b1 = function (match, outcome) { return "\u04241(".concat(signed(outcome.condition), ")"); };
var fa_c1 = function (match, outcome) { return "\u04242(".concat(signed(-outcome.condition), ")"); };
var fa_d1 = function (match, outcome) { return "\u0410\u0437 ".concat(outcome.condition); };
var fa_e1 = function (match, outcome) { return "\u041A\u04E9\u043F ".concat(outcome.condition); };
var fa_f1 = function (match, outcome) { return "".concat(outcome.condition, " \u0430\u0437"); };
var fa_g1 = function (match, outcome) { return "".concat(outcome.condition, " \u043A\u04E9\u043F"); };
var fa_h1 = function (match, outcome) { return 'Жұп'; };
var fa_i1 = function (match, outcome) { return 'Тақ'; };
var fa_j1 = function (match, outcome) { return 'Ж1'; };
var fa_k1 = function (match, outcome) { return 'Ж2'; };
var fa_l1 = function (match, outcome) { return '1-інші жоғары'; };
var fa_m1 = function (match, outcome) { return '2-нші жоғары'; };
var fa_n1 = function (match, outcome) { return 'Иә'; };
var fa_o1 = function (match, outcome) { return 'Жоқ'; };
var fa_p1 = function (match, outcome) { return "\u041A\u04E9\u043F".concat(outcome.condition); };
var fa_q1 = function (match, outcome) { return '0-2'; };
var fa_r1 = function (match, outcome) { return '0-3'; };
var fa_s1 = function (match, outcome) { return '1-2'; };
var fa_t1 = function (match, outcome) { return '1-3'; };
var fa_u1 = function (match, outcome) { return '2-0'; };
var fa_v1 = function (match, outcome) { return '2-1'; };
var fa_w1 = function (match, outcome) { return '2-3'; };
var fa_x1 = function (match, outcome) { return '3-0'; };
var fa_y1 = function (match, outcome) { return '3-1'; };
var fa_z1 = function (match, outcome) { return '3-2'; };
var fa_a2 = function (match, outcome) { return "".concat(match.homeTeam); };
var fa_b2 = function (match, outcome) { return "".concat(match.awayTeam); };
var fa_c2 = function (match, outcome) { return 'Х'; };
var fa_d2 = function (match, outcome) { return 'Ешкім'; };
var fa_e2 = function (match, outcome) { return '1X'; };
var fa_f2 = function (match, outcome) { return '12'; };
var fa_g2 = function (match, outcome) { return '2X'; };
var fa_h2 = function (match, outcome) { return "\u04161\u0422\u0430 ".concat(outcome.condition); };
var fa_i2 = function (match, outcome) { return "\u04161\u0422\u043A ".concat(outcome.condition); };
var fa_j2 = function (match, outcome) { return "\u04162\u0422\u0430 ".concat(outcome.condition); };
var fa_k2 = function (match, outcome) { return "\u04162\u0422\u043A ".concat(outcome.condition); };
var fa_l2 = function (match, outcome) { return "\u0425\u0422\u0430 ".concat(outcome.condition); };
var fa_m2 = function (match, outcome) { return "\u0425\u0422\u043A ".concat(outcome.condition); };
var fa_n2 = function (match, outcome) { return '0'; };
var fa_o2 = function (match, outcome) { return '1'; };
var fa_p2 = function (match, outcome) { return '2'; };
var fa_q2 = function (match, outcome) { return '3'; };
var fa_r2 = function (match, outcome) { return '4'; };
var fa_s2 = function (match, outcome) { return '≥ 5'; };
var fa_t2 = function (match, outcome) { return 'Екі команда соғады'; };
var fa_u2 = function (match, outcome) { return 'Тура бір команда соғады'; };
var fa_v2 = function (match, outcome) { return 'Екі команда соөқпайды'; };
var fa_w2 = function (match, outcome) { return '0-0'; };
var fa_x2 = function (match, outcome) { return '0-1'; };
var fa_y2 = function (match, outcome) { return '0-4'; };
var fa_z2 = function (match, outcome) { return '0-5'; };
var fa_a3 = function (match, outcome) { return '1-0'; };
var fa_b3 = function (match, outcome) { return '1-1'; };
var fa_c3 = function (match, outcome) { return '1-4'; };
var fa_d3 = function (match, outcome) { return '1-5'; };
var fa_e3 = function (match, outcome) { return '2-2'; };
var fa_f3 = function (match, outcome) { return '2-4'; };
var fa_g3 = function (match, outcome) { return '2-5'; };
var fa_h3 = function (match, outcome) { return '2-6'; };
var fa_i3 = function (match, outcome) { return '3-3'; };
var fa_j3 = function (match, outcome) { return '3-4'; };
var fa_k3 = function (match, outcome) { return '3-5'; };
var fa_l3 = function (match, outcome) { return '4-0'; };
var fa_m3 = function (match, outcome) { return '4-1'; };
var fa_n3 = function (match, outcome) { return '4-2'; };
var fa_o3 = function (match, outcome) { return '4-3'; };
var fa_p3 = function (match, outcome) { return '4-4'; };
var fa_q3 = function (match, outcome) { return '5-0'; };
var fa_r3 = function (match, outcome) { return '5-1'; };
var fa_s3 = function (match, outcome) { return '5-2'; };
var fa_t3 = function (match, outcome) { return '5-3'; };
var fa_u3 = function (match, outcome) { return 'Кез келген басқа'; };
var fa_v3 = function (match, outcome) { return "\u2264 ".concat(outcome.condition); };
var fa_w3 = function (match, outcome) { return "".concat(outcome.condition + 1, " - ").concat(outcome.condition + 2); };
var fa_x3 = function (match, outcome) { return "".concat(outcome.condition + 3, " - ").concat(outcome.condition + 4); };
var fa_y3 = function (match, outcome) { return "".concat(outcome.condition + 5, " - ").concat(outcome.condition + 6); };
var fa_z3 = function (match, outcome) { return "".concat(outcome.condition + 7, " - ").concat(outcome.condition + 8); };
var fa_a4 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 9); };
var fa_b4 = function (match, outcome) { return '6-9'; };
var fa_c4 = function (match, outcome) { return '10-12'; };
var fa_d4 = function (match, outcome) { return '13-16'; };
var fa_e4 = function (match, outcome) { return '17-20'; };
var fa_f4 = function (match, outcome) { return '≥21'; };
var fa_g4 = function (match, outcome) { return "\u04E8\u0442\u0443: ".concat(match.homeTeam); };
var fa_h4 = function (match, outcome) { return "\u04E8\u0442\u0443: ".concat(match.awayTeam); };
var fa_i4 = function (match, outcome) { return '1-ші жарты'; };
var fa_j4 = function (match, outcome) { return '2-ші жарты'; };
var fa_k4 = function (match, outcome) { return '1-ші ширек'; };
var fa_l4 = function (match, outcome) { return '2-ші ширек'; };
var fa_m4 = function (match, outcome) { return '3-ші ширек'; };
var fa_n4 = function (match, outcome) { return '4-ші ширек'; };
var fa_o4 = function (match, outcome) { return 'Ж1: 1-2'; };
var fa_p4 = function (match, outcome) { return 'Ж1: 3-5'; };
var fa_q4 = function (match, outcome) { return 'Ж1: 6-9'; };
var fa_r4 = function (match, outcome) { return 'Ж1: 10-12'; };
var fa_s4 = function (match, outcome) { return 'Ж1: 13-16'; };
var fa_t4 = function (match, outcome) { return 'Ж1: 17-20'; };
var fa_u4 = function (match, outcome) { return 'Ж1: ≥21'; };
var fa_v4 = function (match, outcome) { return 'Ж2: 1-2'; };
var fa_w4 = function (match, outcome) { return 'Ж2: 3-5'; };
var fa_x4 = function (match, outcome) { return 'Ж2: 6-9'; };
var fa_y4 = function (match, outcome) { return 'Ж2: 10-12'; };
var fa_z4 = function (match, outcome) { return 'Ж2: 13-16'; };
var fa_a5 = function (match, outcome) { return 'Ж2: 17-20'; };
var fa_b5 = function (match, outcome) { return 'Ж2: ≥21'; };
var fa_c5 = function (match, outcome) { return 'Ж1: 3-4'; };
var fa_d5 = function (match, outcome) { return 'Ж1: 5-7'; };
var fa_e5 = function (match, outcome) { return 'Ж1: ≥8'; };
var fa_f5 = function (match, outcome) { return 'Х2'; };
var fa_g5 = function (match, outcome) { return 'Ж2: 3-4'; };
var fa_h5 = function (match, outcome) { return 'Ж2: 5-7'; };
var fa_i5 = function (match, outcome) { return 'Ж2: ≥8'; };
var fa_j5 = function (match, outcome) { return 'Х1'; };
var fa_k5 = function (match, outcome) { return '1-інші ширек'; };
var fa_l5 = function (match, outcome) { return '2-нші ширек'; };
var fa_m5 = function (match, outcome) { return '3-інші ширек'; };
var fa_n5 = function (match, outcome) { return '4-інші ширек'; };
var fa_o5 = function (match, outcome) { return 'Айыппұл доп'; };
var fa_p5 = function (match, outcome) { return '3-ұпайлық'; };
var fa_q5 = function (match, outcome) { return '2-ұпайлық'; };
var fa_r5 = function (match, outcome) { return "\u04161 \u2265 ".concat(outcome.condition); };
var fa_s5 = function (match, outcome) { return "\u0410\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u049B ".concat(outcome.condition, " \u0430\u0437"); };
var fa_t5 = function (match, outcome) { return "\u04162 \u2265 ".concat(outcome.condition); };
var fa_u5 = function (match, outcome) { return "\u04161: ".concat(outcome.condition, " \u043A\u04E9\u043F =21"); };
var fa_v5 = function (match, outcome) { return "\u04162:".concat(outcome.condition, " \u043A\u04E9\u043F=21"); };
var fa_w5 = function (match, outcome) { return 'Ж1: 8 және одан көп'; };
var fa_x5 = function (match, outcome) { return 'Ж2: 8 және одан көп'; };
var fa_y5 = function (match, outcome) { return '1-інші жартылық'; };
var fa_z5 = function (match, outcome) { return '2-нші жартылық'; };
var fa_a6 = function (match, outcome) { return 'Ешқандай'; };
var fa_b6 = function (match, outcome) { return 'жұп'; };
var fa_c6 = function (match, outcome) { return 'тақ'; };
var fa_d6 = function (match, outcome) { return 'Ж1: 1'; };
var fa_e6 = function (match, outcome) { return 'Ж1: 2'; };
var fa_f6 = function (match, outcome) { return 'Ж1: 3'; };
var fa_g6 = function (match, outcome) { return 'Ж1: 4'; };
var fa_h6 = function (match, outcome) { return 'Ж1: ≥ 5'; };
var fa_i6 = function (match, outcome) { return 'Ж2: 1'; };
var fa_j6 = function (match, outcome) { return 'Ж2: 2'; };
var fa_k6 = function (match, outcome) { return 'Ж2: 3'; };
var fa_l6 = function (match, outcome) { return 'Ж2: 4'; };
var fa_m6 = function (match, outcome) { return 'Ж2: ≥ 5'; };
var fa_n6 = function (match, outcome) { return '1Х'; };
var fa_o6 = function (match, outcome) { return 'Екеуі де'; };
var fa_p6 = function (match, outcome) { return 'Бір'; };
var fa_q6 = function (match, outcome) { return 'Ешқайсысы'; };
var fa_r6 = function (match, outcome) { return '0 немесе 1'; };
var fa_s6 = function (match, outcome) { return '5'; };
var fa_t6 = function (match, outcome) { return '6'; };
var fa_u6 = function (match, outcome) { return '7'; };
var fa_v6 = function (match, outcome) { return '≥ 8'; };
var fa_w6 = function (match, outcome) { return 'Ж1Ж1'; };
var fa_x6 = function (match, outcome) { return 'Ж1Ж'; };
var fa_y6 = function (match, outcome) { return 'Ж1Ж2'; };
var fa_z6 = function (match, outcome) { return 'НЖ1'; };
var fa_a7 = function (match, outcome) { return 'НН'; };
var fa_b7 = function (match, outcome) { return 'НЖ2'; };
var fa_c7 = function (match, outcome) { return 'Ж2Ж1'; };
var fa_d7 = function (match, outcome) { return 'Ж2Н'; };
var fa_e7 = function (match, outcome) { return 'Ж2Ж2'; };
var fa_f7 = function (match, outcome) { return "".concat(outcome.condition + 1); };
var fa_g7 = function (match, outcome) { return "".concat(outcome.condition + 2); };
var fa_h7 = function (match, outcome) { return "".concat(outcome.condition + 3); };
var fa_i7 = function (match, outcome) { return "".concat(outcome.condition + 4); };
var fa_j7 = function (match, outcome) { return "".concat(outcome.condition + 5); };
var fa_k7 = function (match, outcome) { return "".concat(outcome.condition + 6); };
var fa_l7 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 7); };
var fa_m7 = function (match, outcome) { return "".concat(outcome.condition + 1, " - ").concat(outcome.condition + 2, " \u0434\u0435\u0439\u0456\u043D"); };
var fa_n7 = function (match, outcome) { return "".concat(outcome.condition + 3, " - ").concat(outcome.condition + 4, " \u0434\u0435\u0439\u0456\u043D"); };
var fa_o7 = function (match, outcome) { return "".concat(outcome.condition + 5, " - ").concat(outcome.condition + 6, " \u0434\u0435\u0439\u0456\u043D"); };
var fa_p7 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 7, " \u0436\u04D9\u043D\u0435 \u043E\u0434\u0430\u043D \u0430\u0441\u0430\u0434\u044B"); };
var fa_q7 = function (match, outcome) { return '44960'; };
var fa_r7 = function (match, outcome) { return '45022'; };
var fa_s7 = function (match, outcome) { return '7 және одан асады'; };
var fa_t7 = function (match, outcome) { return '4-6'; };
var fa_u7 = function (match, outcome) { return 'Ж1Та'; };
var fa_v7 = function (match, outcome) { return 'Ж1Тк'; };
var fa_w7 = function (match, outcome) { return 'Ж2Та'; };
var fa_x7 = function (match, outcome) { return 'Ж2Тк'; };
var fa_y7 = function (match, outcome) { return '1-ші көп'; };
var fa_z7 = function (match, outcome) { return '2-нші көп'; };
var fa_a8 = function (match, outcome) { return 'Ж1: 2-3'; };
var fa_b8 = function (match, outcome) { return 'Ж1: 4-6'; };
var fa_c8 = function (match, outcome) { return 'Ж1: ≥7'; };
var fa_d8 = function (match, outcome) { return 'Ж2: 2-3'; };
var fa_e8 = function (match, outcome) { return 'Ж2: 4-6'; };
var fa_f8 = function (match, outcome) { return 'Ж2: ≥7'; };
var fa_g8 = function (match, outcome) { return "".concat(outcome.condition); };
var fa_h8 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 6); };
var fa_i8 = function (match, outcome) { return 'Ж1: мерзімнен бұрын жеңу'; };
var fa_j8 = function (match, outcome) { return 'Ж1: ұпайдан жеңу'; };
var fa_k8 = function (match, outcome) { return 'Тең'; };
var fa_l8 = function (match, outcome) { return 'Ж2: мерзімнен бұрын жеңу'; };
var fa_m8 = function (match, outcome) { return 'Ж2: ұпайдан жеңу'; };
var fa_n8 = function (match, outcome) { return 'Ж1: 1 раунд'; };
var fa_o8 = function (match, outcome) { return 'Ж1: 2 раунд'; };
var fa_p8 = function (match, outcome) { return 'Ж1: 3 раунд'; };
var fa_q8 = function (match, outcome) { return 'ЖЖ1: 4 раунд'; };
var fa_r8 = function (match, outcome) { return 'Ж1: 5 раунд'; };
var fa_s8 = function (match, outcome) { return 'Ж1: 6 раунд'; };
var fa_t8 = function (match, outcome) { return 'Ж1: 7 раунд'; };
var fa_u8 = function (match, outcome) { return 'Ж1: 8 раунд'; };
var fa_v8 = function (match, outcome) { return 'Ж1: 9 раунд'; };
var fa_w8 = function (match, outcome) { return 'Ж1: 10 раунд'; };
var fa_x8 = function (match, outcome) { return 'Ж1: 11 раунд'; };
var fa_y8 = function (match, outcome) { return 'Ж1: 12 раунд'; };
var fa_z8 = function (match, outcome) { return 'Ж2: 1 раунд'; };
var fa_a9 = function (match, outcome) { return 'Ж2: 2 раунд'; };
var fa_b9 = function (match, outcome) { return 'Ж2: 3 раунд'; };
var fa_c9 = function (match, outcome) { return 'Ж2: 4 раунд'; };
var fa_d9 = function (match, outcome) { return 'Ж2: 5 раунд'; };
var fa_e9 = function (match, outcome) { return 'Ж2: 6 раунд'; };
var fa_f9 = function (match, outcome) { return 'Ж2: 7 раунд'; };
var fa_g9 = function (match, outcome) { return 'Ж2: 8 раунд'; };
var fa_h9 = function (match, outcome) { return 'Ж2: 9 раунд'; };
var fa_i9 = function (match, outcome) { return 'Ж2: 10 раунд'; };
var fa_j9 = function (match, outcome) { return 'Ж2: 11 раунд'; };
var fa_k9 = function (match, outcome) { return 'Ж2: 12 раунд'; };
var fa_l9 = function (match, outcome) { return 'Ия'; };
var fa_m9 = function (match, outcome) { return 'X'; };
var fa_n9 = function (match, outcome) { return '5 және одан көп'; };
var fa_o9 = function (match, outcome) { return 'Екі'; };
var fa_p9 = function (match, outcome) { return 'Ешбірі'; };
var fa_q9 = function (match, outcome) { return "\u041A\u043E\u043C\u0430\u043D\u0434\u0430\u043B\u0430\u0440\u0434\u044B\u04A3 \u04D9\u0440\u049B\u0430\u0439\u0441\u044B\u0441\u044B ".concat(outcome.condition + 1, " \u043D\u0435\u043C\u0435\u0441\u0435 \u043E\u0434\u0430\u043D \u0430\u0441\u0430\u0442\u044B\u043D \u0433\u043E\u043B\u0434\u044B \u0441\u0430\u043B\u0430\u0434\u044B"); };
var fa_r9 = function (match, outcome) { return "\u0422\u0443\u0440\u0430 \u0431\u0456\u0440\u0435\u0443\u0456 ".concat(outcome.condition + 1, " \u043D\u0435\u043C\u0435\u0441\u0435 \u043E\u0434\u0430\u043D \u0430\u0441\u0430\u0442\u044B\u043D \u0433\u043E\u043B\u0434\u044B \u0441\u0430\u043B\u0430\u0434\u044B"); };
var fa_s9 = function (match, outcome) { return "\u0415\u0448\u043A\u0456\u043C ".concat(outcome.condition + 1, " \u043D\u0435\u043C\u0435\u0441\u0435 \u043E\u0434\u0430\u043D \u0430\u0441\u0430\u0442\u044B\u043D \u0433\u043E\u043B\u0434\u044B \u0441\u0430\u043B\u0430\u0434\u044B"); };
var fa_t9 = function (match, outcome) { return 'Бірінші голды баспен ұрып салады'; };
var fa_u9 = function (match, outcome) { return 'Бірінші голды аяқпен (ойындағы) салады'; };
var fa_v9 = function (match, outcome) { return 'Бірінші гол автогол болады'; };
var fa_w9 = function (match, outcome) { return 'Бірінші гол пенальтиден салынады'; };
var fa_x9 = function (match, outcome) { return 'Бұрыштама'; };
var fa_y9 = function (match, outcome) { return 'Офсайд'; };
var fa_z9 = function (match, outcome) { return 'СК'; };
var fa_a10 = function (match, outcome) { return 'Гол'; };
var fa_b10 = function (match, outcome) { return 'Болады'; };
var fa_c10 = function (match, outcome) { return 'Болмайды'; };
var fa_d10 = function (match, outcome) { return "\u0415\u0440\u0442\u0435 ".concat(outcome.condition); };
var fa_e10 = function (match, outcome) { return 'Кейін'; };
var fa_f10 = function (match, outcome) { return 'Бірінші таймда'; };
var fa_g10 = function (match, outcome) { return 'Екінші таймда'; };
var fa_h10 = function (match, outcome) { return 'Гол болмайды'; };
var fa_i10 = function (match, outcome) { return 'Салмайды'; };
var fa_j10 = function (match, outcome) { return 'Ж1Т'; };
var fa_k10 = function (match, outcome) { return 'ТЖ1'; };
var fa_l10 = function (match, outcome) { return 'ТТ'; };
var fa_m10 = function (match, outcome) { return 'ТЖ2'; };
var fa_n10 = function (match, outcome) { return 'Ж2Т'; };
var fa_o10 = function (match, outcome) { return '0-6'; };
var fa_p10 = function (match, outcome) { return '1-6'; };
var fa_q10 = function (match, outcome) { return '6-0'; };
var fa_r10 = function (match, outcome) { return '6-1'; };
var fa_s10 = function (match, outcome) { return 'Голдық тең ойын'; };
var fa_t10 = function (match, outcome) { return 'Голсыз тең ойын'; };
var fa_u10 = function (match, outcome) { return 'Тең ойын емес'; };
var fa_v10 = function (match, outcome) { return 'Ерте'; };
var fa_w10 = function (match, outcome) { return 'Соғады'; };
var fa_x10 = function (match, outcome) { return 'Соқпайды'; };
var fa_y10 = function (match, outcome) { return 'Екі команда соқпайды'; };
var fa_z10 = function (match, outcome) { return 'Бірінші аздау'; };
var fa_a11 = function (match, outcome) { return 'Теңдік'; };
var fa_b11 = function (match, outcome) { return 'Бірінші көп'; };
var fa_c11 = function (match, outcome) { return "\u041C\u0435\u043D. ".concat(outcome.condition); };
var fa_d11 = function (match, outcome) { return "\u0411\u043E\u043B. ".concat(outcome.condition); };
var fa_e11 = function (match, outcome) { return 'Иә/Иә'; };
var fa_f11 = function (match, outcome) { return 'Иә/Жоқ'; };
var fa_g11 = function (match, outcome) { return 'Жоқ/Иә'; };
var fa_h11 = function (match, outcome) { return 'Жоқ/Жоқ'; };
var fa_i11 = function (match, outcome) { return "\u0422\u0431".concat(outcome.condition, "/\u0418\u04D9"); };
var fa_j11 = function (match, outcome) { return "\u0422\u0431".concat(outcome.condition, "/\u0416\u043E\u049B"); };
var fa_k11 = function (match, outcome) { return "\u0422\u043C".concat(outcome.condition, "/\u0418\u04D9"); };
var fa_l11 = function (match, outcome) { return "\u0422\u043C".concat(outcome.condition, "/\u0416\u043E\u049B"); };
var fa_m11 = function (match, outcome) { return 'Ж1 негізгі уақытта'; };
var fa_n11 = function (match, outcome) { return 'Ж2 негізгі уақытта'; };
var fa_o11 = function (match, outcome) { return 'Ж1 қосымша уақытта'; };
var fa_p11 = function (match, outcome) { return 'Ж2 қосымша уақытта'; };
var fa_q11 = function (match, outcome) { return 'Ж1 пенальти сериясында'; };
var fa_r11 = function (match, outcome) { return 'Ж2 пенальти сериясында'; };
var fa_s11 = function (match, outcome) { return '1 тайм'; };
var fa_t11 = function (match, outcome) { return 'Үзіліс'; };
var fa_u11 = function (match, outcome) { return '2 тайм'; };
var fa_v11 = function (match, outcome) { return "\u0410\u0437".concat(outcome.condition); };
var fa_w11 = function (match, outcome) { return '5-4'; };
var fa_x11 = function (match, outcome) { return 'Ж1 кез келген басқамен'; };
var fa_y11 = function (match, outcome) { return '4-5'; };
var fa_z11 = function (match, outcome) { return 'Ж2 кез келген басқамен'; };
var fa_a12 = function (match, outcome) { return '1-10'; };
var fa_b12 = function (match, outcome) { return '11-20'; };
var fa_c12 = function (match, outcome) { return '21-30'; };
var fa_d12 = function (match, outcome) { return '31-40'; };
var fa_e12 = function (match, outcome) { return '41-50'; };
var fa_f12 = function (match, outcome) { return '51-60'; };
var fa_g12 = function (match, outcome) { return '61-70'; };
var fa_h12 = function (match, outcome) { return '71-80'; };
var fa_i12 = function (match, outcome) { return '81-ОВ соңы'; };
var fa_j12 = function (match, outcome) { return 'Гол жоқ'; };
var fa_k12 = function (match, outcome) { return 'Ж1: 8 және одан асады'; };
var fa_l12 = function (match, outcome) { return '1<2'; };
var fa_m12 = function (match, outcome) { return '1=2'; };
var fa_n12 = function (match, outcome) { return '1>2'; };
var fa_o12 = function (match, outcome) { return '1<3'; };
var fa_p12 = function (match, outcome) { return '1=3'; };
var fa_q12 = function (match, outcome) { return '1>3'; };
var fa_r12 = function (match, outcome) { return '2<3'; };
var fa_s12 = function (match, outcome) { return '2=3'; };
var fa_t12 = function (match, outcome) { return '2>3'; };
var fa_u12 = function (match, outcome) { return 'Чет'; };
var fa_v12 = function (match, outcome) { return 'Нечет'; };
var fa_w12 = function (match, outcome) { return 'Первый меньше'; };
var fa_x12 = function (match, outcome) { return 'Первый больше'; };
var fa_y12 = function (match, outcome) { return 'Да'; };
var fa_z12 = function (match, outcome) { return 'Нет'; };
var fa_a13 = function (match, outcome) { return '1-ші жоғары'; };
var fa_b13 = function (match, outcome) { return '2-ші жоғары'; };
var fa_c13 = function (match, outcome) { return 'Ж1: 4 раунд'; };
var fa_d13 = function (match, outcome) { return 'Ж1: ұпай бойынша жеңіс'; };
var fa_e13 = function (match, outcome) { return 'Тең түсу'; };
var fa_f13 = function (match, outcome) { return 'Ж2: ұпайлар бойынша жеңіс'; };
var fa_g13 = function (match, outcome) { return 'иә'; };
var fa_h13 = function (match, outcome) { return 'жоқ'; };
var fa_i13 = function (match, outcome) { return 'Сары шар'; };
var fa_j13 = function (match, outcome) { return 'Жасыл шар'; };
var fa_k13 = function (match, outcome) { return 'Қоңыр шар'; };
var fa_l13 = function (match, outcome) { return 'Көк шар'; };
var fa_m13 = function (match, outcome) { return 'Қызғылт шар'; };
var fa_n13 = function (match, outcome) { return 'Қара шар'; };
var fa_o13 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 5); };
var fa_p13 = function (match, outcome) { return '≤ 14'; };
var fa_q13 = function (match, outcome) { return '15-тен 17 дейін'; };
var fa_r13 = function (match, outcome) { return '18-ден 19 дейін'; };
var fa_s13 = function (match, outcome) { return '≥ 20'; };
var fa_t13 = function (match, outcome) { return "\u0410\u0437 ".concat(outcome.condition); };
var fa_u13 = function (match, outcome) { return 'Ж1-0'; };
var fa_v13 = function (match, outcome) { return 'Ж1-15'; };
var fa_w13 = function (match, outcome) { return 'Ж1-30'; };
var fa_x13 = function (match, outcome) { return 'Ж1-40'; };
var fa_y13 = function (match, outcome) { return '0-Ж2'; };
var fa_z13 = function (match, outcome) { return '15-Ж2'; };
var fa_a14 = function (match, outcome) { return '30-Ж2'; };
var fa_b14 = function (match, outcome) { return '40-Ж2'; };
var fa_c14 = function (match, outcome) { return '3-6'; };
var fa_d14 = function (match, outcome) { return '5-7'; };
var fa_e14 = function (match, outcome) { return '6-2'; };
var fa_f14 = function (match, outcome) { return '6-3'; };
var fa_g14 = function (match, outcome) { return '6-4'; };
var fa_h14 = function (match, outcome) { return '6-7'; };
var fa_i14 = function (match, outcome) { return '7-5'; };
var fa_j14 = function (match, outcome) { return '7-6'; };
var fa_k14 = function (match, outcome) { return '7-0'; };
var fa_l14 = function (match, outcome) { return '7-1'; };
var fa_m14 = function (match, outcome) { return '7-2'; };
var fa_n14 = function (match, outcome) { return '7-3'; };
var fa_o14 = function (match, outcome) { return '7-4'; };
var fa_p14 = function (match, outcome) { return 'Кез келген басқамен Ж1'; };
var fa_q14 = function (match, outcome) { return '0-7'; };
var fa_r14 = function (match, outcome) { return '1-7'; };
var fa_s14 = function (match, outcome) { return '2-7'; };
var fa_t14 = function (match, outcome) { return '3-7'; };
var fa_u14 = function (match, outcome) { return '4-7'; };
var fa_v14 = function (match, outcome) { return 'Кез келген басқамен Ж2'; };
var fa_w14 = function (match, outcome) { return '8'; };
var fa_x14 = function (match, outcome) { return '9'; };
var fa_y14 = function (match, outcome) { return '10'; };
var fa_z14 = function (match, outcome) { return '11'; };
var fa_a15 = function (match, outcome) { return '≥ 13'; };
var fa_b15 = function (match, outcome) { return "".concat(match.homeTeam, " (\u0421.\u041F.)"); };
var fa_c15 = function (match, outcome) { return "".concat(match.awayTeam, " (\u0421.\u041F.)"); };
var fa_d15 = function (match, outcome) { return 'Равенство'; };
var fa_e15 = function (match, outcome) { return 'Екеуі деП1'; };
var fa_f15 = function (match, outcome) { return 'Тең ойын'; };
var fa_g15 = function (match, outcome) { return 'Екеуі де Ж2'; };
var fa_h15 = function (match, outcome) { return 'ПЖ'; };
var fa_i15 = function (match, outcome) { return 'Ф1'; };
var fa_j15 = function (match, outcome) { return 'Ф2'; };
var fa_k15 = function (match, outcome) { return "".concat(outcome.condition + 1, " ").concat(outcome.condition + 2, " \u0434\u0435\u0439\u0456\u043D"); };
var fa_l15 = function (match, outcome) { return " ".concat(outcome.condition + 3, " ").concat(outcome.condition + 4, " \u0434\u0435\u0439\u0456\u043D"); };
var fa_m15 = function (match, outcome) { return " ".concat(outcome.condition + 5, " ").concat(outcome.condition + 6, " \u0434\u0435\u0439\u0456\u043D"); };
var fa_n15 = function (match, outcome) { return 'Ж1: 7 және одан көп'; };
var fa_o15 = function (match, outcome) { return 'Ж2: 7 және одан көп'; };
var fa_p15 = function (match, outcome) { return '6-5'; };
var fa_q15 = function (match, outcome) { return '5-6'; };
var baseOutcomeConfig = {
    11: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    32: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        122: bo_a2,
        123: bo_b2,
        124: bo_c2,
        129: bo_d2,
        130: bo_e2,
        131: bo_f2,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        257: bo_d1,
        307: bo_e1,
        443: bo_h1,
        608: bo_i1,
        362: bo_m2,
        363: bo_n2,
        364: bo_o2,
        17: bo_p2,
        18: bo_q2,
        19: bo_r2,
        176: bo_s2,
        177: bo_t2,
        178: bo_u2,
        358: bo_v2,
        359: bo_w2,
        360: bo_x2,
        13: bo_y2,
        14: bo_z2,
        15: bo_a3,
        172: bo_b3,
        173: bo_c3,
        174: bo_d3,
        256: bo_d1,
        306: bo_e1
    },
    35: {
        138: bo_e3,
        256: bo_d1,
        21: bo_f3,
        673: bo_g3,
        182: bo_h3,
        306: bo_e1,
        698: bo_g1,
        731: bo_i3,
        656: bo_j3,
        195: bo_k3,
        74: bo_b1,
        349: bo_c1,
        443: bo_h1,
        608: bo_i1,
        911: bo_l3,
        426: bo_m3,
        535: bo_n3,
        871: bo_o3,
        710: bo_p3,
        742: bo_q3
    },
    10: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        1: bo_r3,
        443: bo_h1,
        608: bo_i1
    },
    31: {
        74: bo_b1,
        349: bo_c1,
        21: bo_s3,
        22: bo_t3,
        23: bo_u3,
        24: bo_v3,
        256: bo_d1,
        306: bo_e1,
        195: bo_w3,
        196: bo_x3,
        197: bo_y3,
        198: bo_z3,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        403: bo_g1,
        138: bo_e4,
        139: bo_f4,
        140: bo_g4,
        141: bo_h4,
        182: bo_i4,
        183: bo_j4,
        184: bo_k4,
        185: bo_l4,
        238: bo_m4,
        682: bo_n4,
        239: bo_o4,
        58: bo_p4,
        59: bo_q4,
        681: bo_r4,
        234: bo_s4,
        235: bo_t4,
        236: bo_u4,
        237: bo_v4,
        725: bo_w4,
        726: bo_x4,
        727: bo_y4,
        728: bo_z4,
        782: bo_o3,
        778: bo_a5,
        779: bo_b5,
        780: bo_c5,
        781: bo_d5,
        783: bo_e5,
        773: bo_f5,
        474: bo_g5,
        421: bo_h5,
        530: bo_i5,
        422: bo_j5,
        531: bo_k5,
        444: bo_l5,
        888: bo_m5,
        280: bo_n5,
        317: bo_o5,
        424: bo_p5,
        533: bo_q5,
        423: bo_r5,
        532: bo_s5,
        637: bo_t5,
        788: bo_u5,
        784: bo_v5,
        785: bo_w5,
        786: bo_x5,
        787: bo_y5,
        774: bo_v5,
        775: bo_w5,
        776: bo_x5,
        777: bo_y5,
        281: bo_z5,
        137: bo_a6,
        246: bo_b6,
        248: bo_c6,
        240: bo_d6,
        232: bo_e6,
        241: bo_f6,
        233: bo_g6,
        61: bo_h6,
        62: bo_i6,
        684: bo_j6,
        685: bo_k6,
        443: bo_h1,
        608: bo_i1,
        890: bo_l6,
        242: bo_m6,
        245: bo_n6,
        243: bo_o6,
        60: bo_p6,
        683: bo_q6,
        406: bo_r6,
        405: bo_s6,
        404: bo_t6,
        700: bo_u6,
        408: bo_v6,
        407: bo_w6,
        247: bo_x6,
        244: bo_y6,
        638: bo_z6,
        639: bo_a7,
        640: bo_b7,
        641: bo_c7,
        646: bo_d7,
        642: bo_e7,
        643: bo_f7,
        644: bo_g7,
        645: bo_h7
    },
    41: {
        74: bo_b1,
        349: bo_c1,
        21: bo_i7,
        22: bo_j7,
        403: bo_g1,
        673: bo_k7,
        674: bo_l7,
        195: bo_m7,
        196: bo_n7,
        791: bo_o7,
        792: bo_n7,
        637: bo_p7,
        796: bo_u5,
        794: bo_q7,
        795: bo_r7,
        789: bo_q7,
        790: bo_r7,
        725: bo_s7,
        726: bo_t7,
        793: bo_u7,
        411: bo_v7,
        701: bo_l5,
        251: bo_w7,
        252: bo_x7,
        409: bo_y7,
        430: bo_z7,
        410: bo_a8,
        431: bo_b8,
        281: bo_z5,
        137: bo_a6,
        249: bo_c8,
        250: bo_d8,
        63: bo_e8,
        64: bo_f8,
        686: bo_g8,
        687: bo_h8,
        103: bo_i8,
        256: bo_d1,
        306: bo_e1,
        138: bo_j8,
        139: bo_k8,
        182: bo_l8,
        183: bo_m8,
        443: bo_h1,
        608: bo_i1,
        648: bo_s7,
        649: bo_t7
    },
    18: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_n8,
        196: bo_o8,
        197: bo_p8,
        673: bo_q8,
        674: bo_r8,
        675: bo_s8,
        610: bo_t8,
        443: bo_h1,
        608: bo_i1,
        806: bo_u8,
        893: bo_v8,
        707: bo_w8,
        708: bo_x8,
        709: bo_y8,
        889: bo_u7,
        904: bo_z8,
        253: bo_a9,
        688: bo_b9,
        65: bo_c9,
        751: bo_q3,
        21: bo_d9,
        22: bo_e9,
        23: bo_f9,
        743: bo_g9,
        744: bo_h9,
        745: bo_i9,
        615: bo_j9,
        350: bo_a9
    },
    3: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        352: bo_p1,
        746: bo_q3,
        102: bo_f1,
        403: bo_g1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        74: bo_k9,
        854: bo_l9,
        855: bo_m9,
        856: bo_n9,
        857: bo_l9,
        858: bo_m9,
        859: bo_n9,
        797: bo_o9,
        798: bo_p9,
        799: bo_q9,
        851: bo_r9,
        852: bo_s9,
        853: bo_t9,
        83: bo_u9,
        84: bo_v9,
        85: bo_w9,
        905: bo_x9,
        906: bo_y9,
        907: bo_z9,
        443: bo_h1,
        608: bo_i1,
        362: bo_a10,
        363: bo_b10,
        17: bo_c10,
        18: bo_d10,
        176: bo_e10,
        177: bo_f10,
        358: bo_g10,
        359: bo_g10,
        13: bo_h10,
        14: bo_i10,
        172: bo_j10,
        173: bo_k10,
        616: bo_l10,
        617: bo_m10,
        618: bo_n10,
        891: bo_l3,
        257: bo_d1,
        307: bo_e1,
        800: bo_o10,
        801: bo_p10,
        802: bo_q10
    },
    20: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        698: bo_g1,
        195: bo_r10,
        196: bo_s10,
        197: bo_t10,
        198: bo_u10,
        199: bo_v10,
        200: bo_w10,
        201: bo_x10,
        202: bo_y10,
        138: bo_z10,
        139: bo_a11,
        140: bo_b11,
        141: bo_c11,
        142: bo_d11,
        143: bo_e11,
        144: bo_f11,
        145: bo_g11,
        182: bo_h11,
        183: bo_i11,
        184: bo_j11,
        185: bo_k11,
        186: bo_l11,
        187: bo_m11,
        188: bo_n11,
        189: bo_o11,
        21: bo_p11,
        22: bo_q11,
        23: bo_r11,
        24: bo_s11,
        25: bo_t11,
        26: bo_u11,
        27: bo_v11,
        28: bo_w11,
        673: bo_x11,
        674: bo_y11,
        675: bo_z11,
        676: bo_a12,
        677: bo_b12,
        678: bo_c12,
        679: bo_d12,
        680: bo_e12,
        860: bo_f12,
        861: bo_g12,
        862: bo_h12,
        863: bo_i12,
        864: bo_j12,
        865: bo_k12,
        866: bo_l12,
        867: bo_m12,
        443: bo_h1,
        608: bo_i1
    },
    5: {
        349: bo_c1,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1,
        945: bo_n12,
        948: bo_o12,
        949: bo_p12
    },
    40: {
        656: bo_j3,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    37: {
        443: bo_h1,
        608: bo_i1
    },
    38: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_q12,
        615: bo_r12,
        413: bo_s12,
        414: bo_t12
    },
    42: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_q12,
        615: bo_u12,
        413: bo_s12,
        414: bo_v12,
        566: bo_w12,
        567: bo_x12,
        568: bo_y12,
        569: bo_z12,
        570: bo_a13,
        698: bo_b13,
        366: bo_c13,
        367: bo_d13,
        368: bo_e13,
        369: bo_f13,
        370: bo_g13,
        940: bo_h13,
        941: bo_i13,
        942: bo_j13,
        943: bo_k13,
        944: bo_l13
    },
    26: {
        443: bo_h1,
        608: bo_i1
    },
    25: {
        443: bo_h1,
        608: bo_i1
    },
    16: {
        443: bo_h1,
        608: bo_i1
    },
    12: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    36: {
        610: bo_m13,
        698: bo_g1,
        656: bo_j3,
        74: bo_b1,
        349: bo_c1,
        615: bo_j9,
        256: bo_d1,
        306: bo_e1,
        673: bo_q8,
        21: bo_d9,
        195: bo_n8,
        443: bo_h1,
        608: bo_i1
    },
    7: {
        425: bo_n13,
        534: bo_o13,
        540: bo_p13,
        343: bo_q13,
        345: bo_r13,
        260: bo_s13,
        261: bo_t13,
        83: bo_u13,
        84: bo_v13,
        803: bo_w13,
        868: bo_x13,
        869: bo_y13,
        870: bo_z13,
        805: bo_a14,
        892: bo_b14,
        346: bo_c14,
        419: bo_d14,
        528: bo_e14,
        420: bo_f14,
        529: bo_g14,
        707: bo_h14,
        708: bo_i14,
        706: bo_j14,
        804: bo_k14,
        474: bo_l14,
        614: bo_m14,
        609: bo_n14,
        416: bo_o14,
        732: bo_p14,
        525: bo_q14,
        850: bo_r14,
        473: bo_s14,
        442: bo_t14,
        729: bo_u14,
        538: bo_v14,
        542: bo_w14,
        730: bo_x14,
        471: bo_y14,
        635: bo_z14,
        714: bo_a15,
        624: bo_b15,
        625: bo_c15,
        715: bo_d15,
        650: bo_e15,
        651: bo_f15,
        652: bo_g15,
        653: bo_h15,
        654: bo_i15,
        655: bo_j15,
        634: bo_k15,
        626: bo_l15,
        733: bo_m15,
        734: bo_n15,
        258: bo_o15,
        259: bo_p15,
        66: bo_q15,
        67: bo_r15,
        81: bo_s15,
        68: bo_t15,
        689: bo_u15,
        690: bo_v15,
        699: bo_w15,
        691: bo_x15,
        723: bo_y15,
        633: bo_z15,
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        322: bo_a16,
        904: bo_b16,
        1: bo_r3,
        136: bo_c16,
        747: bo_q3,
        871: bo_o3,
        255: bo_d16,
        705: bo_e16,
        323: bo_f16,
        324: bo_g16,
        702: bo_h16,
        278: bo_i16,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_j16,
        21: bo_f3,
        22: bo_k16,
        282: bo_l16,
        911: bo_l3,
        353: bo_m16,
        673: bo_g3,
        674: bo_n16,
        2: bo_o16,
        5: bo_p16,
        7: bo_q16,
        939: bo_r16,
        9: bo_s16,
        12: bo_t16,
        417: bo_u16,
        526: bo_v16,
        325: bo_w16,
        103: bo_f1,
        160: bo_x16,
        163: bo_y16,
        165: bo_z16,
        166: bo_a17,
        168: bo_b17,
        171: bo_c17,
        148: bo_d17,
        149: bo_e17,
        150: bo_f17,
        151: bo_g17,
        152: bo_h17,
        153: bo_i17,
        154: bo_j17,
        155: bo_k17,
        156: bo_l17,
        157: bo_m17,
        158: bo_n17,
        159: bo_o17,
        731: bo_i3,
        765: bo_p17,
        766: bo_q17,
        415: bo_r17,
        524: bo_s17,
        418: bo_t17,
        527: bo_u17,
        743: bo_v17,
        744: bo_w17,
        710: bo_p3,
        321: bo_x17,
        326: bo_y17,
        327: bo_z17,
        724: bo_a18,
        661: bo_b18,
        664: bo_c18,
        666: bo_d18,
        667: bo_e18,
        669: bo_f18,
        672: bo_g18,
        426: bo_m3,
        535: bo_n3,
        537: bo_h18,
        541: bo_i18,
        539: bo_j18,
        138: bo_e3,
        139: bo_k18,
        182: bo_h3,
        183: bo_l18,
        437: bo_m18,
        436: bo_n18,
        694: bo_o18,
        71: bo_p18,
        271: bo_c1,
        268: bo_q18,
        265: bo_r18,
        267: bo_s18,
        270: bo_t18,
        272: bo_u18,
        269: bo_v18,
        266: bo_w18,
        264: bo_x18,
        281: bo_z5,
        137: bo_a6,
        660: bo_y18,
        880: bo_z18,
        879: bo_a19,
        429: bo_b19,
        433: bo_c19,
        443: bo_h1,
        608: bo_i1,
        881: bo_d19,
        273: bo_e19,
        274: bo_f19,
        435: bo_g19,
        704: bo_h19,
        432: bo_i19,
        428: bo_j19,
        434: bo_k19,
        439: bo_l19,
        440: bo_m19,
        441: bo_n19,
        438: bo_o19,
        623: bo_p19,
        180: bo_q19,
        146: bo_r19,
        659: bo_s19,
        749: bo_t19,
        69: bo_u19,
        262: bo_v19,
        692: bo_w19,
        703: bo_x19,
        70: bo_y19,
        263: bo_z19,
        693: bo_a20,
        72: bo_b20,
        277: bo_c20,
        695: bo_d20,
        750: bo_e20,
        181: bo_f20,
        147: bo_g20,
        276: bo_h20,
        275: bo_i20,
        735: bo_j20,
        736: bo_k20,
        737: bo_l20,
        738: bo_m20,
        739: bo_n20,
        740: bo_o20,
        356: bo_p20,
        357: bo_q20,
        354: bo_r20,
        355: bo_s20,
        937: bo_t20,
        657: bo_u20,
        658: bo_v20,
        412: bo_w20
    },
    14: {
        443: bo_h1,
        608: bo_i1
    },
    34: {
        425: bo_n13,
        534: bo_o13,
        540: bo_p13,
        343: bo_q13,
        345: bo_r13,
        260: bo_s13,
        261: bo_t13,
        83: bo_u13,
        84: bo_v13,
        803: bo_w13,
        868: bo_x13,
        869: bo_y13,
        870: bo_z13,
        346: bo_c14,
        419: bo_d14,
        528: bo_e14,
        420: bo_f14,
        529: bo_g14,
        707: bo_h14,
        708: bo_i14,
        706: bo_j14,
        538: bo_v14,
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        322: bo_a16,
        904: bo_b16,
        1: bo_r3,
        136: bo_c16,
        747: bo_q3,
        871: bo_o3,
        255: bo_d16,
        705: bo_e16,
        323: bo_f16,
        324: bo_g16,
        702: bo_h16,
        278: bo_i16,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_j16,
        21: bo_f3,
        22: bo_k16,
        282: bo_l16,
        911: bo_l3,
        353: bo_m16,
        673: bo_g3,
        674: bo_n16,
        2: bo_o16,
        5: bo_p16,
        7: bo_q16,
        939: bo_r16,
        9: bo_s16,
        12: bo_t16,
        417: bo_u16,
        526: bo_v16,
        325: bo_w16,
        103: bo_f1,
        160: bo_x16,
        163: bo_y16,
        165: bo_z16,
        166: bo_a17,
        168: bo_b17,
        171: bo_c17,
        148: bo_d17,
        149: bo_e17,
        150: bo_f17,
        151: bo_g17,
        152: bo_h17,
        153: bo_i17,
        154: bo_j17,
        155: bo_k17,
        156: bo_l17,
        157: bo_m17,
        158: bo_n17,
        159: bo_o17,
        731: bo_i3,
        765: bo_p17,
        766: bo_q17,
        415: bo_r17,
        524: bo_s17,
        418: bo_t17,
        527: bo_u17,
        743: bo_v17,
        744: bo_w17,
        710: bo_p3,
        321: bo_x17,
        326: bo_y17,
        327: bo_z17,
        724: bo_a18,
        661: bo_b18,
        664: bo_c18,
        666: bo_d18,
        667: bo_e18,
        669: bo_f18,
        672: bo_g18,
        426: bo_m3,
        535: bo_n3,
        537: bo_h18,
        541: bo_i18,
        539: bo_j18,
        138: bo_e3,
        139: bo_k18,
        182: bo_h3,
        183: bo_l18,
        443: bo_h1,
        608: bo_i1
    },
    19: {
        74: bo_b1,
        349: bo_c1,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_j16,
        103: bo_f1,
        615: bo_j9,
        886: bo_p17,
        887: bo_q17,
        911: bo_l3,
        884: bo_x20,
        885: bo_y20,
        882: bo_z20,
        883: bo_a21,
        723: bo_y15,
        673: bo_g3,
        674: bo_n16,
        21: bo_f3,
        22: bo_k16,
        138: bo_e3,
        182: bo_h3,
        443: bo_h1,
        608: bo_i1
    },
    30: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        21: bo_d9,
        22: bo_e9,
        23: bo_f9,
        279: bo_b21,
        610: bo_t8,
        256: bo_d1,
        306: bo_e1,
        195: bo_c21,
        196: bo_d21,
        197: bo_e21,
        673: bo_q8,
        674: bo_r8,
        675: bo_s8,
        350: bo_a9,
        103: bo_f1,
        415: bo_r17,
        524: bo_s17,
        743: bo_f21,
        744: bo_g21,
        745: bo_h21,
        710: bo_p3,
        403: bo_g1,
        426: bo_m3,
        535: bo_n3,
        706: bo_j14,
        343: bo_q13,
        346: bo_c14,
        83: bo_i21,
        84: bo_j21,
        85: bo_k21,
        344: bo_l21,
        347: bo_m21,
        765: bo_n21,
        766: bo_o21,
        767: bo_p21,
        138: bo_q21,
        139: bo_r21,
        140: bo_s21,
        182: bo_t21,
        183: bo_u21,
        184: bo_v21,
        751: bo_q3,
        911: bo_l3,
        889: bo_o3,
        637: bo_t5,
        615: bo_j9,
        412: bo_w21,
        634: bo_k15,
        626: bo_l15,
        611: bo_x21,
        443: bo_h1,
        608: bo_i1,
        904: bo_y21,
        449: bo_z21,
        446: bo_a22,
        451: bo_b22,
        711: bo_c22,
        712: bo_d22,
        713: bo_e22,
        450: bo_f22,
        447: bo_g22,
        448: bo_h22,
        662: bo_i22,
        663: bo_j22,
        665: bo_k22,
        668: bo_l22,
        670: bo_m22,
        671: bo_n22,
        3: bo_o22,
        4: bo_p22,
        6: bo_q22,
        8: bo_r22,
        10: bo_s22,
        11: bo_t22,
        161: bo_u22,
        162: bo_v22,
        164: bo_w22,
        167: bo_x22,
        169: bo_y22,
        170: bo_z22,
        707: bo_a23,
        708: bo_b23,
        709: bo_c23,
        946: bo_d23,
        947: bo_e23
    },
    23: {
        443: bo_h1,
        608: bo_i1
    },
    13: {
        468: bo_f23,
        470: bo_g23,
        467: bo_h23,
        469: bo_i23,
        464: bo_j23,
        466: bo_k23,
        465: bo_l23,
        463: bo_m23,
        289: bo_n23,
        288: bo_o23,
        292: bo_p23,
        461: bo_q23,
        283: bo_r23,
        295: bo_s23,
        293: bo_t23,
        284: bo_u23,
        285: bo_v23,
        316: bo_w23,
        286: bo_x23,
        287: bo_y23,
        290: bo_z23,
        291: bo_a24,
        462: bo_b24,
        294: bo_c24
    },
    39: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        698: bo_g1,
        349: bo_c1,
        950: bo_d24,
        955: bo_e24,
        951: bo_f24,
        952: bo_g24,
        953: bo_h24,
        954: bo_i24
    },
    33: {
        348: bo_j24,
        443: bo_h1,
        608: bo_i1
    },
    24: {
        443: bo_h1,
        608: bo_i1
    },
    9: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_j16,
        673: bo_g3,
        674: bo_n16,
        443: bo_h1,
        608: bo_i1
    },
    21: {
        443: bo_h1,
        608: bo_i1
    },
    29: {
        394: bo_k24,
        395: bo_l24,
        396: bo_m24,
        397: bo_n24,
        398: bo_o24,
        399: bo_p24,
        400: bo_q24,
        401: bo_r24,
        402: bo_s24,
        100: bo_t24,
        101: bo_u24,
        104: bo_v24,
        105: bo_w24,
        106: bo_x24,
        107: bo_y24,
        108: bo_z24,
        109: bo_a25,
        110: bo_b25,
        111: bo_c25,
        112: bo_d25,
        113: bo_e25,
        114: bo_f25,
        115: bo_g25,
        116: bo_h25,
        117: bo_i25,
        118: bo_j25,
        119: bo_k25,
        120: bo_l25,
        121: bo_m25,
        808: bo_n25,
        809: bo_o25,
        810: bo_p25,
        811: bo_q25,
        812: bo_r25,
        813: bo_s25,
        814: bo_t25,
        815: bo_u25,
        816: bo_v25,
        817: bo_w25,
        818: bo_x25,
        819: bo_y25,
        820: bo_z25,
        821: bo_a26,
        822: bo_b26,
        823: bo_c26,
        824: bo_d26,
        825: bo_e26,
        826: bo_f26,
        827: bo_g26,
        828: bo_h26,
        829: bo_i26,
        830: bo_j26,
        831: bo_k26,
        832: bo_l26,
        833: bo_m26,
        834: bo_n26,
        835: bo_o26,
        836: bo_p26,
        837: bo_q26,
        838: bo_r26,
        839: bo_s26,
        840: bo_t26,
        841: bo_u26,
        842: bo_v26,
        843: bo_w26,
        844: bo_x26,
        366: bo_y26,
        367: bo_z26,
        368: bo_a27,
        369: bo_b27,
        370: bo_c27,
        371: bo_d27,
        372: bo_e27,
        373: bo_f27,
        374: bo_g27,
        375: bo_h27,
        376: bo_i27,
        377: bo_j27,
        378: bo_k27,
        379: bo_l27,
        380: bo_m27,
        381: bo_n27,
        382: bo_o27,
        383: bo_p27,
        384: bo_q27,
        385: bo_r27,
        386: bo_s27,
        387: bo_t27,
        388: bo_u27,
        389: bo_v27,
        390: bo_w27,
        391: bo_x27,
        392: bo_y27,
        393: bo_z27,
        481: bo_a28,
        482: bo_b28,
        483: bo_c28,
        484: bo_d28,
        485: bo_e28,
        486: bo_f28,
        487: bo_g28,
        488: bo_h28,
        489: bo_i28,
        490: bo_j28,
        491: bo_k28,
        492: bo_l28,
        493: bo_m28,
        494: bo_n28,
        495: bo_o28,
        496: bo_p28,
        497: bo_q28,
        498: bo_r28,
        499: bo_s28,
        500: bo_t28,
        501: bo_u28,
        502: bo_v28,
        503: bo_w28,
        504: bo_x28,
        505: bo_y28,
        506: bo_z28,
        507: bo_a29,
        508: bo_b29,
        509: bo_c29,
        510: bo_d29,
        511: bo_e29,
        566: bo_f29,
        567: bo_g29,
        568: bo_h29,
        569: bo_i29,
        570: bo_j29,
        571: bo_k29,
        572: bo_l29,
        573: bo_m29,
        574: bo_n29,
        575: bo_o29,
        576: bo_p29,
        577: bo_q29,
        578: bo_r29,
        579: bo_s29,
        580: bo_t29,
        581: bo_u29,
        582: bo_v29,
        583: bo_w29,
        584: bo_x29,
        585: bo_y29,
        586: bo_z29,
        587: bo_a30,
        588: bo_b30,
        589: bo_c30,
        590: bo_d30,
        591: bo_e30,
        592: bo_f30,
        593: bo_g30,
        594: bo_h30,
        595: bo_i30,
        596: bo_j30,
        597: bo_k30,
        598: bo_l30,
        599: bo_m30,
        600: bo_n30,
        601: bo_o30,
        602: bo_p30,
        83: bo_q30,
        84: bo_r30,
        85: bo_s30,
        86: bo_t30,
        87: bo_u30,
        88: bo_v30,
        89: bo_w30,
        90: bo_x30,
        91: bo_y30,
        92: bo_z30,
        93: bo_a31,
        94: bo_b31,
        95: bo_c31,
        96: bo_d31,
        97: bo_e31,
        98: bo_f31,
        99: bo_g31,
        74: bo_b1,
        349: bo_c1,
        254: bo_h31,
        403: bo_g1,
        21: bo_i31,
        22: bo_j31,
        23: bo_k31,
        24: bo_l31,
        25: bo_m31,
        26: bo_n31,
        27: bo_o31,
        28: bo_p31,
        29: bo_q31,
        30: bo_r31,
        31: bo_s31,
        32: bo_t31,
        33: bo_u31,
        34: bo_v31,
        35: bo_w31,
        36: bo_x31,
        37: bo_y31,
        38: bo_z31,
        39: bo_a32,
        40: bo_b32,
        41: bo_c32,
        42: bo_d32,
        43: bo_e32,
        44: bo_f32,
        45: bo_g32,
        46: bo_h32,
        47: bo_i32,
        48: bo_j32,
        49: bo_k32,
        50: bo_l32,
        51: bo_m32,
        52: bo_n32,
        53: bo_o32,
        54: bo_p32,
        55: bo_q32,
        56: bo_r32,
        57: bo_s32,
        195: bo_t32,
        196: bo_u32,
        197: bo_v32,
        198: bo_w32,
        199: bo_x32,
        200: bo_y32,
        201: bo_z32,
        202: bo_a33,
        203: bo_b33,
        204: bo_c33,
        205: bo_d33,
        206: bo_e33,
        207: bo_f33,
        208: bo_g33,
        209: bo_h33,
        210: bo_i33,
        211: bo_j33,
        212: bo_k33,
        213: bo_l33,
        214: bo_m33,
        215: bo_n33,
        216: bo_o33,
        217: bo_p33,
        218: bo_q33,
        219: bo_r33,
        220: bo_s33,
        221: bo_t33,
        222: bo_u33,
        223: bo_v33,
        224: bo_w33,
        225: bo_x33,
        226: bo_y33,
        227: bo_z33,
        228: bo_a34,
        229: bo_b34,
        230: bo_c34,
        231: bo_d34,
        475: bo_e34,
        476: bo_f34,
        477: bo_g34,
        478: bo_h34,
        479: bo_i34,
        480: bo_j34,
        443: bo_h1,
        608: bo_i1
    },
    15: {
        443: bo_h1,
        608: bo_i1
    },
    2: {
        73: bo_b1,
        318: bo_c1,
        21: bo_i31,
        22: bo_j31,
        23: bo_k31,
        24: bo_l31,
        25: bo_m31,
        26: bo_n31,
        27: bo_o31,
        195: bo_t32,
        196: bo_u32,
        197: bo_v32,
        198: bo_w32,
        199: bo_x32,
        200: bo_y32,
        201: bo_z32,
        352: bo_k34,
        102: bo_f1,
        403: bo_g1,
        138: bo_l34,
        139: bo_m34,
        140: bo_n34,
        141: bo_o34,
        142: bo_p34,
        143: bo_q34,
        144: bo_r34,
        182: bo_s34,
        183: bo_t34,
        184: bo_u34,
        185: bo_v34,
        186: bo_w34,
        187: bo_x34,
        188: bo_y34,
        566: bo_f29,
        567: bo_g29,
        568: bo_h29,
        569: bo_i29,
        570: bo_j29,
        571: bo_k29,
        572: bo_l29,
        366: bo_y26,
        367: bo_z26,
        368: bo_a27,
        369: bo_b27,
        370: bo_c27,
        371: bo_d27,
        372: bo_e27,
        122: bo_z34,
        123: bo_a35,
        124: bo_b35,
        125: bo_c35,
        126: bo_d35,
        127: bo_e35,
        128: bo_f35,
        129: bo_g35,
        130: bo_h35,
        131: bo_i35,
        132: bo_j35,
        133: bo_k35,
        134: bo_l35,
        135: bo_m35,
        872: bo_n35,
        873: bo_o35,
        874: bo_p35,
        875: bo_q35,
        876: bo_r35,
        877: bo_s35,
        878: bo_t35,
        616: bo_u35,
        617: bo_v35,
        618: bo_w35,
        619: bo_x35,
        620: bo_y35,
        621: bo_z35,
        622: bo_a36,
        894: bo_n35,
        895: bo_o35,
        896: bo_p35,
        897: bo_q35,
        898: bo_r35,
        899: bo_s35,
        900: bo_t35,
        443: bo_h1,
        608: bo_i1,
        83: bo_b36,
        84: bo_c36,
        85: bo_d36,
        86: bo_e36,
        87: bo_f36,
        88: bo_g36,
        89: bo_h36,
        257: bo_d1,
        307: bo_e1,
        752: bo_i36,
        753: bo_i36
    },
    6: {
        553: bo_j36,
        339: bo_k36,
        547: bo_l36,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        141: bo_m36,
        142: bo_n36,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        185: bo_o36,
        186: bo_p36,
        83: bo_u9,
        84: bo_v9,
        85: bo_w9,
        86: bo_q36,
        87: bo_r36,
        807: bo_s36,
        636: bo_t36,
        334: bo_u36,
        335: bo_v36,
        336: bo_w36,
        337: bo_x36,
        906: bo_y9,
        907: bo_z9,
        908: bo_y36,
        909: bo_z36,
        300: bo_a37,
        301: bo_b37,
        302: bo_c37,
        303: bo_d37,
        304: bo_e37,
        310: bo_f37,
        311: bo_g37,
        312: bo_h37,
        313: bo_i37,
        314: bo_j37,
        554: bo_k37,
        555: bo_l37,
        556: bo_m37,
        557: bo_n37,
        558: bo_o37,
        517: bo_p37,
        518: bo_q37,
        519: bo_r37,
        520: bo_s37,
        521: bo_t37,
        561: bo_u37,
        562: bo_v37,
        563: bo_w37,
        564: bo_x37,
        565: bo_y37,
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_z37,
        25: bo_a38,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        198: bo_b38,
        199: bo_c38,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        903: bo_d38,
        445: bo_e38,
        754: bo_f38,
        755: bo_g38,
        756: bo_h38,
        757: bo_i38,
        758: bo_j38,
        452: bo_k38,
        453: bo_l38,
        454: bo_m38,
        566: bo_n38,
        567: bo_o38,
        568: bo_p38,
        569: bo_q38,
        570: bo_r38,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_s38,
        370: bo_t38,
        522: bo_u38,
        627: bo_v38,
        628: bo_w38,
        629: bo_x38,
        630: bo_y38,
        631: bo_z38,
        632: bo_a39,
        190: bo_b39,
        191: bo_c39,
        192: bo_d39,
        193: bo_e39,
        194: bo_f39,
        759: bo_g39,
        760: bo_h39,
        761: bo_i39,
        762: bo_j39,
        763: bo_k39,
        768: bo_l39,
        769: bo_m39,
        770: bo_n39,
        771: bo_o39,
        772: bo_p39,
        603: bo_q39,
        604: bo_r39,
        605: bo_s39,
        606: bo_t39,
        607: bo_u39,
        257: bo_d1,
        307: bo_e1,
        696: bo_g1,
        333: bo_v39,
        341: bo_w39,
        427: bo_x39,
        536: bo_y39,
        905: bo_x9,
        320: bo_z39,
        514: bo_a40,
        516: bo_b40,
        305: bo_c40,
        315: bo_d40,
        523: bo_e40,
        299: bo_f40,
        309: bo_g40,
        697: bo_h40,
        298: bo_i40,
        308: bo_j40,
        515: bo_k40,
        549: bo_l40,
        548: bo_m40,
        443: bo_h1,
        608: bo_i1,
        550: bo_n40,
        551: bo_n40,
        455: bo_o40,
        456: bo_o40,
        457: bo_p40,
        458: bo_p40,
        459: bo_q40,
        460: bo_q40,
        512: bo_r40,
        513: bo_s40,
        901: bo_d38,
        902: bo_d38,
        340: bo_t40,
        328: bo_u40,
        329: bo_v40,
        342: bo_w40,
        330: bo_x40,
        331: bo_y40,
        722: bo_z40,
        560: bo_a41,
        543: bo_b41,
        544: bo_c41,
        545: bo_d41,
        546: bo_e41,
        332: bo_f41,
        559: bo_g41,
        296: bo_h41,
        297: bo_i41,
        717: bo_j41,
        718: bo_k41,
        719: bo_l41,
        720: bo_m41,
        721: bo_n41,
        552: bo_o41,
        76: bo_p41,
        77: bo_q41,
        78: bo_r41,
        79: bo_s41,
        80: bo_t41,
        647: bo_u41,
        741: bo_v41,
        82: bo_w41,
        338: bo_x41
    },
    17: {
        348: bo_j24,
        443: bo_h1,
        608: bo_i1
    },
    4: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_z37,
        25: bo_a38,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        198: bo_b38,
        199: bo_c38,
        352: bo_p1,
        764: bo_q3,
        102: bo_f1,
        403: bo_g1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        141: bo_m36,
        142: bo_n36,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        185: bo_o36,
        186: bo_p36,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_s38,
        370: bo_t38,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        569: bo_y41,
        570: bo_z41,
        74: bo_k9,
        923: bo_l9,
        924: bo_m9,
        925: bo_n9,
        926: bo_a42,
        927: bo_b42,
        929: bo_l9,
        930: bo_m9,
        931: bo_n9,
        932: bo_a42,
        933: bo_b42,
        845: bo_o9,
        846: bo_p9,
        847: bo_q9,
        848: bo_c42,
        849: bo_d42,
        918: bo_r9,
        919: bo_s9,
        920: bo_t9,
        921: bo_e42,
        922: bo_f42,
        83: bo_u9,
        84: bo_v9,
        85: bo_w9,
        86: bo_q36,
        87: bo_r36,
        905: bo_x9,
        906: bo_y9,
        907: bo_z9,
        908: bo_y36,
        909: bo_z36,
        807: bo_s36,
        319: bo_g42,
        320: bo_z39,
        912: bo_o10,
        913: bo_p10,
        914: bo_q10,
        915: bo_h42,
        916: bo_i42,
        443: bo_h1,
        608: bo_i1,
        257: bo_d1,
        307: bo_e1,
        362: bo_j42,
        363: bo_k42,
        364: bo_l42,
        365: bo_m42,
        17: bo_n42,
        18: bo_o42,
        19: bo_p42,
        20: bo_q42,
        176: bo_r42,
        177: bo_s42,
        178: bo_t42,
        179: bo_u42,
        358: bo_v42,
        359: bo_w42,
        360: bo_x42,
        361: bo_y42,
        13: bo_z42,
        14: bo_a43,
        15: bo_b43,
        16: bo_c43,
        172: bo_d43,
        173: bo_e43,
        174: bo_f43,
        175: bo_g43,
        281: bo_z5,
        137: bo_a6,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        619: bo_h43,
        620: bo_i43,
        891: bo_l3,
        26: bo_j43,
        200: bo_k43,
        143: bo_l43,
        187: bo_m43,
        371: bo_n43,
        571: bo_o43,
        928: bo_p43,
        934: bo_p43,
        88: bo_q43,
        910: bo_r43,
        917: bo_s43,
        936: bo_t43
    },
    8: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_w3,
        196: bo_x3,
        197: bo_y3,
        198: bo_z3,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    27: {
        443: bo_h1,
        608: bo_i1
    },
    28: {
        403: bo_g1,
        615: bo_u43,
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        935: bo_q3,
        612: bo_v43,
        613: bo_w43,
        443: bo_h1,
        608: bo_i1
    }
};
var outcomeConfig = {
    7: {
        426: function (match, outcome) { return "".concat(match.homeTeam, " \u0434\u04D9\u043B ").concat(outcome.condition, " \u0433\u043E\u043B \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u0493\u044B\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); },
        535: function (match, outcome) { return "".concat(match.awayTeam, " \u0434\u04D9\u043B ").concat(outcome.condition, " \u0433\u043E\u043B \u0430\u0439\u044B\u0440\u043C\u0430\u0448\u044B\u043B\u044B\u0493\u044B\u043C\u0435\u043D \u0436\u0435\u04A3\u0435\u0434\u0456"); }
    },
    6: {
        455: function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 15x15 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?"); },
        456: function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 15x15 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?"); },
        457: function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 30x30 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?"); },
        458: function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 30x30 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?"); },
        459: function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 40x40 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?"); },
        460: function (match, outcome) { return "".concat(outcome.condition, " \u0433\u0435\u0439\u043C\u0434\u0435 40x40 \u0431\u043E\u043B\u0430\u0434\u044B \u043C\u0430?"); }
    }
};
var baseFactorNameConfig = {
    11: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_f1,
            2: fa_g1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    32: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_p1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_q1,
            2: fa_r1,
            3: fa_s1,
            4: fa_t1,
            5: fa_u1,
            6: fa_v1,
            7: fa_w1,
            8: fa_x1,
            9: fa_y1,
            10: fa_z1
        },
        102: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_p1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        122: {
            1: fa_n1,
            2: fa_o1
        },
        123: {
            1: fa_n1,
            2: fa_o1
        },
        124: {
            1: fa_n1,
            2: fa_o1
        },
        129: {
            1: fa_n1,
            2: fa_o1
        },
        130: {
            1: fa_n1,
            2: fa_o1
        },
        131: {
            1: fa_n1,
            2: fa_o1
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        616: {
            1: fa_a2,
            2: fa_b2
        },
        617: {
            1: fa_a2,
            2: fa_b2
        },
        618: {
            1: fa_a2,
            2: fa_b2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        362: {
            1: fa_j1,
            2: fa_k1
        },
        363: {
            1: fa_j1,
            2: fa_k1
        },
        364: {
            1: fa_j1,
            2: fa_k1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_j1,
            2: fa_k1
        },
        359: {
            1: fa_j1,
            2: fa_k1
        },
        360: {
            1: fa_j1,
            2: fa_k1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        }
    },
    35: {
        138: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        731: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        911: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2,
            5: fa_l2,
            6: fa_m2
        },
        426: {
            1: fa_n1,
            2: fa_o1
        },
        535: {
            1: fa_n1,
            2: fa_o1
        },
        871: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        710: {
            1: fa_t2,
            2: fa_u2,
            3: fa_v2
        },
        742: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_y2,
            6: fa_z2,
            7: fa_a3,
            8: fa_b3,
            9: fa_s1,
            10: fa_t1,
            11: fa_c3,
            12: fa_d3,
            13: fa_u1,
            14: fa_v1,
            15: fa_e3,
            16: fa_w1,
            17: fa_f3,
            18: fa_g3,
            19: fa_h3,
            20: fa_x1,
            21: fa_y1,
            22: fa_z1,
            23: fa_i3,
            24: fa_j3,
            25: fa_k3,
            26: fa_l3,
            27: fa_m3,
            28: fa_n3,
            29: fa_o3,
            30: fa_p3,
            31: fa_q3,
            32: fa_r3,
            33: fa_s3,
            34: fa_t3,
            35: fa_u3
        }
    },
    10: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    31: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        675: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        676: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        238: {
            1: fa_d1,
            2: fa_e1
        },
        682: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        239: {
            1: fa_d1,
            2: fa_e1
        },
        58: {
            1: fa_b1,
            2: fa_c1
        },
        59: {
            1: fa_b1,
            2: fa_c1
        },
        681: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        234: {
            1: fa_d1,
            2: fa_e1
        },
        235: {
            1: fa_d1,
            2: fa_e1
        },
        236: {
            1: fa_d1,
            2: fa_e1
        },
        237: {
            1: fa_d1,
            2: fa_e1
        },
        725: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        726: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        727: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        728: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        782: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        778: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        779: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        780: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        781: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        783: {
            1: fa_s1,
            2: fa_k3,
            3: fa_b4,
            4: fa_c4,
            5: fa_d4,
            6: fa_e4,
            7: fa_f4,
            8: fa_k1
        },
        773: {
            1: fa_s1,
            2: fa_k3,
            3: fa_b4,
            4: fa_c4,
            5: fa_d4,
            6: fa_e4,
            7: fa_f4,
            8: fa_j1
        },
        474: {
            1: fa_g4,
            2: fa_h4
        },
        421: {
            1: fa_n1,
            2: fa_o1
        },
        530: {
            1: fa_n1,
            2: fa_o1
        },
        422: {
            1: fa_n1,
            2: fa_o1
        },
        531: {
            1: fa_n1,
            2: fa_o1
        },
        444: {
            1: fa_i4,
            2: fa_j4
        },
        888: {
            1: fa_k4,
            2: fa_l4,
            3: fa_m4,
            4: fa_n4
        },
        280: {
            1: fa_d1,
            2: fa_e1
        },
        317: {
            1: fa_d1,
            2: fa_e1
        },
        424: {
            1: fa_n1,
            2: fa_o1
        },
        533: {
            1: fa_n1,
            2: fa_o1
        },
        423: {
            1: fa_n1,
            2: fa_o1
        },
        532: {
            1: fa_n1,
            2: fa_o1
        },
        637: {
            1: fa_n1,
            2: fa_o1
        },
        788: {
            1: fa_o4,
            2: fa_p4,
            3: fa_q4,
            4: fa_r4,
            5: fa_s4,
            6: fa_t4,
            7: fa_u4,
            8: fa_v4,
            9: fa_w4,
            10: fa_x4,
            11: fa_y4,
            12: fa_z4,
            13: fa_a5,
            14: fa_b5
        },
        784: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_e5,
            5: fa_f5
        },
        785: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_e5,
            5: fa_f5
        },
        786: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_e5,
            5: fa_f5
        },
        787: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_e5,
            5: fa_f5
        },
        774: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_i5,
            5: fa_j5
        },
        775: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_i5,
            5: fa_j5
        },
        776: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_i5,
            5: fa_j5
        },
        777: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_i5,
            5: fa_j5
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        246: {
            1: fa_d1,
            2: fa_e1
        },
        248: {
            1: fa_d1,
            2: fa_e1
        },
        240: {
            1: fa_d1,
            2: fa_e1
        },
        232: {
            1: fa_d1,
            2: fa_e1
        },
        241: {
            1: fa_d1,
            2: fa_e1
        },
        233: {
            1: fa_d1,
            2: fa_e1
        },
        61: {
            1: fa_b1,
            2: fa_c1
        },
        62: {
            1: fa_b1,
            2: fa_c1
        },
        684: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        685: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        890: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5,
            4: fa_n5
        },
        242: {
            1: fa_d1,
            2: fa_e1
        },
        245: {
            1: fa_d1,
            2: fa_e1
        },
        243: {
            1: fa_d1,
            2: fa_e1
        },
        60: {
            1: fa_b1,
            2: fa_c1
        },
        683: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        406: {
            1: fa_a2,
            2: fa_b2
        },
        405: {
            1: fa_a2,
            2: fa_b2
        },
        404: {
            1: fa_a2,
            2: fa_b2
        },
        700: {
            1: fa_o5,
            2: fa_p5,
            3: fa_q5
        },
        408: {
            1: fa_a2,
            2: fa_b2
        },
        407: {
            1: fa_a2,
            2: fa_b2
        },
        247: {
            1: fa_d1,
            2: fa_e1
        },
        244: {
            1: fa_d1,
            2: fa_e1
        },
        638: {
            1: fa_a2,
            2: fa_b2
        },
        639: {
            1: fa_a2,
            2: fa_b2
        },
        640: {
            1: fa_a2,
            2: fa_b2
        },
        641: {
            1: fa_a2,
            2: fa_b2
        },
        646: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5
        },
        642: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5
        },
        643: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5
        },
        644: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5
        },
        645: {
            1: fa_r5,
            2: fa_s5,
            3: fa_t5
        }
    },
    41: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        791: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        792: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        637: {
            1: fa_n1,
            2: fa_o1
        },
        796: {
            1: fa_o4,
            2: fa_p4,
            3: fa_q4,
            4: fa_r4,
            5: fa_s4,
            6: fa_t4,
            7: fa_u5,
            8: fa_v4,
            9: fa_w4,
            10: fa_x4,
            11: fa_y4,
            12: fa_z4,
            13: fa_a5,
            14: fa_v5
        },
        794: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_w5,
            5: fa_f5
        },
        795: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_w5,
            5: fa_f5
        },
        789: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_x5,
            5: fa_j5
        },
        790: {
            1: fa_v4,
            2: fa_g5,
            3: fa_h5,
            4: fa_x5,
            5: fa_j5
        },
        725: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        726: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        793: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        411: {
            1: fa_a2,
            2: fa_b2
        },
        701: {
            1: fa_y5,
            2: fa_z5,
            3: fa_a6
        },
        251: {
            1: fa_d1,
            2: fa_e1
        },
        252: {
            1: fa_d1,
            2: fa_e1
        },
        409: {
            1: fa_n1,
            2: fa_o1
        },
        430: {
            1: fa_n1,
            2: fa_o1
        },
        410: {
            1: fa_n1,
            2: fa_o1
        },
        431: {
            1: fa_n1,
            2: fa_o1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        249: {
            1: fa_d1,
            2: fa_p1
        },
        250: {
            1: fa_d1,
            2: fa_e1
        },
        63: {
            1: fa_b1,
            2: fa_c1
        },
        64: {
            1: fa_b1,
            2: fa_c1
        },
        686: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        687: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        103: {
            1: fa_b6,
            2: fa_c6
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        648: {
            1: fa_a2,
            2: fa_b2
        },
        649: {
            1: fa_a2,
            2: fa_b2
        }
    },
    18: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        675: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        610: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        806: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6,
            4: fa_g6,
            5: fa_h6,
            6: fa_f5
        },
        893: {
            1: fa_i6,
            2: fa_j6,
            3: fa_k6,
            4: fa_l6,
            5: fa_m6,
            6: fa_n6
        },
        707: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        708: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        709: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        889: {
            1: fa_r6,
            2: fa_p2,
            3: fa_q2,
            4: fa_r2,
            5: fa_s6,
            6: fa_t6,
            7: fa_u6,
            8: fa_v6
        },
        904: {
            1: fa_w6,
            2: fa_x6,
            3: fa_y6,
            4: fa_z6,
            5: fa_a7,
            6: fa_b7,
            7: fa_c7,
            8: fa_d7,
            9: fa_e7
        },
        253: {
            1: fa_d1,
            2: fa_e1
        },
        688: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        65: {
            1: fa_b1,
            2: fa_c1
        },
        751: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_y2,
            6: fa_z2,
            7: fa_a3,
            8: fa_b3,
            9: fa_s1,
            10: fa_t1,
            11: fa_c3,
            12: fa_d3,
            13: fa_u1,
            14: fa_v1,
            15: fa_e3,
            16: fa_w1,
            17: fa_f3,
            18: fa_g3,
            19: fa_h3,
            20: fa_x1,
            21: fa_y1,
            22: fa_z1,
            23: fa_i3,
            24: fa_j3,
            25: fa_k3,
            26: fa_l3,
            27: fa_m3,
            28: fa_n3,
            29: fa_o3,
            30: fa_p3,
            31: fa_q3,
            32: fa_r3,
            33: fa_s3,
            34: fa_t3,
            35: fa_u3
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        743: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        744: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        745: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        350: {
            1: fa_d1,
            2: fa_e1
        }
    },
    3: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        746: {
            1: fa_u1,
            2: fa_v1,
            3: fa_s1,
            4: fa_q1
        },
        102: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        854: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        855: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        856: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        857: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_p7
        },
        858: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_p7
        },
        859: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_p7
        },
        797: {
            1: fa_q7,
            2: fa_r7,
            3: fa_s7,
            4: fa_k1
        },
        798: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        799: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        851: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        852: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        853: {
            1: fa_q7,
            2: fa_r7,
            3: fa_s7,
            4: fa_j1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        905: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        906: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        907: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        443: {
            1: fa_y7,
            2: fa_z7
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        362: {
            1: fa_j1,
            2: fa_k1
        },
        363: {
            1: fa_j1,
            2: fa_k1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_p1
        },
        358: {
            1: fa_j1,
            2: fa_k1
        },
        359: {
            1: fa_j1,
            2: fa_k1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_a2,
            2: fa_b2
        },
        617: {
            1: fa_a2,
            2: fa_b2
        },
        618: {
            1: fa_a2,
            2: fa_b2
        },
        891: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        800: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        801: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        802: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        }
    },
    20: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        145: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        189: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        675: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        676: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        677: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        678: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        679: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        680: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        860: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        861: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        862: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        863: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        864: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        865: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        866: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        867: {
            1: fa_g8,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_h8
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    5: {
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        945: {
            1: fa_n1,
            2: fa_o1
        },
        948: {
            1: fa_i8,
            2: fa_j8,
            3: fa_k8,
            4: fa_l8,
            5: fa_m8
        },
        949: {
            1: fa_n8,
            2: fa_o8,
            3: fa_p8,
            4: fa_q8,
            5: fa_r8,
            6: fa_s8,
            7: fa_t8,
            8: fa_u8,
            9: fa_v8,
            10: fa_w8,
            11: fa_x8,
            12: fa_y8,
            13: fa_j8,
            14: fa_k8,
            15: fa_z8,
            16: fa_a9,
            17: fa_b9,
            18: fa_c9,
            19: fa_d9,
            20: fa_e9,
            21: fa_f9,
            22: fa_g9,
            23: fa_h9,
            24: fa_i9,
            25: fa_j9,
            26: fa_k9,
            27: fa_m8
        }
    },
    40: {
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    37: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    38: {
        403: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        413: {
            1: fa_a2,
            2: fa_b2
        },
        414: {
            1: fa_a2,
            2: fa_b2
        }
    },
    42: {
        403: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_l9,
            2: fa_o1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        413: {
            1: fa_a2,
            2: fa_b2
        },
        414: {
            1: fa_a2,
            2: fa_b2
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        569: {
            1: fa_a2,
            2: fa_b2
        },
        570: {
            1: fa_a2,
            2: fa_b2
        },
        698: {
            1: fa_j1,
            2: fa_m9,
            3: fa_k1
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        369: {
            1: fa_j1,
            2: fa_k1
        },
        370: {
            1: fa_j1,
            2: fa_k1
        },
        940: {
            1: fa_j1,
            2: fa_k1
        },
        941: {
            1: fa_j1,
            2: fa_k1
        },
        942: {
            1: fa_j1,
            2: fa_k1
        },
        943: {
            1: fa_j1,
            2: fa_k1
        },
        944: {
            1: fa_j1,
            2: fa_k1
        }
    },
    26: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    25: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    16: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    12: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    36: {
        610: {
            1: fa_j1,
            2: fa_k1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    7: {
        425: {
            1: fa_n1,
            2: fa_o1
        },
        534: {
            1: fa_n1,
            2: fa_o1
        },
        540: {
            1: fa_d1,
            2: fa_p1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_n1,
            2: fa_o1
        },
        261: {
            1: fa_n1,
            2: fa_o1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        803: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        868: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        869: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        870: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        805: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        892: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_n1,
            2: fa_o1
        },
        528: {
            1: fa_n1,
            2: fa_o1
        },
        420: {
            1: fa_n1,
            2: fa_o1
        },
        529: {
            1: fa_n1,
            2: fa_o1
        },
        707: {
            1: fa_o9,
            2: fa_p6,
            3: fa_p9
        },
        708: {
            1: fa_o9,
            2: fa_p6,
            3: fa_p9
        },
        706: {
            1: fa_q9,
            2: fa_r9,
            3: fa_s9
        },
        804: {
            1: fa_t9,
            2: fa_u9,
            3: fa_v9,
            4: fa_w9
        },
        474: {
            1: fa_g4,
            2: fa_h4
        },
        614: {
            1: fa_a2,
            2: fa_b2
        },
        609: {
            1: fa_n1,
            2: fa_o1
        },
        416: {
            1: fa_n1,
            2: fa_o1
        },
        732: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        525: {
            1: fa_n1,
            2: fa_o1
        },
        850: {
            1: fa_x9,
            2: fa_y9,
            3: fa_z9,
            4: fa_a10
        },
        473: {
            1: fa_b10,
            2: fa_c10
        },
        442: {
            1: fa_b10,
            2: fa_c10
        },
        729: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        542: {
            1: fa_n1,
            2: fa_o1
        },
        730: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        471: {
            1: fa_b10,
            2: fa_c10
        },
        635: {
            1: fa_n1,
            2: fa_o1
        },
        714: {
            1: fa_d10,
            2: fa_d2,
            3: fa_e10
        },
        624: {
            1: fa_a2,
            2: fa_b2
        },
        625: {
            1: fa_a2,
            2: fa_b2
        },
        715: {
            1: fa_f10,
            2: fa_g10,
            3: fa_h10
        },
        650: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        651: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        652: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        653: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        654: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        655: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        634: {
            1: fa_n1,
            2: fa_o1
        },
        626: {
            1: fa_n1,
            2: fa_o1
        },
        733: {
            1: fa_f10,
            2: fa_g10,
            3: fa_i10
        },
        734: {
            1: fa_f10,
            2: fa_g10,
            3: fa_i10
        },
        258: {
            1: fa_d1,
            2: fa_e1
        },
        259: {
            1: fa_d1,
            2: fa_e1
        },
        66: {
            1: fa_b1,
            2: fa_c1
        },
        67: {
            1: fa_b1,
            2: fa_c1
        },
        81: {
            1: fa_b1,
            2: fa_c1
        },
        68: {
            1: fa_b1,
            2: fa_c1
        },
        689: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        690: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        699: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        691: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        723: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        633: {
            1: fa_n1,
            2: fa_o1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_w6,
            2: fa_j10,
            3: fa_y6,
            4: fa_k10,
            5: fa_l10,
            6: fa_m10,
            7: fa_c7,
            8: fa_n10,
            9: fa_e7
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_y2,
            6: fa_z2,
            7: fa_o10,
            8: fa_a3,
            9: fa_b3,
            10: fa_s1,
            11: fa_t1,
            12: fa_c3,
            13: fa_d3,
            14: fa_p10,
            15: fa_u1,
            16: fa_v1,
            17: fa_e3,
            18: fa_w1,
            19: fa_f3,
            20: fa_x1,
            21: fa_y1,
            22: fa_z1,
            23: fa_i3,
            24: fa_l3,
            25: fa_m3,
            26: fa_n3,
            27: fa_q3,
            28: fa_r3,
            29: fa_q10,
            30: fa_r10,
            31: fa_u3
        },
        871: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        255: {
            1: fa_d1,
            2: fa_p1
        },
        705: {
            1: fa_s10,
            2: fa_t10,
            3: fa_u10
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_v10,
            2: fa_d2,
            3: fa_e10
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2,
            5: fa_l2,
            6: fa_m2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_w10,
            2: fa_x10
        },
        526: {
            1: fa_w10,
            2: fa_x10
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_p1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        765: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        766: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        415: {
            1: fa_n1,
            2: fa_o1
        },
        524: {
            1: fa_n1,
            2: fa_o1
        },
        418: {
            1: fa_n1,
            2: fa_o1
        },
        527: {
            1: fa_n1,
            2: fa_o1
        },
        743: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        744: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        710: {
            1: fa_t2,
            2: fa_u2,
            3: fa_y10
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_n1,
            2: fa_o1
        },
        327: {
            1: fa_n1,
            2: fa_o1
        },
        724: {
            1: fa_z10,
            2: fa_a11,
            3: fa_b11
        },
        661: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        664: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        666: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        667: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        669: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        672: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        426: {
            1: fa_n1,
            2: fa_o1
        },
        535: {
            1: fa_n1,
            2: fa_o1
        },
        537: {
            1: fa_n1,
            2: fa_o1
        },
        541: {
            1: fa_n1,
            2: fa_o1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        437: {
            1: fa_n1,
            2: fa_o1
        },
        436: {
            1: fa_n1,
            2: fa_o1
        },
        694: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        71: {
            1: fa_b1,
            2: fa_c1
        },
        271: {
            1: fa_d1,
            2: fa_e1
        },
        268: {
            1: fa_d1,
            2: fa_e1
        },
        265: {
            1: fa_d1,
            2: fa_e1
        },
        267: {
            1: fa_d1,
            2: fa_e1
        },
        270: {
            1: fa_c11,
            2: fa_d11
        },
        272: {
            1: fa_d1,
            2: fa_e1
        },
        269: {
            1: fa_d1,
            2: fa_e1
        },
        266: {
            1: fa_d1,
            2: fa_e1
        },
        264: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        660: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        880: {
            1: fa_e11,
            2: fa_f11,
            3: fa_g11,
            4: fa_h11
        },
        879: {
            1: fa_i11,
            2: fa_j11,
            3: fa_k11,
            4: fa_l11
        },
        429: {
            1: fa_n1,
            2: fa_o1
        },
        433: {
            1: fa_n1,
            2: fa_o1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        881: {
            1: fa_m11,
            2: fa_n11,
            3: fa_o11,
            4: fa_p11,
            5: fa_q11,
            6: fa_r11
        },
        273: {
            1: fa_d1,
            2: fa_e1
        },
        274: {
            1: fa_d1,
            2: fa_e1
        },
        435: {
            1: fa_n1,
            2: fa_o1
        },
        704: {
            1: fa_s11,
            2: fa_t11,
            3: fa_u11
        },
        432: {
            1: fa_n1,
            2: fa_o1
        },
        428: {
            1: fa_n1,
            2: fa_o1
        },
        434: {
            1: fa_n1,
            2: fa_o1
        },
        439: {
            1: fa_n1,
            2: fa_o1
        },
        440: {
            1: fa_n1,
            2: fa_o1
        },
        441: {
            1: fa_n1,
            2: fa_o1
        },
        438: {
            1: fa_n1,
            2: fa_o1
        },
        623: {
            1: fa_a2,
            2: fa_b2
        },
        180: {
            1: fa_d1,
            2: fa_e1
        },
        146: {
            1: fa_d1,
            2: fa_e1
        },
        659: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        749: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        69: {
            1: fa_b1,
            2: fa_c1
        },
        262: {
            1: fa_d1,
            2: fa_e1
        },
        692: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        703: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        70: {
            1: fa_b1,
            2: fa_c1
        },
        263: {
            1: fa_d1,
            2: fa_e1
        },
        693: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        72: {
            1: fa_b1,
            2: fa_c1
        },
        277: {
            1: fa_v11,
            2: fa_e1
        },
        695: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        750: {
            1: fa_a3,
            2: fa_u1,
            3: fa_x1,
            4: fa_v1,
            5: fa_y1,
            6: fa_z1,
            7: fa_m3,
            8: fa_n3,
            9: fa_o3,
            10: fa_t3,
            11: fa_w11,
            12: fa_x11,
            13: fa_x2,
            14: fa_q1,
            15: fa_r1,
            16: fa_s1,
            17: fa_t1,
            18: fa_w1,
            19: fa_c3,
            20: fa_f3,
            21: fa_j3,
            22: fa_k3,
            23: fa_y11,
            24: fa_z11
        },
        181: {
            1: fa_d1,
            2: fa_e1
        },
        147: {
            1: fa_d1,
            2: fa_e1
        },
        276: {
            1: fa_d1,
            2: fa_e1
        },
        275: {
            1: fa_d1,
            2: fa_e1
        },
        735: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        736: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        737: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        738: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        739: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        740: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        356: {
            1: fa_d1,
            2: fa_e1
        },
        357: {
            1: fa_d1,
            2: fa_e1
        },
        354: {
            1: fa_d1,
            2: fa_e1
        },
        355: {
            1: fa_d1,
            2: fa_e1
        },
        937: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12,
            5: fa_e12,
            6: fa_f12,
            7: fa_g12,
            8: fa_h12,
            9: fa_i12,
            10: fa_j12
        },
        657: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        658: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        412: {
            1: fa_n1,
            2: fa_o1
        }
    },
    14: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    34: {
        425: {
            1: fa_n1,
            2: fa_o1
        },
        534: {
            1: fa_n1,
            2: fa_o1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_n1,
            2: fa_o1
        },
        261: {
            1: fa_n1,
            2: fa_o1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        803: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        868: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        869: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        870: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_n9
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_n1,
            2: fa_o1
        },
        528: {
            1: fa_n1,
            2: fa_o1
        },
        420: {
            1: fa_n1,
            2: fa_o1
        },
        529: {
            1: fa_n1,
            2: fa_o1
        },
        707: {
            1: fa_o9,
            2: fa_p6,
            3: fa_p9
        },
        708: {
            1: fa_o9,
            2: fa_p6,
            3: fa_p9
        },
        706: {
            1: fa_q9,
            2: fa_r9,
            3: fa_s9
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_w6,
            2: fa_j10,
            3: fa_y6,
            4: fa_k10,
            5: fa_l10,
            6: fa_m10,
            7: fa_c7,
            8: fa_n10,
            9: fa_e7
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_y2,
            6: fa_z2,
            7: fa_o10,
            8: fa_a3,
            9: fa_b3,
            10: fa_s1,
            11: fa_t1,
            12: fa_c3,
            13: fa_d3,
            14: fa_p10,
            15: fa_u1,
            16: fa_v1,
            17: fa_e3,
            18: fa_w1,
            19: fa_f3,
            20: fa_x1,
            21: fa_y1,
            22: fa_z1,
            23: fa_i3,
            24: fa_l3,
            25: fa_m3,
            26: fa_n3,
            27: fa_q3,
            28: fa_r3,
            29: fa_q10,
            30: fa_r10,
            31: fa_u3
        },
        871: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_s10,
            2: fa_t10,
            3: fa_u10
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_c11,
            2: fa_d11
        },
        702: {
            1: fa_v10,
            2: fa_d2,
            3: fa_e10
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2,
            5: fa_l2,
            6: fa_m2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_w10,
            2: fa_x10
        },
        526: {
            1: fa_w10,
            2: fa_x10
        },
        325: {
            1: fa_c11,
            2: fa_d11
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        765: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        766: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        415: {
            1: fa_n1,
            2: fa_o1
        },
        524: {
            1: fa_n1,
            2: fa_o1
        },
        418: {
            1: fa_n1,
            2: fa_o1
        },
        527: {
            1: fa_n1,
            2: fa_o1
        },
        743: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        744: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        710: {
            1: fa_t2,
            2: fa_u2,
            3: fa_v2
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_n1,
            2: fa_o1
        },
        327: {
            1: fa_n1,
            2: fa_o1
        },
        724: {
            1: fa_z10,
            2: fa_a11,
            3: fa_b11
        },
        661: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        664: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        666: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        667: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        669: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        672: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        426: {
            1: fa_n1,
            2: fa_o1
        },
        535: {
            1: fa_n1,
            2: fa_o1
        },
        537: {
            1: fa_n1,
            2: fa_o1
        },
        541: {
            1: fa_n1,
            2: fa_o1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    19: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        886: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        887: {
            1: fa_v3,
            2: fa_w3,
            3: fa_x3,
            4: fa_y3,
            5: fa_z3,
            6: fa_a4
        },
        911: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2,
            5: fa_l2,
            6: fa_m2
        },
        884: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_k12,
            5: fa_f5
        },
        885: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_k12,
            5: fa_f5
        },
        882: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_k12,
            5: fa_e2
        },
        883: {
            1: fa_o4,
            2: fa_c5,
            3: fa_d5,
            4: fa_k12,
            5: fa_e2
        },
        723: {
            1: fa_a2,
            2: fa_d2,
            3: fa_b2
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    30: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        279: {
            1: fa_c11,
            2: fa_d11
        },
        610: {
            1: fa_j1,
            2: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        675: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        350: {
            1: fa_c11,
            2: fa_d11
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        415: {
            1: fa_n1,
            2: fa_o1
        },
        524: {
            1: fa_n1,
            2: fa_o1
        },
        743: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        744: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        745: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_a3,
            6: fa_b3,
            7: fa_s1,
            8: fa_t1,
            9: fa_u1,
            10: fa_v1,
            11: fa_e3,
            12: fa_w1,
            13: fa_x1,
            14: fa_y1,
            15: fa_z1,
            16: fa_i3,
            17: fa_u3
        },
        710: {
            1: fa_t2,
            2: fa_u2,
            3: fa_v2
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        426: {
            1: fa_n1,
            2: fa_o1
        },
        535: {
            1: fa_n1,
            2: fa_o1
        },
        706: {
            1: fa_q9,
            2: fa_r9,
            3: fa_s9
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        344: {
            1: fa_d1,
            2: fa_e1
        },
        347: {
            1: fa_d1,
            2: fa_e1
        },
        765: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        766: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        767: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s2
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        751: {
            1: fa_w2,
            2: fa_x2,
            3: fa_q1,
            4: fa_r1,
            5: fa_y2,
            6: fa_z2,
            7: fa_a3,
            8: fa_b3,
            9: fa_s1,
            10: fa_t1,
            11: fa_c3,
            12: fa_d3,
            13: fa_u1,
            14: fa_v1,
            15: fa_e3,
            16: fa_w1,
            17: fa_f3,
            18: fa_g3,
            19: fa_h3,
            20: fa_x1,
            21: fa_y1,
            22: fa_z1,
            23: fa_i3,
            24: fa_j3,
            25: fa_k3,
            26: fa_l3,
            27: fa_m3,
            28: fa_n3,
            29: fa_o3,
            30: fa_p3,
            31: fa_q3,
            32: fa_r3,
            33: fa_s3,
            34: fa_t3,
            35: fa_u3
        },
        911: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2,
            5: fa_l2,
            6: fa_m2
        },
        889: {
            1: fa_r6,
            2: fa_p2,
            3: fa_q2,
            4: fa_r2,
            5: fa_s6,
            6: fa_t6,
            7: fa_u6,
            8: fa_v6
        },
        637: {
            1: fa_n1,
            2: fa_o1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        412: {
            1: fa_n1,
            2: fa_o1
        },
        634: {
            1: fa_n1,
            2: fa_o1
        },
        626: {
            1: fa_n1,
            2: fa_o1
        },
        611: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        904: {
            1: fa_w6,
            2: fa_j10,
            3: fa_y6,
            4: fa_k10,
            5: fa_l10,
            6: fa_m10,
            7: fa_c7,
            8: fa_n10,
            9: fa_e7
        },
        449: {
            1: fa_n1,
            2: fa_o1
        },
        446: {
            1: fa_n1,
            2: fa_o1
        },
        451: {
            1: fa_n1,
            2: fa_o1
        },
        711: {
            1: fa_l12,
            2: fa_m12,
            3: fa_n12
        },
        712: {
            1: fa_o12,
            2: fa_p12,
            3: fa_q12
        },
        713: {
            1: fa_r12,
            2: fa_s12,
            3: fa_t12
        },
        450: {
            1: fa_n1,
            2: fa_o1
        },
        447: {
            1: fa_n1,
            2: fa_o1
        },
        448: {
            1: fa_n1,
            2: fa_o1
        },
        662: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        663: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        665: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        668: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        670: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        671: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        3: {
            1: fa_b1,
            2: fa_c1
        },
        4: {
            1: fa_b1,
            2: fa_c1
        },
        6: {
            1: fa_b1,
            2: fa_c1
        },
        8: {
            1: fa_b1,
            2: fa_c1
        },
        10: {
            1: fa_b1,
            2: fa_c1
        },
        11: {
            1: fa_b1,
            2: fa_c1
        },
        161: {
            1: fa_d1,
            2: fa_e1
        },
        162: {
            1: fa_d1,
            2: fa_e1
        },
        164: {
            1: fa_d1,
            2: fa_e1
        },
        167: {
            1: fa_d1,
            2: fa_e1
        },
        169: {
            1: fa_d1,
            2: fa_e1
        },
        170: {
            1: fa_d1,
            2: fa_e1
        },
        707: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        708: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        709: {
            1: fa_o6,
            2: fa_p6,
            3: fa_q6
        },
        946: {
            1: fa_n1,
            2: fa_o1
        },
        947: {
            1: fa_n1,
            2: fa_o1
        }
    },
    23: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    13: {
        468: {
            1: fa_u12,
            2: fa_v12
        },
        470: {
            1: fa_u12,
            2: fa_v12
        },
        467: {
            1: fa_u12,
            2: fa_v12
        },
        469: {
            1: fa_u12,
            2: fa_v12
        },
        464: {
            1: fa_w12,
            2: fa_x12
        },
        466: {
            1: fa_y12,
            2: fa_z12
        },
        465: {
            1: fa_y12,
            2: fa_z12
        },
        463: {
            1: fa_y12,
            2: fa_z12
        },
        289: {
            1: fa_c11,
            2: fa_d11
        },
        288: {
            1: fa_c11,
            2: fa_d11
        },
        292: {
            1: fa_c11,
            2: fa_d11
        },
        461: {
            1: fa_y12,
            2: fa_z12
        },
        283: {
            1: fa_c11,
            2: fa_d11
        },
        295: {
            1: fa_c11,
            2: fa_d11
        },
        293: {
            1: fa_c11,
            2: fa_d11
        },
        284: {
            1: fa_c11,
            2: fa_d11
        },
        285: {
            1: fa_c11,
            2: fa_d11
        },
        316: {
            1: fa_c11,
            2: fa_d11
        },
        286: {
            1: fa_c11,
            2: fa_d11
        },
        287: {
            1: fa_c11,
            2: fa_d11
        },
        290: {
            1: fa_c11,
            2: fa_d11
        },
        291: {
            1: fa_c11,
            2: fa_d11
        },
        462: {
            1: fa_y12,
            2: fa_z12
        },
        294: {
            1: fa_c11,
            2: fa_d11
        }
    },
    39: {
        403: {
            1: fa_j1,
            2: fa_k1
        },
        443: {
            1: fa_a13,
            2: fa_b13
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        950: {
            1: fa_n8,
            2: fa_o8,
            3: fa_p8,
            4: fa_c13,
            5: fa_r8,
            6: fa_d13,
            7: fa_e13,
            8: fa_z8,
            9: fa_a9,
            10: fa_b9,
            11: fa_c9,
            12: fa_d9,
            13: fa_f13
        },
        955: {
            1: fa_n1,
            2: fa_o1
        },
        951: {
            1: fa_g13,
            2: fa_h13
        },
        952: {
            1: fa_g13,
            2: fa_h13
        },
        953: {
            1: fa_g13,
            2: fa_h13
        },
        954: {
            1: fa_g13,
            2: fa_h13
        }
    },
    33: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    24: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    9: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    21: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    29: {
        394: {
            1: fa_j1,
            2: fa_k1
        },
        395: {
            1: fa_j1,
            2: fa_k1
        },
        396: {
            1: fa_j1,
            2: fa_k1
        },
        397: {
            1: fa_j1,
            2: fa_k1
        },
        398: {
            1: fa_j1,
            2: fa_k1
        },
        399: {
            1: fa_j1,
            2: fa_k1
        },
        400: {
            1: fa_j1,
            2: fa_k1
        },
        401: {
            1: fa_j1,
            2: fa_k1
        },
        402: {
            1: fa_j1,
            2: fa_k1
        },
        100: {
            1: fa_h1,
            2: fa_i1
        },
        101: {
            1: fa_h1,
            2: fa_i1
        },
        104: {
            1: fa_h1,
            2: fa_i1
        },
        105: {
            1: fa_h1,
            2: fa_i1
        },
        106: {
            1: fa_h1,
            2: fa_i1
        },
        107: {
            1: fa_h1,
            2: fa_i1
        },
        108: {
            1: fa_h1,
            2: fa_i1
        },
        109: {
            1: fa_h1,
            2: fa_i1
        },
        110: {
            1: fa_h1,
            2: fa_i1
        },
        111: {
            1: fa_h1,
            2: fa_i1
        },
        112: {
            1: fa_h1,
            2: fa_i1
        },
        113: {
            1: fa_h1,
            2: fa_i1
        },
        114: {
            1: fa_h1,
            2: fa_i1
        },
        115: {
            1: fa_h1,
            2: fa_i1
        },
        116: {
            1: fa_h1,
            2: fa_i1
        },
        117: {
            1: fa_h1,
            2: fa_i1
        },
        118: {
            1: fa_h1,
            2: fa_i1
        },
        119: {
            1: fa_h1,
            2: fa_i1
        },
        120: {
            1: fa_h1,
            2: fa_i1
        },
        121: {
            1: fa_h1,
            2: fa_i1
        },
        808: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        809: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        810: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        811: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        812: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        813: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        814: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        815: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        816: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        817: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        818: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        819: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        820: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        821: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        822: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        823: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        824: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        825: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        826: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        827: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        828: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        829: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        830: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        831: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        832: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        833: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        834: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        835: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        836: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        837: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        838: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        839: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        840: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        841: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        842: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        843: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        844: {
            1: fa_i13,
            2: fa_j13,
            3: fa_k13,
            4: fa_l13,
            5: fa_m13,
            6: fa_n13
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        369: {
            1: fa_j1,
            2: fa_k1
        },
        370: {
            1: fa_j1,
            2: fa_k1
        },
        371: {
            1: fa_j1,
            2: fa_k1
        },
        372: {
            1: fa_j1,
            2: fa_k1
        },
        373: {
            1: fa_j1,
            2: fa_k1
        },
        374: {
            1: fa_j1,
            2: fa_k1
        },
        375: {
            1: fa_j1,
            2: fa_k1
        },
        376: {
            1: fa_j1,
            2: fa_k1
        },
        377: {
            1: fa_j1,
            2: fa_k1
        },
        378: {
            1: fa_j1,
            2: fa_k1
        },
        379: {
            1: fa_j1,
            2: fa_k1
        },
        380: {
            1: fa_j1,
            2: fa_k1
        },
        381: {
            1: fa_j1,
            2: fa_k1
        },
        382: {
            1: fa_j1,
            2: fa_k1
        },
        383: {
            1: fa_j1,
            2: fa_k1
        },
        384: {
            1: fa_j1,
            2: fa_k1
        },
        385: {
            1: fa_j1,
            2: fa_k1
        },
        386: {
            1: fa_j1,
            2: fa_k1
        },
        387: {
            1: fa_j1,
            2: fa_k1
        },
        388: {
            1: fa_j1,
            2: fa_k1
        },
        389: {
            1: fa_j1,
            2: fa_k1
        },
        390: {
            1: fa_j1,
            2: fa_k1
        },
        391: {
            1: fa_j1,
            2: fa_k1
        },
        392: {
            1: fa_j1,
            2: fa_k1
        },
        393: {
            1: fa_j1,
            2: fa_k1
        },
        481: {
            1: fa_a2,
            2: fa_b2
        },
        482: {
            1: fa_a2,
            2: fa_b2
        },
        483: {
            1: fa_a2,
            2: fa_b2
        },
        484: {
            1: fa_a2,
            2: fa_b2
        },
        485: {
            1: fa_a2,
            2: fa_b2
        },
        486: {
            1: fa_a2,
            2: fa_b2
        },
        487: {
            1: fa_a2,
            2: fa_b2
        },
        488: {
            1: fa_a2,
            2: fa_b2
        },
        489: {
            1: fa_a2,
            2: fa_b2
        },
        490: {
            1: fa_a2,
            2: fa_b2
        },
        491: {
            1: fa_a2,
            2: fa_b2
        },
        492: {
            1: fa_a2,
            2: fa_b2
        },
        493: {
            1: fa_a2,
            2: fa_b2
        },
        494: {
            1: fa_a2,
            2: fa_b2
        },
        495: {
            1: fa_a2,
            2: fa_b2
        },
        496: {
            1: fa_a2,
            2: fa_b2
        },
        497: {
            1: fa_a2,
            2: fa_b2
        },
        498: {
            1: fa_a2,
            2: fa_b2
        },
        499: {
            1: fa_a2,
            2: fa_b2
        },
        500: {
            1: fa_a2,
            2: fa_b2
        },
        501: {
            1: fa_a2,
            2: fa_b2
        },
        502: {
            1: fa_a2,
            2: fa_b2
        },
        503: {
            1: fa_a2,
            2: fa_b2
        },
        504: {
            1: fa_a2,
            2: fa_b2
        },
        505: {
            1: fa_a2,
            2: fa_b2
        },
        506: {
            1: fa_a2,
            2: fa_b2
        },
        507: {
            1: fa_a2,
            2: fa_b2
        },
        508: {
            1: fa_a2,
            2: fa_b2
        },
        509: {
            1: fa_a2,
            2: fa_b2
        },
        510: {
            1: fa_a2,
            2: fa_b2
        },
        511: {
            1: fa_a2,
            2: fa_b2
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        569: {
            1: fa_a2,
            2: fa_b2
        },
        570: {
            1: fa_a2,
            2: fa_b2
        },
        571: {
            1: fa_a2,
            2: fa_b2
        },
        572: {
            1: fa_a2,
            2: fa_b2
        },
        573: {
            1: fa_a2,
            2: fa_b2
        },
        574: {
            1: fa_a2,
            2: fa_b2
        },
        575: {
            1: fa_a2,
            2: fa_b2
        },
        576: {
            1: fa_a2,
            2: fa_b2
        },
        577: {
            1: fa_a2,
            2: fa_b2
        },
        578: {
            1: fa_a2,
            2: fa_b2
        },
        579: {
            1: fa_a2,
            2: fa_b2
        },
        580: {
            1: fa_a2,
            2: fa_b2
        },
        581: {
            1: fa_a2,
            2: fa_b2
        },
        582: {
            1: fa_a2,
            2: fa_b2
        },
        583: {
            1: fa_a2,
            2: fa_b2
        },
        584: {
            1: fa_a2,
            2: fa_b2
        },
        585: {
            1: fa_a2,
            2: fa_b2
        },
        586: {
            1: fa_a2,
            2: fa_b2
        },
        587: {
            1: fa_a2,
            2: fa_b2
        },
        588: {
            1: fa_a2,
            2: fa_b2
        },
        589: {
            1: fa_a2,
            2: fa_b2
        },
        590: {
            1: fa_a2,
            2: fa_b2
        },
        591: {
            1: fa_a2,
            2: fa_b2
        },
        592: {
            1: fa_a2,
            2: fa_b2
        },
        593: {
            1: fa_a2,
            2: fa_b2
        },
        594: {
            1: fa_a2,
            2: fa_b2
        },
        595: {
            1: fa_a2,
            2: fa_b2
        },
        596: {
            1: fa_a2,
            2: fa_b2
        },
        597: {
            1: fa_a2,
            2: fa_b2
        },
        598: {
            1: fa_a2,
            2: fa_b2
        },
        599: {
            1: fa_a2,
            2: fa_b2
        },
        600: {
            1: fa_a2,
            2: fa_b2
        },
        601: {
            1: fa_a2,
            2: fa_b2
        },
        602: {
            1: fa_a2,
            2: fa_b2
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        86: {
            1: fa_h1,
            2: fa_i1
        },
        87: {
            1: fa_h1,
            2: fa_i1
        },
        88: {
            1: fa_h1,
            2: fa_i1
        },
        89: {
            1: fa_h1,
            2: fa_i1
        },
        90: {
            1: fa_h1,
            2: fa_i1
        },
        91: {
            1: fa_h1,
            2: fa_i1
        },
        92: {
            1: fa_h1,
            2: fa_i1
        },
        93: {
            1: fa_h1,
            2: fa_i1
        },
        94: {
            1: fa_h1,
            2: fa_i1
        },
        95: {
            1: fa_h1,
            2: fa_i1
        },
        96: {
            1: fa_h1,
            2: fa_i1
        },
        97: {
            1: fa_h1,
            2: fa_i1
        },
        98: {
            1: fa_h1,
            2: fa_i1
        },
        99: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_c11,
            2: fa_d11
        },
        254: {
            1: fa_c11,
            2: fa_d11
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        29: {
            1: fa_b1,
            2: fa_c1
        },
        30: {
            1: fa_b1,
            2: fa_c1
        },
        31: {
            1: fa_b1,
            2: fa_c1
        },
        32: {
            1: fa_b1,
            2: fa_c1
        },
        33: {
            1: fa_b1,
            2: fa_c1
        },
        34: {
            1: fa_b1,
            2: fa_c1
        },
        35: {
            1: fa_b1,
            2: fa_c1
        },
        36: {
            1: fa_b1,
            2: fa_c1
        },
        37: {
            1: fa_b1,
            2: fa_c1
        },
        38: {
            1: fa_b1,
            2: fa_c1
        },
        39: {
            1: fa_b1,
            2: fa_c1
        },
        40: {
            1: fa_b1,
            2: fa_c1
        },
        41: {
            1: fa_b1,
            2: fa_c1
        },
        42: {
            1: fa_b1,
            2: fa_c1
        },
        43: {
            1: fa_b1,
            2: fa_c1
        },
        44: {
            1: fa_b1,
            2: fa_c1
        },
        45: {
            1: fa_b1,
            2: fa_c1
        },
        46: {
            1: fa_b1,
            2: fa_c1
        },
        47: {
            1: fa_b1,
            2: fa_c1
        },
        48: {
            1: fa_b1,
            2: fa_c1
        },
        49: {
            1: fa_b1,
            2: fa_c1
        },
        50: {
            1: fa_b1,
            2: fa_c1
        },
        51: {
            1: fa_b1,
            2: fa_c1
        },
        52: {
            1: fa_b1,
            2: fa_c1
        },
        53: {
            1: fa_b1,
            2: fa_c1
        },
        54: {
            1: fa_b1,
            2: fa_c1
        },
        55: {
            1: fa_b1,
            2: fa_c1
        },
        56: {
            1: fa_b1,
            2: fa_c1
        },
        57: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        203: {
            1: fa_d1,
            2: fa_e1
        },
        204: {
            1: fa_d1,
            2: fa_e1
        },
        205: {
            1: fa_d1,
            2: fa_e1
        },
        206: {
            1: fa_d1,
            2: fa_e1
        },
        207: {
            1: fa_d1,
            2: fa_e1
        },
        208: {
            1: fa_d1,
            2: fa_e1
        },
        209: {
            1: fa_d1,
            2: fa_e1
        },
        210: {
            1: fa_d1,
            2: fa_e1
        },
        211: {
            1: fa_d1,
            2: fa_e1
        },
        212: {
            1: fa_d1,
            2: fa_e1
        },
        213: {
            1: fa_d1,
            2: fa_e1
        },
        214: {
            1: fa_d1,
            2: fa_e1
        },
        215: {
            1: fa_d1,
            2: fa_e1
        },
        216: {
            1: fa_d1,
            2: fa_e1
        },
        217: {
            1: fa_d1,
            2: fa_e1
        },
        218: {
            1: fa_d1,
            2: fa_e1
        },
        219: {
            1: fa_d1,
            2: fa_e1
        },
        220: {
            1: fa_d1,
            2: fa_e1
        },
        221: {
            1: fa_d1,
            2: fa_e1
        },
        222: {
            1: fa_d1,
            2: fa_e1
        },
        223: {
            1: fa_d1,
            2: fa_e1
        },
        224: {
            1: fa_d1,
            2: fa_e1
        },
        225: {
            1: fa_d1,
            2: fa_e1
        },
        226: {
            1: fa_d1,
            2: fa_e1
        },
        227: {
            1: fa_d1,
            2: fa_e1
        },
        228: {
            1: fa_d1,
            2: fa_e1
        },
        229: {
            1: fa_d1,
            2: fa_e1
        },
        230: {
            1: fa_d1,
            2: fa_e1
        },
        231: {
            1: fa_d1,
            2: fa_e1
        },
        475: {
            1: fa_a2,
            2: fa_b2
        },
        476: {
            1: fa_a2,
            2: fa_b2
        },
        477: {
            1: fa_a2,
            2: fa_b2
        },
        478: {
            1: fa_a2,
            2: fa_b2
        },
        479: {
            1: fa_a2,
            2: fa_b2
        },
        480: {
            1: fa_a2,
            2: fa_b2
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    15: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    2: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_c11,
            2: fa_d11
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        102: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        569: {
            1: fa_a2,
            2: fa_b2
        },
        570: {
            1: fa_a2,
            2: fa_b2
        },
        571: {
            1: fa_a2,
            2: fa_b2
        },
        572: {
            1: fa_a2,
            2: fa_b2
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        369: {
            1: fa_j1,
            2: fa_k1
        },
        370: {
            1: fa_j1,
            2: fa_k1
        },
        371: {
            1: fa_j1,
            2: fa_k1
        },
        372: {
            1: fa_j1,
            2: fa_k1
        },
        122: {
            1: fa_n1,
            2: fa_o1
        },
        123: {
            1: fa_n1,
            2: fa_o1
        },
        124: {
            1: fa_n1,
            2: fa_o1
        },
        125: {
            1: fa_n1,
            2: fa_o1
        },
        126: {
            1: fa_n1,
            2: fa_o1
        },
        127: {
            1: fa_n1,
            2: fa_o1
        },
        128: {
            1: fa_n1,
            2: fa_o1
        },
        129: {
            1: fa_n1,
            2: fa_o1
        },
        130: {
            1: fa_n1,
            2: fa_o1
        },
        131: {
            1: fa_n1,
            2: fa_o1
        },
        132: {
            1: fa_n1,
            2: fa_o1
        },
        133: {
            1: fa_n1,
            2: fa_o1
        },
        134: {
            1: fa_n1,
            2: fa_o1
        },
        135: {
            1: fa_n1,
            2: fa_o1
        },
        872: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        873: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        874: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        875: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        876: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        877: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        878: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_o13
        },
        616: {
            1: fa_a2,
            2: fa_b2
        },
        617: {
            1: fa_a2,
            2: fa_b2
        },
        618: {
            1: fa_a2,
            2: fa_b2
        },
        619: {
            1: fa_a2,
            2: fa_b2
        },
        620: {
            1: fa_a2,
            2: fa_b2
        },
        621: {
            1: fa_a2,
            2: fa_b2
        },
        622: {
            1: fa_a2,
            2: fa_b2
        },
        894: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        895: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        896: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        897: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        898: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        899: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        900: {
            1: fa_p13,
            2: fa_q13,
            3: fa_r13,
            4: fa_s13
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        86: {
            1: fa_h1,
            2: fa_i1
        },
        87: {
            1: fa_h1,
            2: fa_i1
        },
        88: {
            1: fa_h1,
            2: fa_i1
        },
        89: {
            1: fa_h1,
            2: fa_i1
        },
        257: {
            1: fa_t13,
            2: fa_e1
        },
        307: {
            1: fa_t13,
            2: fa_e1
        },
        752: {
            1: fa_x1,
            2: fa_y1,
            3: fa_z1,
            4: fa_w1,
            5: fa_t1,
            6: fa_r1
        },
        753: {
            1: fa_l3,
            2: fa_m3,
            3: fa_n3,
            4: fa_o3,
            5: fa_j3,
            6: fa_f3,
            7: fa_c3,
            8: fa_y2
        }
    },
    6: {
        553: {
            1: fa_n1,
            2: fa_o1
        },
        339: {
            1: fa_d1,
            2: fa_p1
        },
        547: {
            1: fa_b10,
            2: fa_c10
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        86: {
            1: fa_h1,
            2: fa_i1
        },
        87: {
            1: fa_h1,
            2: fa_i1
        },
        807: {
            1: fa_w6,
            2: fa_y6,
            3: fa_c7,
            4: fa_e7
        },
        636: {
            1: fa_n1,
            2: fa_o1
        },
        334: {
            1: fa_d1,
            2: fa_e1
        },
        335: {
            1: fa_d1,
            2: fa_e1
        },
        336: {
            1: fa_d1,
            2: fa_e1
        },
        337: {
            1: fa_d1,
            2: fa_e1
        },
        906: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        907: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        908: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        909: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        300: {
            1: fa_d1,
            2: fa_e1
        },
        301: {
            1: fa_d1,
            2: fa_e1
        },
        302: {
            1: fa_d1,
            2: fa_e1
        },
        303: {
            1: fa_d1,
            2: fa_e1
        },
        304: {
            1: fa_d1,
            2: fa_e1
        },
        310: {
            1: fa_d1,
            2: fa_e1
        },
        311: {
            1: fa_d1,
            2: fa_e1
        },
        312: {
            1: fa_d1,
            2: fa_e1
        },
        313: {
            1: fa_d1,
            2: fa_e1
        },
        314: {
            1: fa_d1,
            2: fa_e1
        },
        554: {
            1: fa_n1,
            2: fa_o1
        },
        555: {
            1: fa_n1,
            2: fa_o1
        },
        556: {
            1: fa_n1,
            2: fa_o1
        },
        557: {
            1: fa_n1,
            2: fa_o1
        },
        558: {
            1: fa_n1,
            2: fa_o1
        },
        517: {
            1: fa_n1,
            2: fa_o1
        },
        518: {
            1: fa_n1,
            2: fa_o1
        },
        519: {
            1: fa_n1,
            2: fa_o1
        },
        520: {
            1: fa_n1,
            2: fa_o1
        },
        521: {
            1: fa_n1,
            2: fa_o1
        },
        561: {
            1: fa_n1,
            2: fa_o1
        },
        562: {
            1: fa_n1,
            2: fa_o1
        },
        563: {
            1: fa_n1,
            2: fa_o1
        },
        564: {
            1: fa_n1,
            2: fa_o1
        },
        565: {
            1: fa_n1,
            2: fa_o1
        },
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_q1,
            2: fa_r1,
            3: fa_s1,
            4: fa_t1,
            5: fa_u1,
            6: fa_v1,
            7: fa_w1,
            8: fa_x1,
            9: fa_y1,
            10: fa_z1
        },
        102: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        903: {
            1: fa_u13,
            2: fa_v13,
            3: fa_w13,
            4: fa_x13,
            5: fa_y13,
            6: fa_z13,
            7: fa_a14,
            8: fa_b14
        },
        445: {
            1: fa_a2,
            2: fa_b2
        },
        754: {
            1: fa_o10,
            2: fa_p10,
            3: fa_h3,
            4: fa_c14,
            5: fa_t7,
            6: fa_d14,
            7: fa_q10,
            8: fa_r10,
            9: fa_e14,
            10: fa_f14,
            11: fa_g14,
            12: fa_h14,
            13: fa_i14,
            14: fa_j14
        },
        755: {
            1: fa_o10,
            2: fa_p10,
            3: fa_h3,
            4: fa_c14,
            5: fa_t7,
            6: fa_d14,
            7: fa_q10,
            8: fa_r10,
            9: fa_e14,
            10: fa_f14,
            11: fa_g14,
            12: fa_h14,
            13: fa_i14,
            14: fa_j14
        },
        756: {
            1: fa_o10,
            2: fa_p10,
            3: fa_h3,
            4: fa_c14,
            5: fa_t7,
            6: fa_d14,
            7: fa_q10,
            8: fa_r10,
            9: fa_e14,
            10: fa_f14,
            11: fa_g14,
            12: fa_h14,
            13: fa_i14,
            14: fa_j14
        },
        757: {
            1: fa_o10,
            2: fa_p10,
            3: fa_h3,
            4: fa_c14,
            5: fa_t7,
            6: fa_d14,
            7: fa_q10,
            8: fa_r10,
            9: fa_e14,
            10: fa_f14,
            11: fa_g14,
            12: fa_h14,
            13: fa_i14,
            14: fa_j14
        },
        758: {
            1: fa_o10,
            2: fa_p10,
            3: fa_h3,
            4: fa_c14,
            5: fa_t7,
            6: fa_d14,
            7: fa_q10,
            8: fa_r10,
            9: fa_e14,
            10: fa_f14,
            11: fa_g14,
            12: fa_h14,
            13: fa_i14,
            14: fa_j14
        },
        452: {
            1: fa_b10,
            2: fa_c10
        },
        453: {
            1: fa_b10,
            2: fa_c10
        },
        454: {
            1: fa_b10,
            2: fa_c10
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        569: {
            1: fa_a2,
            2: fa_b2
        },
        570: {
            1: fa_a2,
            2: fa_b2
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        369: {
            1: fa_j1,
            2: fa_k1
        },
        370: {
            1: fa_j1,
            2: fa_k1
        },
        522: {
            1: fa_a2,
            2: fa_b2
        },
        627: {
            1: fa_n1,
            2: fa_o1
        },
        628: {
            1: fa_n1,
            2: fa_o1
        },
        629: {
            1: fa_n1,
            2: fa_o1
        },
        630: {
            1: fa_n1,
            2: fa_o1
        },
        631: {
            1: fa_n1,
            2: fa_o1
        },
        632: {
            1: fa_n1,
            2: fa_o1
        },
        190: {
            1: fa_d1,
            2: fa_e1
        },
        191: {
            1: fa_d1,
            2: fa_e1
        },
        192: {
            1: fa_d1,
            2: fa_e1
        },
        193: {
            1: fa_d1,
            2: fa_e1
        },
        194: {
            1: fa_d1,
            2: fa_e1
        },
        759: {
            1: fa_k14,
            2: fa_l14,
            3: fa_m14,
            4: fa_n14,
            5: fa_o14,
            6: fa_i14,
            7: fa_p14,
            8: fa_q14,
            9: fa_r14,
            10: fa_s14,
            11: fa_t14,
            12: fa_u14,
            13: fa_d14,
            14: fa_v14
        },
        760: {
            1: fa_k14,
            2: fa_l14,
            3: fa_m14,
            4: fa_n14,
            5: fa_o14,
            6: fa_i14,
            7: fa_p14,
            8: fa_q14,
            9: fa_r14,
            10: fa_s14,
            11: fa_t14,
            12: fa_u14,
            13: fa_d14,
            14: fa_v14
        },
        761: {
            1: fa_k14,
            2: fa_l14,
            3: fa_m14,
            4: fa_n14,
            5: fa_o14,
            6: fa_i14,
            7: fa_p14,
            8: fa_q14,
            9: fa_r14,
            10: fa_s14,
            11: fa_t14,
            12: fa_u14,
            13: fa_d14,
            14: fa_v14
        },
        762: {
            1: fa_k14,
            2: fa_l14,
            3: fa_m14,
            4: fa_n14,
            5: fa_o14,
            6: fa_i14,
            7: fa_p14,
            8: fa_q14,
            9: fa_r14,
            10: fa_s14,
            11: fa_t14,
            12: fa_u14,
            13: fa_d14,
            14: fa_v14
        },
        763: {
            1: fa_k14,
            2: fa_l14,
            3: fa_m14,
            4: fa_n14,
            5: fa_o14,
            6: fa_i14,
            7: fa_p14,
            8: fa_q14,
            9: fa_r14,
            10: fa_s14,
            11: fa_t14,
            12: fa_u14,
            13: fa_d14,
            14: fa_v14
        },
        768: {
            1: fa_u6,
            2: fa_w14,
            3: fa_x14,
            4: fa_y14,
            5: fa_z14,
            6: fa_f2,
            7: fa_a15
        },
        769: {
            1: fa_u6,
            2: fa_w14,
            3: fa_x14,
            4: fa_y14,
            5: fa_z14,
            6: fa_f2,
            7: fa_a15
        },
        770: {
            1: fa_u6,
            2: fa_w14,
            3: fa_x14,
            4: fa_y14,
            5: fa_z14,
            6: fa_f2,
            7: fa_a15
        },
        771: {
            1: fa_u6,
            2: fa_w14,
            3: fa_x14,
            4: fa_y14,
            5: fa_z14,
            6: fa_f2,
            7: fa_a15
        },
        772: {
            1: fa_u6,
            2: fa_w14,
            3: fa_x14,
            4: fa_y14,
            5: fa_z14,
            6: fa_f2,
            7: fa_a15
        },
        603: {
            1: fa_a2,
            2: fa_b2
        },
        604: {
            1: fa_a2,
            2: fa_b2
        },
        605: {
            1: fa_a2,
            2: fa_b2
        },
        606: {
            1: fa_a2,
            2: fa_b2
        },
        607: {
            1: fa_a2,
            2: fa_b2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        696: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        333: {
            1: fa_d1,
            2: fa_e1
        },
        341: {
            1: fa_d1,
            2: fa_e1
        },
        427: {
            1: fa_n1,
            2: fa_o1
        },
        536: {
            1: fa_n1,
            2: fa_o1
        },
        905: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        514: {
            1: fa_a2,
            2: fa_b2
        },
        516: {
            1: fa_a2,
            2: fa_b2
        },
        305: {
            1: fa_d1,
            2: fa_e1
        },
        315: {
            1: fa_d1,
            2: fa_e1
        },
        523: {
            1: fa_n1,
            2: fa_o1
        },
        299: {
            1: fa_d1,
            2: fa_e1
        },
        309: {
            1: fa_d1,
            2: fa_e1
        },
        697: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        298: {
            1: fa_d1,
            2: fa_e1
        },
        308: {
            1: fa_d1,
            2: fa_e1
        },
        515: {
            1: fa_a2,
            2: fa_b2
        },
        549: {
            1: fa_n1,
            2: fa_o1
        },
        548: {
            1: fa_n1,
            2: fa_o1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        550: {
            1: fa_b15,
            2: fa_b2
        },
        551: {
            1: fa_a2,
            2: fa_c15
        },
        455: {
            1: fa_b10,
            2: fa_c10
        },
        456: {
            1: fa_b10,
            2: fa_c10
        },
        457: {
            1: fa_b10,
            2: fa_c10
        },
        458: {
            1: fa_b10,
            2: fa_c10
        },
        459: {
            1: fa_b10,
            2: fa_c10
        },
        460: {
            1: fa_b10,
            2: fa_c10
        },
        512: {
            1: fa_b15,
            2: fa_b2
        },
        513: {
            1: fa_a2,
            2: fa_c15
        },
        901: {
            1: fa_u13,
            2: fa_v13,
            3: fa_w13,
            4: fa_x13,
            5: fa_y13,
            6: fa_z13,
            7: fa_a14,
            8: fa_b14
        },
        902: {
            1: fa_u13,
            2: fa_v13,
            3: fa_w13,
            4: fa_x13,
            5: fa_y13,
            6: fa_z13,
            7: fa_a14,
            8: fa_b14
        },
        340: {
            1: fa_d1,
            2: fa_e1
        },
        328: {
            1: fa_d1,
            2: fa_e1
        },
        329: {
            1: fa_d1,
            2: fa_e1
        },
        342: {
            1: fa_d1,
            2: fa_e1
        },
        330: {
            1: fa_d1,
            2: fa_e1
        },
        331: {
            1: fa_d1,
            2: fa_e1
        },
        722: {
            1: fa_w12,
            2: fa_d15,
            3: fa_x12
        },
        560: {
            1: fa_n1,
            2: fa_o1
        },
        543: {
            1: fa_n1,
            2: fa_o1
        },
        544: {
            1: fa_n1,
            2: fa_o1
        },
        545: {
            1: fa_n1,
            2: fa_o1
        },
        546: {
            1: fa_n1,
            2: fa_o1
        },
        332: {
            1: fa_d1,
            2: fa_e1
        },
        559: {
            1: fa_n1,
            2: fa_o1
        },
        296: {
            1: fa_d1,
            2: fa_e1
        },
        297: {
            1: fa_d1,
            2: fa_e1
        },
        717: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        718: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        719: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        720: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        721: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        552: {
            1: fa_b1,
            2: fa_c1
        },
        76: {
            1: fa_b1,
            2: fa_c1
        },
        77: {
            1: fa_b1,
            2: fa_c1
        },
        78: {
            1: fa_b1,
            2: fa_c1
        },
        79: {
            1: fa_b1,
            2: fa_c1
        },
        80: {
            1: fa_b1,
            2: fa_c1
        },
        647: {
            1: fa_a2,
            2: fa_b2
        },
        741: {
            1: fa_e15,
            2: fa_f15,
            3: fa_g15
        },
        82: {
            1: fa_b1,
            2: fa_c1
        },
        338: {
            1: fa_d1,
            2: fa_e1
        }
    },
    17: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    4: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_p1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        764: {
            1: fa_r1,
            2: fa_t1,
            3: fa_w1,
            4: fa_x1,
            5: fa_y1,
            6: fa_z1
        },
        102: {
            1: fa_h1,
            2: fa_i1
        },
        403: {
            1: fa_j1,
            2: fa_k1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_j1,
            2: fa_k1
        },
        367: {
            1: fa_j1,
            2: fa_k1
        },
        368: {
            1: fa_j1,
            2: fa_k1
        },
        369: {
            1: fa_j1,
            2: fa_k1
        },
        370: {
            1: fa_j1,
            2: fa_k1
        },
        566: {
            1: fa_a2,
            2: fa_b2
        },
        567: {
            1: fa_a2,
            2: fa_b2
        },
        568: {
            1: fa_a2,
            2: fa_b2
        },
        569: {
            1: fa_a2,
            2: fa_b2
        },
        570: {
            1: fa_a2,
            2: fa_b2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        923: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        924: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        925: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        926: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        927: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        929: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_l7
        },
        930: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_l7
        },
        931: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_l7
        },
        932: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_l7
        },
        933: {
            1: fa_v3,
            2: fa_m7,
            3: fa_n7,
            4: fa_o7,
            5: fa_l7
        },
        845: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        846: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        847: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        848: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        849: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_k1
        },
        918: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        919: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        920: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        921: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        922: {
            1: fa_w1,
            2: fa_t7,
            3: fa_s7,
            4: fa_j1
        },
        83: {
            1: fa_h1,
            2: fa_i1
        },
        84: {
            1: fa_h1,
            2: fa_i1
        },
        85: {
            1: fa_h1,
            2: fa_i1
        },
        86: {
            1: fa_h1,
            2: fa_i1
        },
        87: {
            1: fa_h1,
            2: fa_i1
        },
        905: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        906: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        907: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        908: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        909: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        807: {
            1: fa_w6,
            2: fa_y6,
            3: fa_c7,
            4: fa_e7
        },
        319: {
            1: fa_d1,
            2: fa_e1
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        912: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        913: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        914: {
            1: fa_h15,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        915: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        916: {
            1: fa_a8,
            2: fa_b8,
            3: fa_c8,
            4: fa_d8,
            5: fa_e8,
            6: fa_f8
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        362: {
            1: fa_j1,
            2: fa_k1
        },
        363: {
            1: fa_j1,
            2: fa_k1
        },
        364: {
            1: fa_j1,
            2: fa_k1
        },
        365: {
            1: fa_j1,
            2: fa_k1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        20: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        179: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_j1,
            2: fa_k1
        },
        359: {
            1: fa_j1,
            2: fa_k1
        },
        360: {
            1: fa_j1,
            2: fa_k1
        },
        361: {
            1: fa_j1,
            2: fa_k1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        16: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        175: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_a2,
            2: fa_b2
        },
        617: {
            1: fa_a2,
            2: fa_b2
        },
        618: {
            1: fa_a2,
            2: fa_b2
        },
        619: {
            1: fa_a2,
            2: fa_b2
        },
        620: {
            1: fa_a2,
            2: fa_b2
        },
        891: {
            1: fa_h2,
            2: fa_i2,
            3: fa_j2,
            4: fa_k2
        },
        26: {
            1: fa_i15,
            2: fa_j15
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        371: {
            1: fa_j1,
            2: fa_k1
        },
        571: {
            1: fa_a2,
            2: fa_b2
        },
        928: {
            1: fa_v3,
            2: fa_f7,
            3: fa_g7,
            4: fa_h7,
            5: fa_i7,
            6: fa_j7,
            7: fa_k7,
            8: fa_l7
        },
        934: {
            1: fa_v3,
            2: fa_k15,
            3: fa_l15,
            4: fa_m15,
            5: fa_l7
        },
        88: {
            1: fa_h1,
            2: fa_i1
        },
        910: {
            1: fa_u7,
            2: fa_v7,
            3: fa_w7,
            4: fa_x7
        },
        917: {
            1: fa_a8,
            2: fa_b8,
            3: fa_n15,
            4: fa_d8,
            5: fa_e8,
            6: fa_o15
        },
        936: {
            1: fa_n2,
            2: fa_o2,
            3: fa_p2,
            4: fa_q2,
            5: fa_r2,
            6: fa_s6
        }
    },
    8: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2
        },
        698: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        674: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        675: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        676: {
            1: fa_j1,
            2: fa_c2,
            3: fa_k1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    27: {
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    },
    28: {
        403: {
            1: fa_j1,
            2: fa_k1
        },
        615: {
            1: fa_a2,
            2: fa_b2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_h1,
            2: fa_i1
        },
        935: {
            1: fa_q10,
            2: fa_r10,
            3: fa_e14,
            4: fa_f14,
            5: fa_g14,
            6: fa_p15,
            7: fa_o10,
            8: fa_p10,
            9: fa_h3,
            10: fa_c14,
            11: fa_t7,
            12: fa_q15
        },
        612: {
            1: fa_n1,
            2: fa_o1
        },
        613: {
            1: fa_n1,
            2: fa_o1
        },
        443: {
            1: fa_l1,
            2: fa_m1
        },
        608: {
            1: fa_n1,
            2: fa_o1
        }
    }
};
var periodConfig = {
    2: {
        208: 'Матч аяқталды',
        207: 'Жетінші партия',
        206: 'Алтыншы партия',
        205: 'Бесінші партия',
        200: 'Матч әлі басталған жоқ',
        203: 'Үшінші партия',
        202: 'Екінші партия',
        201: 'Бірінші партия',
        204: 'Төртінші партия'
    },
    3: {
        304: 'Матч аяқталды',
        303: 'Үшінші сет',
        302: 'Екінші сет',
        301: 'Бірінші сет',
        300: 'Матч әлі басталған жоқ'
    },
    4: {
        406: 'Матч аяқталды',
        403: 'Үшінші сет',
        402: 'Екінші сет',
        401: 'Бірінші сет',
        400: 'Матч әлі басталған жоқ',
        407: 'Алтын сет',
        405: 'Бесінші сет',
        404: 'Төртінші сет'
    },
    5: {
        510: 'Оныншы раунд',
        509: 'Тоғызыншы раунд',
        508: 'Сегізінші раунд',
        507: 'Жетінші раунд',
        506: 'Алтыншы раунд',
        505: 'Бесінші раунд',
        513: 'Матч аяқталды',
        503: 'Үшінші раунд',
        500: 'Матч әлі басталған жоқ',
        501: 'Бірінші раунд',
        502: 'Екінші тур',
        511: 'Он бірінші раунд',
        512: 'Он екінші раунд',
        504: 'Төртінші раунд'
    },
    6: {
        600: 'Матч әлі басталған жоқ',
        601: 'Бірінші сет',
        602: 'Екінші сет',
        603: 'Үшінші сет',
        604: 'Төртінші сет',
        605: 'Бесінші сет',
        606: 'Матч аяқталды'
    },
    7: {
        701: 'Бірінші тайм',
        700: 'Матч әлі басталған жоқ',
        703: 'Екінші тайм',
        704: 'Негізгі уақыт аяқталды',
        705: 'Бірінші қосымша уақыт',
        702: 'Үзіліс',
        707: 'Екінші қосымша уақыт',
        708: 'Екінші қосымша уақыт аяқталады',
        709: 'Пенальти',
        710: 'Матч аяқталды',
        706: 'Бірінші қосымша уақыт аяқталады'
    },
    8: {
        808: 'Кідірту',
        807: 'Төртінші ширек',
        806: 'Кідірту',
        805: 'Үшінші ширек',
        804: 'Үзіліс',
        809: 'Овертайм',
        802: 'Кідірту',
        801: 'Бірінші ширек',
        800: 'Матч әлі басталған жоқ',
        810: 'Матч аяқталды',
        803: 'Екінші ширек'
    },
    9: {
        903: 'Екінші тайм',
        902: 'Үзіліс',
        901: 'Бірінші тайм',
        900: 'Матч әлі басталған жоқ',
        904: 'Матч аяқталды'
    },
    12: {
        1203: 'Екінші тайм',
        1202: 'Үзіліс',
        1201: 'Бірінші тайм',
        1200: 'Матч әлі басталған жоқ',
        1204: 'Матч аяқталды'
    },
    18: {
        1808: 'Овертайм аяқталады',
        1807: 'Овертайм',
        1806: 'Негізгі уақыт аяқталды',
        1805: 'Үшінші кезең',
        1804: 'Екінші үзіліс',
        1809: 'Пенальти',
        1802: 'Бірінші үзіліс',
        1801: 'Бірінші кезең',
        1800: 'Матч әлі басталған жоқ',
        1810: 'Матч аяқталды',
        1803: 'Екінші кезең'
    },
    19: {
        1904: 'Негізгі уақыт аяқталды',
        1903: 'Екінші тайм',
        1902: 'Үзіліс',
        1901: 'Бірінші тайм',
        1900: 'Матч әлі басталған жоқ',
        1905: 'Матч аяқталды'
    },
    20: {
        2016: 'Сегізінші атыс желісі',
        2017: 'Матч аяқталды',
        2000: 'Матч әлі басталған жоқ',
        2001: 'Бірінші тур',
        2002: 'Бірінші атыс сызығы',
        2003: 'Екінші тур',
        2004: 'Екінші атыс желісі',
        2005: 'Үшінші тур',
        2006: 'Үшінші атыс желісі',
        2007: 'Төртінші тур',
        2008: 'Төртінші атыс желісі',
        2009: 'Бесінші тур',
        2010: 'Бесінші атыс желісі',
        2011: 'Алтыншы тур',
        2012: 'Алтыншы атыс желісі',
        2013: 'Жетінші тур',
        2014: 'Жетінші атыс желісі',
        2015: 'Сегізінші тур'
    },
    28: {
        2801: 'Негізгі уақыт',
        2802: 'Матч аяқталды',
        2800: 'Матч әлі басталған жоқ'
    },
    29: {
        2911: '6-шы партия',
        2912: 'Үзіліс',
        2913: '7-ші партия',
        2914: 'Үзіліс',
        2915: '8-ші партия',
        2916: 'Үзіліс',
        2917: '9-шы партия',
        2918: 'Үзіліс',
        2919: '10-шы партия',
        2920: 'Үзіліс',
        2921: '11-ші партия',
        2964: 'Үзіліс',
        2965: '33-ші партия',
        2966: 'Үзіліс',
        2967: '34-ші партия',
        2968: 'Үзіліс',
        2969: '35-ші партия',
        2970: 'Үзіліс',
        2971: '36-шы партия',
        2972: 'Үзіліс',
        2973: '37-ші партия',
        2974: 'Матч аяқталды',
        2943: '22-ші партия',
        2944: 'Үзіліс',
        2945: '23-ші партия',
        2946: 'Үзіліс',
        2947: '24-ші партия',
        2948: 'Үзіліс',
        2949: '25-ші партия',
        2950: 'Үзіліс',
        2951: '26-шы партия',
        2952: 'Үзіліс',
        2953: '27-ші партия',
        2954: 'Үзіліс',
        2955: '28-ші партия',
        2956: 'Үзіліс',
        2957: '29-шы партия',
        2958: 'Үзіліс',
        2959: '30-шы партия',
        2960: 'Үзіліс',
        2961: '31-ші партия',
        2962: 'Үзіліс',
        2963: '32-ші партия',
        2922: 'Үзіліс',
        2923: '12-ші партия',
        2924: 'Үзіліс',
        2925: '13-ші партия',
        2926: 'Үзіліс',
        2927: '14-ші партия',
        2928: 'Үзіліс',
        2929: '15-ші партия',
        2930: 'Үзіліс',
        2931: '16-шы партия',
        2932: 'Үзіліс',
        2933: '17-ші партия',
        2934: 'Үзіліс',
        2935: '18-ші партия',
        2936: 'Үзіліс',
        2937: '19-шы партия',
        2938: 'Үзіліс',
        2939: '20-шы партия',
        2940: 'Үзіліс',
        2941: '21-ші партия',
        2942: 'Үзіліс',
        2900: 'Матч әлі басталған жоқ',
        2901: '1-ші партия',
        2902: 'Үзіліс',
        2903: '2-ші партия',
        2904: 'Үзіліс',
        2905: '3-ші партия',
        2906: 'Үзіліс',
        2907: '4-ші партия',
        2908: 'Үзіліс',
        2909: '5-ші партия',
        2910: 'Үзіліс'
    },
    30: {
        3008: 'Қосымша уақыт аяқталды',
        3007: 'Овертайм',
        3006: 'Негізгі уақыт аяқталды',
        3005: 'Үшінші кезең',
        3004: 'Екінші үзіліс',
        3009: 'Буллеттер',
        3002: 'Бірінші үзіліс',
        3001: 'Бірінші кезең',
        3000: 'Матч әлі басталған жоқ',
        3010: 'Матч аяқталды',
        3003: 'Екінші кезең'
    },
    31: {
        3108: 'Кідірту',
        3107: 'Төртінші ширек',
        3106: 'Кідірту',
        3105: 'Үшінші ширек',
        3104: 'Үзіліс',
        3109: 'Овертайм',
        3102: 'Кідірту',
        3101: 'Бірінші ширек',
        3100: 'Матч әлі басталған жоқ',
        3110: 'Матч аяқталды',
        3103: 'Екінші ширек'
    },
    32: {
        3203: 'Үшінші сет',
        3202: 'Екінші сет',
        3201: 'Бірінші сет',
        3200: 'Матч әлі басталған жоқ',
        3204: 'Матч аяқталды'
    },
    34: {
        3400: 'Матч әлі басталған жоқ',
        3401: 'Бірінші тайм',
        3402: 'Үзіліс',
        3403: 'Екінші тайм',
        3404: 'Негізгі уақыт аяқталды',
        3410: 'Матч аяқталды',
        3406: 'Бірінші қосымша уақыт аяқталады',
        3407: 'Екінші қосымша уақыт',
        3408: 'Екінші қосымша уақыт аяқталады',
        3409: 'Пенальти',
        3405: 'Бірінші қосымша уақыт'
    },
    35: {
        3500: 'Матч әлі басталған жоқ',
        3501: 'Бірінші тайм',
        3502: 'Үзіліс',
        3503: 'Екінші тайм',
        3504: 'Матч аяқталды'
    },
    36: {
        3601: 'Бірінші кезең',
        3602: 'Бірінші үзіліс',
        3603: 'Екінші кезең',
        3604: 'Екінші үзіліс',
        3605: 'Үшінші кезең',
        3600: 'Матч әлі басталған жоқ',
        3607: 'Овертайм',
        3608: 'Қосымша уақыт аяқталды',
        3609: 'Буллеттер',
        3610: 'Матч аяқталды',
        3606: 'Негізгі уақыт аяқталды'
    },
    37: {
        3701: 'Матч аяқталды',
        3700: 'Матч әлі басталған жоқ'
    },
    38: {
        3801: 'Матч аяқталды',
        3800: 'Матч әлі басталған жоқ'
    },
    39: {
        3901: 'Матч аяқталды',
        3900: 'Матч әлі басталған жоқ',
        3902: 'Бірінші раунд',
        3903: 'Екінші тур',
        3904: 'Үшінші раунд',
        3905: 'Төртінші раунд',
        3906: 'Бесінші раунд',
    },
    40: {
        4001: 'Матч аяқталды',
        4000: 'Матч әлі басталған жоқ'
    },
    41: {
        4102: 'Бірінші үзіліс',
        4106: 'Матч аяқталды',
        4105: 'Овертайм',
        4104: 'Екінші үзіліс',
        4103: 'Екінші жартылық',
        4101: 'Бірінші жартылық',
        4100: 'Матч әлі басталған жоқ'
    },
    42: {
        4202: 'Екінші карта',
        4206: 'Матч аяқталды',
        4205: 'Бесінші карта',
        4204: 'Төртінші карта',
        4203: 'Үшінші карта',
        4201: 'Бірінші карта',
        4200: 'Матч әлі басталған жоқ'
    }
};
export function getOutcomeName(sportId, outcome, match) {
    var func;
    if (baseOutcomeConfig !== undefined &&
        baseOutcomeConfig[sportId] !== undefined &&
        baseOutcomeConfig[sportId]) {
        func = baseOutcomeConfig[sportId][outcome.type];
    }
    if (outcomeConfig !== undefined &&
        outcomeConfig[sportId] !== undefined &&
        outcomeConfig[sportId][outcome.type] !== undefined) {
        func = outcomeConfig[sportId][outcome.type];
    }
    if (func === undefined) {
        return undefined;
    }
    return func(match, outcome);
}
export function getRateName(sportId, outcome, factorType, match) {
    var func;
    if (baseFactorNameConfig !== undefined &&
        baseFactorNameConfig[sportId] !== undefined &&
        baseFactorNameConfig[sportId][outcome.type] !== undefined) {
        func = baseFactorNameConfig[sportId][outcome.type][factorType];
    }
    if (func === undefined) {
        return undefined;
    }
    return func(match, outcome);
}
export function getPeriodName(sportId, periodId) {
    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
        return periodConfig[sportId][periodId];
    }
    return undefined;
}



// WEBPACK FOOTER //
// ./src/localization/kk.js